export const fr = {
    translation: {
        sidebar: {
            favorites: 'Favoris',
            all_tabs: 'Tous les onglets',
            add_to_favorites: 'Ajouter aux favoris',
            remove_from_favorites: 'Retirer des favoris',
            focused: 'Favoris',
            full: 'Tous les onglets',
            empty_favorites: 'Marquez des pages pour les ajouter ici',
            switch_to_full: 'Parcourir tous les onglets',
            reorder: 'Réorganiser',
            groups: {
                organization: 'Organisation',
                users: 'Utilisateurs',
                content: 'Contenu',
                commerce: 'Commerce',
                data: 'Données',
                system: 'Système',
            },
        },
        tabs: {
            locations: 'Clubs',
            dashboard: 'Dashboard',
            users: 'Utilisateurs',
            memberships: 'Types d\'adhésion',
            courts: 'Terrains',
            access_codes: "Codes d'accès",
            access_control: "Contrôle d'accès",
            events: 'Événements',
            organizations: 'Organizations',
            availability: 'disponibilité',
            analytics: 'Analytics',
            settings: 'Paramètres',
            calendar: 'Calendrier',
            coachs: 'Coachs',
            pricing: 'Tarification',
            court_pricing: 'Tarification des terrains',
            coach_pricing: 'Tarification des coachs',
            game_durations: 'Durées de Match',
            organization: 'Enterprise',
            time_windows: 'Créneaux Horaires',
            products: 'Produits',
            games: 'Parties',
            articles: 'Articles',
            sponsors: 'Sponsors',
            support: 'Support',
            transactions: 'Transactions',
            notifications: 'Notifications',
            pricing_insights: 'Conseiller Tarifaire',
            video_reviews: 'Revues Vidéo',
            churn_prediction: 'Prédiction d\'attrition',
            court_recording: 'Enregistrement Terrain',
            venue_agents: 'Agents de site',
            whatsapp_conversations: 'WhatsApp',
            impact: 'Impact',
            nextore: 'Nextore',
            venue_display: 'Affichage Club',
        },
        organization: {
            stripe_setup: "Configuration de Stripe",
            name: "Dénomination Sociale",
            company_search_placeholder: "Recherchez votre entreprise...",
            company_search_helper: "Commencez à taper pour rechercher dans le répertoire des entreprises françaises.",
            company_search_loading: "Recherche...",
            company_search_no_results: "Aucune entreprise trouvée",
            company_use: "Utiliser",
            organization_id: "ID de l'organisation",
            stripe_account_id: "ID du compte Stripe",
            create_organization: "Valider",
            select_organization: "Sélectionner l'entreprise",
            email: "Email",
            joined_at: "Date d'inscription",
            sent_at: "Envoyé le",
            invitation_status: "Statut",
            invitation_expired: "Expirée — révoquez puis réinvitez",
            invitation_pending: "En attente",
            members: "Membres",
            invite: "Inviter",
            invite_new_member: "Inviter un nouveau membre",
            invite_success: "Invitation envoyée avec succès",
            add_member: "Ajouter un membre",
            add_member_title: "Ajouter un administrateur",
            add_member_description: "Le membre est ajouté immédiatement. S'il n'a pas encore de compte, il rejoindra l'organisation dès qu'il s'inscrira avec cette adresse e-mail.",
            add_member_success: "Membre ajouté avec succès",
            force_add_section: "Options superadmin",
            force_add_notify: "Envoyer un e-mail « vous avez été ajouté »",
            force_add_silent_help: "Aucun e-mail ne sera envoyé : transmettez-lui vous-même le lien d'inscription — {url} — il crée son compte avec cette adresse et retrouve le club. D'ici là, quiconque s'inscrit avec cette adresse obtient cet accès : ajoutez-le peu avant qu'il s'inscrive.",
            new_organization: "Nouvelle organisation",
            invitations: "Invitations",
            select_location: "Sélectionnez un club",
            refund_time_limit: "Modalités de remboursement",
            set_refund_time_limit: "Définir le délai de remboursement",
            set_refund_time_limit_description: "Exemple, 36 signifie que les matchs annulés 36 heures à l'avance seront remboursés. Les matchs annulés ou créés après ce délai ne seront pas remboursés.",
            cancellation_messages: "Messages d'annulation (mobile)",
            cancellation_messages_description: "Personnalisez ce que voient les joueurs quand ils annulent. Laissez vide pour utiliser le message par défaut. Utilisez {{hours}} pour insérer automatiquement le délai en heures.",
            cancellation_message_within: "Message si l'annulation est dans le délai",
            cancellation_message_outside: "Message si l'annulation est hors délai",
            cancellation_message_within_placeholder: "Ex : Vous êtes dans le délai ({{hours}}h). Vous serez remboursé automatiquement.",
            cancellation_message_outside_placeholder: "Ex : Hors délai ({{hours}}h). Appelez-moi au 06 12 34 56 78 — j'essaierai de remplir votre créneau.",
            set_cancellation_messages: "Modifier les messages d'annulation",
            booking_payment_deadline: "Délai d'expiration du paiement",
            booking_payment_deadline_helper: "Délai avant que le lien de paiement Stripe expire et libère le créneau. Défaut : 30 minutes.",
            booking_payment_deadline_description: "Définir en minutes (entre 5 et 1430). S'applique aux liens de paiement Stripe envoyés depuis le dashboard pour les réservations administrateur.",
            set_booking_payment_deadline: "Définir le délai d'expiration",
            booking_payment_deadline_saved: "Délai d'expiration enregistré",
            pay_for_others_title: "Payer pour d'autres joueurs",
            pay_for_others_helper: "Permet aux utilisateurs de payer pour d'autres joueurs lors de la réservation. Masque le sélecteur multi-joueurs.",
            pay_for_others_saved: "Paramètre enregistré",
            pay_for_others_daily_cap_label: "Limite quotidienne",
            pay_for_others_daily_cap_helper: "Nombre max de joueurs distincts qu'un utilisateur peut couvrir par 24 h glissantes (1–50). Garde-fou anti-abus ; à augmenter pour les événements d'équipe.",
            pay_for_others_daily_cap_invalid: "Saisissez un nombre entier entre 1 et 50",
            guest_players_label: 'Joueurs invités',
            guest_players_helper: 'Permet à un joueur de payer pour quelqu\'un sans compte (un enfant, un ami de passage). Les invités sont ajoutés par leur nom, uniquement sur des parties non classées ; leur niveau est déclaré par l\'hôte.',
            guests_per_game_label: 'Invités max par partie',
            guests_per_game_helper: 'Nombre de places sans compte qu\'une partie peut contenir (1–10).',
            guests_per_game_invalid: 'Saisissez un nombre entier entre 1 et 10',
            pay_for_others_consent_label: 'Les joueurs doivent accepter une place payée',
            pay_for_others_consent_helper: 'Quand quelqu\'un paie pour un autre joueur, ce joueur doit accepter la place. Une place refusée ou sans réponse (24 h, ou 2 h avant le match) est libérée et le payeur remboursé.',
            chat_backend_title: "Backend de chat (admin plateforme)",
            chat_backend_inhouse_label: "Utiliser le chat interne",
            chat_backend_helper: "Bascule le chat mobile de cette organisation entre GetStream et le backend interne. Les utilisateurs voient le changement au prochain démarrage de l'application (jusqu'à 1 heure). L'historique des messages n'est pas transféré entre les backends — suivez le runbook de bascule (backfill + vérifications de parité) avant de basculer.",
            chat_backend_saved: "Backend de chat enregistré",
            chat_backend_confirm_title: "Basculer le backend de chat ?",
            chat_backend_confirm_body: "Cela remplace le chat pour tous les utilisateurs de cette organisation. Les messages envoyés sur un backend ne sont pas visibles sur l'autre. Avez-vous exécuté le backfill et les vérifications de parité du runbook ?",
            chat_backend_confirm_cancel: "Annuler",
            chat_backend_confirm_action: "Basculer",
            recording_retention_title: "Conservation des vidéos",
            recording_retention_current: "Vidéos conservées {days} jours après le match",
            recording_retention_is_default: "(valeur par défaut de la plateforme)",
            recording_retention_is_custom: "(définie pour cette organisation)",
            recording_retention_helper: "Passé ce délai, la vidéo et son analyse sont supprimées automatiquement et les joueurs voient l'enregistrement comme expiré. Le décompte démarre quand l'enregistrement est prêt, pas à la réservation.",
            recording_retention_read_only: "Seul MySportSet peut modifier ce réglage.",
            recording_retention_edit: "Modifier la conservation",
            recording_retention_range: "Nombre entier de jours, entre 1 et {max}.",
            recording_retention_use_default: "Utiliser la valeur par défaut de la plateforme",
            recording_retention_days_label: "jours",
            recording_retention_lowering_warning: "Réduire ce délai supprime les enregistrements plus anciens au prochain passage horaire, de façon irréversible.",
            recording_retention_confirm_title: "Supprimer les enregistrements plus anciens ?",
            recording_retention_confirm_action: "Réduire la conservation",
            recording_retention_saved: "Conservation des vidéos enregistrée",
            coaching_pay_later_title: "Coaching — Payer plus tard",
            coaching_pay_later_helper: "Permet aux joueurs de différer le paiement des sessions de coaching (débité plus tard sur une carte enregistrée). Désactiver masque l'option Payer plus tard dans la réservation de coach.",
            coaching_pay_later_saved: "Paramètre enregistré",
            court_pay_later_title: "Réservation de court — Payer plus tard",
            court_pay_later_helper: "Permet aux joueurs de différer le paiement des réservations de court (débité plus tard sur une carte enregistrée). Désactiver masque l'option Payer plus tard dans la réservation et refuse tout paiement différé, y compris depuis les anciennes versions de l'application.",
            court_pay_later_saved: "Paramètre enregistré",
            admin_notification_emails_title: "Notifications par e-mail",
            admin_notification_emails_helper: "Adresses qui reçoivent un e-mail à chaque réservation, annulation ou échec de paiement. Laisse la liste vide pour désactiver les e-mails — ces événements restent visibles dans la cloche de notifications dans tous les cas.",
            admin_notification_emails_empty: "Aucun destinataire — les e-mails sont désactivés.",
            admin_notification_emails_add: "Ajouter un destinataire",
            admin_notification_emails_saved: "Destinataires enregistrés",
            admin_notification_emails_invalid: "Adresse e-mail invalide : {{email}}",
            signup_document_upload_title: "Document d'inscription",
            signup_document_upload_helper: "Permet de demander un document (carte étudiante, etc.) lors de l'inscription des joueurs.",
            signup_document_upload_saved: "Paramètre enregistré",
            signup_document_upload_title_label: "Titre",
            signup_document_upload_title_placeholder: "Ex : Carte étudiante",
            signup_document_upload_subtitle_label: "Sous-titre",
            signup_document_upload_subtitle_placeholder: "Ex : Veuillez télécharger votre carte étudiante",
            signup_document_upload_save_texts: "Enregistrer",
            signup_document_upload_required_label: "Obligatoire pour finaliser l'inscription",
            signup_document_upload_required_helper: "Si activé, les joueurs doivent téléverser le document pour terminer leur inscription. Sinon, l'envoi est proposé mais peut être ignoré.",
            document_verification_section_title: "Vérification automatique",
            document_verification_section_helper: "Les documents téléversés sont vérifiés par IA en environ 5 minutes. En cas de correspondance, l'abonnement choisi est assigné automatiquement ; les cas ambigus passent en file d'attente pour examen.",
            document_verification_toggle_label: "Activer la vérification automatique",
            document_verification_membership_label: "Abonnement à assigner après vérification",
            document_verification_membership_placeholder: "Choisir un type d'abonnement",
            document_verification_custom_prompt_label: "Instructions de vérification personnalisées (facultatif)",
            document_verification_custom_prompt_placeholder: "ex : « Doit être une carte universitaire française émise au cours des 12 derniers mois »",
            document_verification_save: "Enregistrer les paramètres",
            document_verification_saved: "Paramètres de vérification enregistrés",
            document_verification_missing_membership: "Sélectionnez un type d'abonnement avant d'activer la vérification automatique",
            document_status_pending: "En attente",
            document_status_verified: "Vérifié",
            document_status_rejected: "Refusé",
            document_status_needs_review: "À examiner",
            verification_status_label: "Statut de vérification :",
            verification_not_run: "La vérification n'a pas encore été lancée.",
            verification_reason_label: "Motif :",
            verification_acted_by: "Effectué par",
            verification_auto_assigned_membership: "Abonnement attribué automatiquement :",
            verification_first_name: "Prénom",
            verification_last_name: "Nom",
            verification_document_type: "Type de document",
            verification_expiry: "Expiration",
            verification_institution: "Établissement",
            verification_unique_id: "Identifiant unique",
            verification_genuine_confidence: "Confiance d'authenticité",
            verification_photo_of_screen: "Photo d'écran ?",
            verification_yes: "Oui",
            verification_no: "Non",
            verification_not_extracted: "non extrait",
            verification_match_label: "correspondance",
            verification_vs: "vs",
            verification_approve: "Approuver",
            verification_reject: "Refuser",
            verification_approved_toast: "Document approuvé",
            verification_rejected_toast: "Document refusé",
            verification_approve_failed_toast: "Échec de l'approbation du document",
            verification_reject_failed_toast: "Échec du refus du document",
            verification_reject_reason_placeholder: "Motif facultatif — montré à l'utilisateur (ex. carte expirée, photo floue)",
            game_booking_code_title: "Code d'accès",
            game_booking_code_helper: "Active le module Code d'accès pour cette organisation. Les administrateurs pourront configurer des codes par terrain, visibles par les joueurs avant leur créneau.",
            game_booking_code_saved: "Paramètre enregistré",
            id: 'Identifiant',
            last_minute_discount: "Remise de dernière minute",
            discount_percentage: "Pourcentage de remise (%)",
            discount_duration: "Appliquer la remise dans les (heures)",
            set_discount_settings: "Mettre à jour les paramètres de remise",
            discount_settings_description: "Définir un pourcentage de remise qui s'applique lorsque les utilisateurs réservent un terrain dans la fenêtre de temps spécifiée avant le début du match.",
            whatsapp_links: "Liens WhatsApp",
            whatsapp_links_description: "Gérer les liens de groupes WhatsApp organisés par niveaux de compétence pour les membres de votre organisation.",
            add_whatsapp_link: "Ajouter un Lien",
            edit_whatsapp_link: "Modifier le Lien",
            link_title: "Titre",
            link_description: "Description",
            link_url: "URL",
            delete_link: "Supprimer",
            save_links: "Enregistrer les Liens",
            no_links_configured: "Aucun lien WhatsApp configuré",
            table_title: "Titre",
            table_description: "Description",
            table_url: "URL",
            table_actions: "Actions",
            whatsapp_config_title: "Réservation IA WhatsApp",
            whatsapp_config_description: "Configurer l'intégration de l'API WhatsApp Business pour la réservation de terrains par IA.",
            whatsapp_config_enable: "Activer la réservation IA WhatsApp",
            whatsapp_config_phone_number_id: "ID du numéro de téléphone",
            whatsapp_config_business_account_id: "ID du compte professionnel",
            whatsapp_replacement_notify_phone: "Numéro de notification remplacement",
            whatsapp_replacement_notify_phone_hint: "Numéro de téléphone (format E.164) pour recevoir les notifications WhatsApp lorsqu'un lien de remplacement est créé.",
            whatsapp_config_access_token: "Jeton d'accès",
            whatsapp_config_token_configured: "Jeton configuré",
            whatsapp_config_click_to_change: "Cliquez pour modifier.",
            whatsapp_config_enter_token: "Saisir le jeton d'accès",
            whatsapp_config_saved: "Configuration WhatsApp enregistrée",
            whapi_section_title: "Notifications de groupe Whapi",
            whapi_section_description: "Publier automatiquement les liens de remplacement dans un groupe WhatsApp via Whapi.cloud quand un joueur annule ou quitte un match.",
            whapi_api_token: "Jeton API Whapi",
            whapi_api_token_enter: "Saisir le jeton API Whapi",
            whapi_api_token_configured: "Jeton configuré",
            whapi_group_id: "ID du groupe WhatsApp",
            whapi_group_id_hint: "JID du groupe WhatsApp (ex : 120363001234567890@g.us). Disponible dans votre tableau de bord Whapi.cloud.",
            whapi_group_id_select: "Sélectionner un groupe",
            whapi_load_groups: "Charger les groupes",
            whapi_groups_error: "Impossible de charger les groupes. Vérifiez votre jeton API Whapi.",
            whapi_groups_title: "Groupes WhatsApp",
            whapi_groups_description: "Créer et gérer des groupes WhatsApp via Whapi.cloud. Lister les groupes, en créer de nouveaux et obtenir les liens d'invitation.",
            whapi_groups_create: "Créer un groupe",
            whapi_groups_create_name: "Nom du groupe",
            whapi_groups_create_name_placeholder: "ex : MySportSet - Padel Paris",
            whapi_groups_create_participants: "Participants (optionnel)",
            whapi_groups_create_participants_placeholder: "Numéros de téléphone séparés par des virgules (ex : 33612345678,33698765432)",
            whapi_groups_create_success: "Groupe créé avec succès !",
            whapi_groups_create_error: "Impossible de créer le groupe.",
            whapi_groups_invite_link: "Lien d'invitation",
            whapi_groups_invite_link_copied: "Lien d'invitation copié !",
            whapi_groups_invite_link_error: "Impossible d'obtenir le lien d'invitation.",
            whapi_groups_no_token: "Configurez un jeton API Whapi dans la config WhatsApp pour gérer les groupes.",
            whapi_groups_empty: "Aucun groupe trouvé.",
            whapi_groups_members: "membres",
            whapi_groups_get_link: "Obtenir le lien",
            whapi_groups_copy_link: "Copier",
            elo_settings: "Paramètres ELO",
            elo_k_factor: "Facteur K",
            elo_k_factor_desc: "Combien de points de niveau un match rapporte. Une valeur élevée signifie que chaque match a un plus grand impact sur le niveau des joueurs.",
            elo_scaling_factor: "Facteur d'échelle",
            elo_scaling_factor_desc: "Sensibilité du système aux écarts de niveau. Une valeur basse signifie qu'un petit écart de niveau favorisera fortement le joueur mieux classé.",
            elo_margin_of_victory: "Marge de victoire",
            elo_margin_of_victory_desc: "Lorsqu'activé, une victoire dominante (ex: 6-0) change le niveau davantage qu'une victoire serrée (ex: 7-6).",
            elo_max_adjustment: "Ajustement max par match",
            elo_max_adjustment_desc_before: "Un joueur ne peut ni gagner plus de",
            elo_max_adjustment_desc_mid: "niveaux, ni perdre plus de",
            elo_max_adjustment_desc_after: "niveaux, en un seul match.",
            elo_edit_settings: "Modifier les paramètres ELO",
            elo_settings_updated: "Paramètres ELO mis à jour avec succès",
            elo_reset_defaults: "Réinitialiser par défaut",
            elo_simulator_title: "Exemples en direct",
            elo_scenario: "Scénario",
            elo_winner_gets: "Gagnant reçoit",
            elo_loser_gets: "Perdant reçoit",
            elo_scenario_equal_win: "5.0 vs 5.0 (égal)",
            elo_scenario_upset_win: "3.0 vs 7.0 (surprise)",
            elo_scenario_expected_win: "7.0 vs 3.0 (attendu)",
            elo_scenario_equal_draw: "5.0 vs 5.0 (nul)",
            elo_scenario_upset_draw: "3.0 vs 7.0 (nul)",
            elo_custom_title: "Essayez votre propre scénario",
            elo_player_level: "Niveau du joueur",
            elo_opponent_level: "Niveau de l'adversaire",
            elo_sets: "Sets",
            elo_add_set: "Ajouter un set",
            elo_result_if_win: "Si le joueur gagne",
            elo_result_if_loss: "Si le joueur perd",
            elo_result_if_draw: "Si nul",
            elo_formula_title: "Formule",
            elo_formula_expected: "Score attendu",
            elo_formula_adjustment: "Ajustement",
            elo_formula_margin: "Multiplicateur de marge",
            elo_formula_clamped: "Plafonné",
            campaign_frequency_cap: "Limite de fréquence des campagnes",
            campaign_frequency_cap_description: "Nombre maximum de messages de campagne qu'un utilisateur peut recevoir par semaine. Mettez 0 pour aucune limite.",
            campaign_frequency_cap_per_week: "messages par semaine",
            campaign_frequency_cap_no_limit: "Aucune limite",
            campaign_frequency_cap_updated: "Limite de fréquence des campagnes mise à jour",
        },
        game_durations: {
            title: 'Durées de Match',
            add_duration: 'Ajouter une Durée',
            create_duration: 'Créer une Durée de Match',
            edit_duration: 'Modifier la Durée de Match',
            delete_duration: 'Supprimer la Durée',
            sport: 'Sport',
            duration_minutes: 'Minutes',
            save: 'Sauvegarder',
            cancel: 'Annuler',
            delete: 'Supprimer',
            confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette durée de match ?',
            no_durations: 'Aucune durée de match configurée',
            duration_exists: 'Cette durée existe déjà pour ce sport',
            duration_created: 'Durée de match créée avec succès',
            duration_updated: 'Durée de match mise à jour avec succès',
            duration_deleted: 'Durée de match supprimée avec succès',
            unpriced_duration:
                'Aucun terrain n\'a de tarif pour les créneaux de {{duration}} minutes dans ce sport, et contrairement aux capacités il n\'existe pas de tarif universel pour les durées. Les joueurs dont le sélecteur de durée tombe sur {{duration}} minutes verront une grille de réservation vide pour ce sport. Ajoute des tarifs pour les créneaux de {{duration}} minutes dans la gestion des tarifs, ou supprime cette durée.',
            stranded_pricing_rows:
                '{{count}} tarif(s) étaient configurés pour la durée que tu viens de retirer et ne peuvent plus être vendus. Rattache-les à une durée encore proposée, ou supprime-les.',
            filter_by_sport: 'Filtrer par sport',
            all_sports: 'Tous les Sports',
            error: 'Erreur',
            error_creating: 'Échec de la création de la durée de match',
            error_updating: 'Échec de la mise à jour de la durée de match',
            error_deleting: 'Échec de la suppression de la durée de match',
            invalid_duration: 'Veuillez entrer une durée valide entre 1 et 480 minutes',
            error_loading: 'Erreur lors du chargement des durées de match. Veuillez réessayer.',
            select_organization: 'Veuillez d\'abord sélectionner une organisation.',
        },
        game_capacity_options: {
            title: 'Options de Capacité de Match',
            add_capacity_option: 'Ajouter une Option de Capacité',
            create_capacity_option: 'Créer une Option de Capacité',
            edit_capacity_option: 'Modifier l\'Option de Capacité',
            delete_capacity_option: 'Supprimer l\'Option de Capacité',
            sport: 'Sport',
            capacity: 'Capacité',
            players: 'joueurs',
            save: 'Sauvegarder',
            cancel: 'Annuler',
            delete: 'Supprimer',
            default: 'Par défaut',
            set_as_default: 'Définir par défaut',
            default_capacity_help: 'Laisser vide pour la capacité par défaut, ou spécifier une capacité personnalisée',
            confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette option de capacité ?',
            no_capacity_options: 'Aucune option de capacité configurée',
            capacity_option_exists: 'Cette option de capacité existe déjà pour ce sport',
            capacity_option_created: 'Option de capacité créée avec succès',
            capacity_option_updated: 'Option de capacité mise à jour avec succès',
            capacity_option_deleted: 'Option de capacité supprimée avec succès',
            stranded_pricing_rows:
                '{{count}} tarif(s) étaient configurés pour cette capacité et ne peuvent plus être vendus. Les terrains tarifés uniquement à cette capacité ne sont plus réservables pour ce sport — modifie ou supprime ces tarifs.',
            retired_capacities:
                'La capacité {{capacities}} n\'est plus acceptée pour ce sport. Les versions de l\'application antérieures au sélecteur de capacité réservent toujours à {{capacities}} : ces réservations seront désormais refusées au paiement — ajoute aussi {{capacities}} comme option de capacité si ces versions sont encore utilisées.',
            unpriced_capacities:
                'La capacité {{capacities}} est réservable mais aucun terrain n\'a de tarif pour elle : la réservation est acceptée puis échoue au calcul du prix. Ajoute un tarif pour {{capacities}} dans la gestion des tarifs, ou un tarif valable pour toutes les capacités.',
            error_creating: 'Échec de la création de l\'option de capacité',
            error_updating: 'Échec de la mise à jour de l\'option de capacité',
            error_deleting: 'Échec de la suppression de l\'option de capacité',
            error: 'Erreur',
            select_organization: 'Veuillez d\'abord sélectionner une organisation.',
            error_loading: 'Erreur lors du chargement des options de capacité. Veuillez réessayer.',
            filter_by_sport: 'Filtrer par sport',
            all_sports: 'Tous les Sports',
            no_default_warning: "Aucune capacité par défaut n'est définie pour ce sport : l'application en présélectionne une à votre place. Marquez celle que les joueurs doivent voir en premier.",
            unbookable_warning: 'La capacité {{capacities}} ne peut pas être réservée (le maximum est {{max}}) : les joueurs ne la voient jamais. Modifiez-la ou supprimez-la.',
        },
        locations: {
            card_header: "Centre",
            details: 'Détails',
            add_new_location: 'Créer un club',
            name: 'Nom du Club',
            address: 'Adresse',
            city: 'Ville',
            postal_code: 'Code Postal',
            country: 'Pays',
            latitude: 'Latitude',
            longitude: 'Longitude',
            sports: 'Sports',
            state: 'Province',
            googleMapsLink: 'Lien Google Maps',
            latitude_must_be_number: 'La latitude doit être un nombre',
            longitude_must_be_number: 'La longitude doit être un nombre',
            name_cannot_be_empty: 'Le nom ne peut pas être vide',
            sports_cannot_be_empty: 'Vous devez sélectionner au moins un sport',
            location_edited_successfully: ' Le club a été modifié avec succès',
            no_locations: 'Aucun club pour le moment. Créez votre premier club pour commencer.',
            error_loading: 'Erreur lors du chargement des clubs. Veuillez réessayer.',
            country_france: 'France',
            country_uae: 'Émirats arabes unis',
        },
        cgu: {
            title: "Conditions d'utilisation (CGU)",
            description: "Ces conditions sont affichées aux utilisateurs avant l'achat ou la souscription d'une adhésion.",
            not_configured: 'non configuré',
            editor_placeholder: 'Rédigez vos conditions ici. Utilisez # pour les titres, ** pour le gras, * pour l\'italique, - pour les listes.',
            editor_hint: 'Utilisez Markdown pour la mise en forme. Barre d\'outils ci-dessus. Aperçu en direct à droite.',
            removed: 'Conditions retirées',
            remove: 'Retirer les CGU',
            empty_save_blocked: 'Le contenu vide ne peut pas être enregistré. Utilisez "Retirer les CGU" pour désactiver l\'enforcement.',
            drift_title: 'Types d\'adhésion avec conditions personnalisées',
            drift_body: '{count} type(s) d\'adhésion ont leurs propres conditions personnalisées et NE recevront PAS cette mise à jour. Vérifiez-les après l\'enregistrement.',
            drift_hint: 'Les acceptations existantes des abonnés sont préservées sans changement.',
            save_anyway: 'Enregistrer quand même',
            remove_title: 'Retirer les CGU ?',
            remove_body: 'Désactive l\'affichage des CGU pour tous les nouveaux abonnés de cette organisation. Les snapshots acceptés existants sont préservés.',
            remove_hint: 'Vous voulez probablement modifier le texte plutôt que le retirer. Retirer est rare.',
            edit_instead: 'Modifier le texte plutôt',
            confirm_remove: 'Confirmer la suppression',
            override_title: 'Utiliser des CGU personnalisées pour cette adhésion',
            override_description: 'Remplace les CGU de l\'organisation par des conditions spécifiques au type. Typiquement utilisé lorsque ce niveau a une durée de reconduction, un engagement ou une politique de remboursement différents.',
            override_edit_hint: 'Modification de la surcharge actuelle. L\'enregistrement remplace le texte en place.',
            override_prefill_hint: 'Pré-rempli avec une copie des CGU de l\'organisation. Ajustez les clauses spécifiques qui diffèrent.',
            override_cleared: 'Surcharge supprimée',
            override_clear_title: 'Supprimer les CGU personnalisées ?',
            override_clear_body: 'Cette adhésion reprendra les CGU de l\'organisation pour les nouveaux abonnés. Les acceptations existantes sont préservées.',
            override_clear_hint: 'Vous pouvez réactiver et modifier à nouveau plus tard ; le compteur de version ne se remet pas à zéro.',
            override_clear_confirm: 'Supprimer la surcharge',
        },
        userMembership: {
            memberships: 'Types d\'adhésions',
            startDate: 'Date de début',
            endDate: 'Date de fin',
            is_active: 'Activé',
            add_new_membership: 'Ajouter une nouvelle adhésion',
            edit_new_membership: 'Modifier adhésion',
            add_new_membership_type: 'Créer un type d\'adhésion',
            edit_membership_type: 'Modifier type d\'adhésion',
            delete_membership_type: 'Supprimer le type d\'adhésion',
            delete_membership_type_confirmation: 'Le type d\'adhésion sera supprimé : les adhérents perdent immédiatement ses avantages et les abonnements en cours sont annulés. Cette action est irréversible.',
            delete_membership_confirmation: 'L\'adhésion sera retirée au joueur, qui perd immédiatement ses avantages. Un éventuel abonnement en cours est annulé. Cette action est irréversible.',
            sports_label: 'Sports',
            sports_all_hint: 'Aucun sport sélectionné = valable pour tous les sports',
            sports_all: 'Tous les sports',
            sport_discounts_label: 'Remises par sport',
            sport_discounts_hint: 'Les sports sans remise spécifique utilisent la remise par défaut. Une remise par sport prime sur les remises par plage horaire.',
            sport_discounts_add: 'Ajouter une remise par sport',
            assign_membership: 'Affecter un type d\'adhésion',
            // MYS-117 Abonnement Duo
            duo_section_title: 'Adhésion Duo',
            duo_plan_label: 'Formule Duo',
            duo_plan_solo: 'Solo (1 joueur)',
            duo_plan_duo: 'Duo (2 joueurs)',
            duo_plan_hint: '1 payeur, 2 bénéficiaires : le prix couvre les deux joueurs et les deux perdent l\'accès si le paiement s\'arrête. Nécessite un abonnement actif.',
            duo_badge_payer: 'Duo · payeur',
            duo_badge_beneficiary: 'Duo · rattaché',
            duo_attached: 'Rattaché :',
            duo_no_attached: 'Aucun joueur rattaché — 1 place disponible',
            duo_attach_cta: 'Rattacher un joueur',
            duo_change: 'Changer',
            duo_remove: 'Retirer',
            duo_attach_modal_title: 'Rattacher un joueur — {name}',
            duo_attach_success: 'Joueur rattaché',
            duo_detach_confirm_title: 'Retirer le joueur rattaché ?',
            duo_detach_confirm_body: '{name} perdra immédiatement ses avantages d\'adhésion.',
            duo_already_covered: 'Ce joueur a déjà une adhésion active de ce type.',
            duo_throttle_error: 'Le rattachement a déjà été modifié cette période de facturation. Cochez le forçage admin pour passer outre.',
            duo_throttle_override_label: 'Forçage admin — le rattachement a déjà été modifié cette période',
            duo_grace_badge: 'paiement en échec — actif jusqu\'au {date}, les 2 joueurs concernés',
            duo_changed_by_club: 'modifié par le club le {date}',
            duo_search_empty: 'Aucun joueur trouvé pour « {query} »',
            duo_paid_by: 'payée par {name}',
            invalidDate: 'Date invalide',
            invalid_start_date: 'Date invalide',
            invalid_end_date: 'Date de fin doit être supérieur à la date début',
            active: 'Actif',
            inactive: 'Désactivé',
            expired: "Expiré",
            subscriptions: 'Abonnements',
            latest_membership: 'Dernière Adhésion',
            latest_subscription: 'Dernier Abonnement',
            users_with_memberships_title: 'Abonnés',
            search_placeholder: 'Rechercher par nom ou email...',
            error_loading: 'Erreur lors du chargement des données. Veuillez réessayer.',
            no_users_found: 'Aucun utilisateur avec adhésions ou abonnements trouvé.',
            active_count: 'actif',
            not_available: 'N/A',
            status: 'État',
            invalid_membership_type_name: 'Le titre ne peut pas être vide',
            name: 'Titre',
            membershipType: 'Type d\'adhésion',
            select_membership_type: 'Sélectionnez un type d\'adhésion',
            invalid_membership_type: 'Vous devez sélectionner un type d\'adhésion',
            is_default: 'Par défaut',
            peakHoursCourtBookingDiscountValue: 'Remise sur Réservation de Terrain (Heure Pleine)',
            offPeakHoursCourtBookingDiscountValue: 'Remise sur Réservation de Terrain (Heure Creuse)',
            courtBookingDiscountValue: 'Remise sur Réservation de Terrain',
            coachingSessionDiscountValue: 'Remise sur Réservation de Coach',
            maxPrivateCourtBookings: 'Quota maximal de réservations sur une période glissante',
            maxCourtBookingTimeInAdvance: 'Délai Maximum de Réservation à l\'Avance',
            maxCourtBookingTimeInAdvance_helper_text: 'Nombre maximal de jours à l\'avance pour réserver un court',
            maxCourtBookingTimeInAdvance_invalid: 'Le délai maximum doit être un nombre',
            maxPrivateCourtBookingsDuration: 'Durée Maximale des Réservations de Terrain Privé',
            time_window_discounts: 'Remises par Créneau Horaire',
            days: 'jours',
            courtBookingDiscountType: 'Type de Remise sur Réservation de Terrain',
            courtBookingDiscountType_helper_text: 'Type de remise pour la réservation de terrain',
            coachingSessionDiscountType: 'Type de Remise sur Séance de Coaching',
            coachingSessionDiscountType_helper_text: 'Type de remise pour la séance de coaching',
            courtBookingDiscountValue_helper_text: 'Valeur de la remise pour la réservation de terrain',
            coachingSessionDiscountValue_helper_text: 'Valeur de la remise pour la séance de coaching',
            courtBookingDiscountType_percentage: 'Pourcentage',
            courtBookingDiscountType_constant: 'Montant Fixe',
            coachingSessionDiscountType_percentage: 'Pourcentage',
            coachingSessionDiscountType_constant: 'Montant Fixe',
            courtBookingDiscountValue_invalid: 'La valeur de la remise doit être un nombre',
            coachingSessionDiscountValue_invalid: 'La valeur de la remise doit être un nombre',
            courtBookingDiscountType_invalid: 'Le type de remise doit être sélectionné',
            coachingSessionDiscountType_invalid: 'Le type de remise doit être sélectionné',
            // MYS-122 — remise appliquée à l'inscription d'un membre à un évènement.
            eventJoiningDiscountValue: 'Remise sur Inscription aux Évènements',
            eventJoiningDiscountType: 'Type de Remise sur Inscription aux Évènements',
            eventJoiningDiscountType_constant: 'Montant Fixe',
            eventJoiningDiscountValue_hint: "Appliquée lorsqu'un membre s'inscrit à un évènement (cours, compétition). Pourcentage : un nombre entier de 0 à 100. Montant fixe : un montant entier en euros, pas en centimes. 100 % rend l'évènement gratuit pour cet abonnement.",
            eventJoiningDiscountType_invalid: 'Le type de remise doit être sélectionné',
            eventJoiningDiscountValue_invalid_integer: 'La remise doit être un nombre entier',
            eventJoiningDiscountValue_invalid_negative: 'La remise ne peut pas être négative',
            eventJoiningDiscountValue_invalid_percentage: 'Une remise en pourcentage ne peut pas dépasser 100 %',
            // H16 — libellés génériques, partagés par les remises coaching et
            // réservation de terrain.
            discountType_invalid: 'Le type de remise doit être sélectionné',
            discountValue_invalid_integer: 'La remise doit être un nombre entier',
            discountValue_invalid_negative: 'La remise ne peut pas être négative',
            discountValue_invalid_percentage: 'Une remise en pourcentage ne peut pas dépasser 100 %',
            time_window_discount_value: 'Valeur de la remise',
            time_window_discount_type: 'Type de remise',
            time_window_discount_type_percentage: 'Pourcentage',
            time_window_discount_type_constant: 'Montant Fixe',
            time_window_discount_value_invalid: 'La valeur de la remise doit être un nombre',
            time_window_discount_type_invalid: 'Le type de remise doit être sélectionné',
            time_window_max_private_court_bookings: 'Nombre Maximal de Réservations Privées',
            time_window_max_private_court_bookings_duration: 'Durée Maximale des Réservations Privées',
            time_window_max_private_court_bookings_invalid: 'Le nombre de réservations doit être supérieur à 0',
            time_window_max_private_court_bookings_duration_invalid: 'La durée doit être supérieure à 0',
            time_window_max_court_booking_time_in_advance: 'Délai Maximum de Réservation à l\'Avance',
            time_window_max_court_booking_time_in_advance_invalid: 'Le délai maximum doit être d\'au moins 1 jour',
            description_sections_label: 'Sections de description personnalisées',
            description_sections_helper: 'Laisser désactivé pour utiliser la description générée automatiquement. Activer pour la remplacer par vos propres sections.',
            description_sections_enable: 'Activer les sections personnalisées',
            description_sections_reset: 'Utiliser la description auto-générée',
            description_section_title: 'Section {index}',
            description_section_remove: 'Supprimer la section',
            description_section_header_label: 'Titre (optionnel)',
            description_section_header_placeholder: 'ex. Heures pleines',
            description_section_bullets_label: 'Points',
            description_section_bullet_placeholder: 'ex. 20% de remise sur les réservations',
            description_section_bullet_remove: 'Supprimer le point',
            description_section_bullet_add: '+ Ajouter un point',
            description_section_add: '+ Ajouter une section',
            description_sections_priority_hint:
                "L'ordre définit la priorité d'affichage : l'application montre les {count} premiers points, en lisant les sections de haut en bas, et cache le reste derrière un « + » que le joueur peut toucher. Utilisez les flèches pour choisir ce qui apparaît en premier — les points marqués « Affiché » sont ceux visibles sans toucher le « + ».",
            description_sections_hidden_hint:
                '{count} point(s) sont actuellement derrière le « + ».',
            description_sections_empty_hint:
                "Aucun point n'est encore rempli : l'application continuera d'afficher la description générée automatiquement. Saisissez au moins un point pour que ces sections la remplacent.",
            description_section_move_up: 'Monter la section',
            description_section_move_down: 'Descendre la section',
            description_section_bullet_move_up: 'Monter le point',
            description_section_bullet_move_down: 'Descendre le point',
            description_section_bullet_visible: 'Affiché',
            day: 'Jour',
            week: 'Semaine',
            weeks: 'Semaines',
            month: 'Mois',
            default_values: 'Valeurs par défaut',
            time_window_values: 'Valeurs des créneaux',
            // Abonnement / Stripe
            subscription_settings: 'Abonnement',
            subscription_disabled: 'Sans abonnement',
            subscription_enabled: 'Abonnement activé',
            priceInCents: 'Prix',
            monthly_price_placeholder: 'Prix mensuel',
            billing_monthly: 'Mensuel',
            billing_yearly: 'Annuel',
            invalid_stripe_configuration: 'Veuillez renseigner le prix, la devise',
            no_memberships: 'Aucune adhésion trouvée.',
            default_membership_type: 'Paramètres d\'adhésion par défaut',
            edit_default_membership_type: 'Modifier les paramètres d\'adhésion par défaut',
            // MYS-125 — sous-tarifs (variantes)
            variants_section_title: 'Sous-tarifs (variantes)',
            variants_section_hint: 'Plusieurs déclinaisons tarifées de cette même offre — ex. PUBLIC, CASH, ou un tarif Duo. Le prix réellement payé dépend de la variante choisie par le membre, ou de la variante par défaut si aucune n\'est choisie.',
            variants_legacy_price_locked_hint: 'Géré par les variantes ci-dessous — dès que cette offre a une variante, son prix est défini là plutôt qu\'ici.',
            variants_empty: 'Aucune variante pour le moment — cette offre utilise encore le prix unique ci-dessus.',
            variants_add: '+ Ajouter une variante',
            variant_label: 'Libellé',
            variant_label_placeholder: 'ex. PUBLIC',
            variant_price: 'Prix',
            variant_currency: 'Devise',
            variant_payment_mode: 'Mode de paiement',
            variant_payment_mode_recurring: 'Récurrent (mensuel)',
            variant_payment_mode_single: 'Paiement unique',
            variant_commitment_months: 'Engagement',
            variant_commitment_months_option: '{count} mois',
            variant_is_default: 'Variante par défaut',
            variant_is_default_hint: 'Utilisée quand un membre s\'abonne sans choisir de variante.',
            variant_is_duo_beneficiary: 'Part non payante du Duo',
            variant_is_duo_beneficiary_hint: '0 € affiché uniquement — accordée automatiquement via le rattachement Duo (MYS-117), jamais achetable directement.',
            variant_duo_partner_type_keys: 'Tarif Duo — types partenaires',
            variant_duo_partner_type_keys_placeholder: 'Sélectionnez le(s) type(s) d\'adhésion que le partenaire doit détenir',
            variant_duo_partner_type_keys_hint: 'Quand le partenaire rattaché détient l\'un de ces types d\'adhésion, cette variante est sélectionnée automatiquement comme tarif Duo — sans formule par combinaison.',
            variant_duo_partner_type_keys_badge: 'Tarif Duo pour : {keys}',
            variant_delete_confirm_title: 'Supprimer cette variante ?',
            variant_delete_confirm_body: 'Les membres déjà sur cette variante la conservent ; les nouveaux abonnés ne pourront plus la choisir. Cette action est irréversible.',
            variant_invalid_label: 'Le libellé ne peut pas être vide',
            variant_invalid_price: 'Le prix doit être supérieur ou égal à zéro',
            variant_invalid_currency: 'La devise doit être un code à 3 lettres (ex. eur)',
            variant_invalid_commitment: 'Sélectionnez une durée d\'engagement',
            variant_invalid_duo_beneficiary_price: 'Une variante Duo non payante doit être à 0',
            variant_invalid_duo_partner_type_keys: 'Une variante Duo non payante ne peut pas cibler de types partenaires',
        },
        common: {
            submit: 'Valider',
            cancel: 'Annuler',
            close: 'Fermer',
            delete: 'Supprimer',
            yes: 'Oui',
            no: 'Non',
            default: 'Par défaut',
            duplicate: 'Dupliquer',
            save: 'Sauvegarder',
            create: 'Créer',
            actions: 'Actions',
            error: 'Erreur',
            unknown: 'Inconnu',
            loading: 'Chargement…',
            previous: 'Précédent',
            next: 'Suivant',
            remove: 'Supprimer',
            unexpected_error: 'Une erreur inattendue s\'est produite',
            offline_no_data: 'Vous semblez hors ligne. Le chargement reprendra dès le retour de votre connexion.',
            unknown_error: 'Erreur inconnue',
            edit: 'Modifier',
            select: 'Sélectionner',
            copy: 'Copier',
            copied: 'Copié',
        },
        coachs: {
            firstName: 'Prénom',
            lastName: 'Nom',
            add_new: "Ajouter un Coach",
            invite: "Inviter un Coach",
            email: "email",
            pricing_rules: 'Tarification',
            default_hourly_tarification: 'Tarification Horaire',
            default_hourly_tarification_helper_text: "La tarification horaire par défaut s'applique aux nouveaux créneaux créés pour ce coach. Vous pourrez ajuster la tarification de chaque créneau individuellement dans l'onglet Tarification.",
            coach_edited_successfully: ' Le coach a été modifié avec succès',
            delete_success: 'Coach supprimé avec succès',
            delete_error: 'Échec de la suppression du coach',
            invite_error: "Échec de l'envoi de l'invitation. Veuillez réessayer.",
            invite_success: "Invitation envoyée avec succès",
            delete_coach_confirmation_message: 'Êtes-vous sûr de vouloir supprimer ce coach ? Cette action est irréversible.',
            price_duration: 'Durée',
            error_loading: 'Erreur lors du chargement des coachs. Veuillez réessayer.',
            provision_access: "Donner l'accès au dashboard",
            provision_access_has: 'Accès dashboard actif',
            provision_access_title: "Donner l'accès au dashboard",
            provision_access_description: "Crée un compte pour ce coach avec un accès limité (Calendrier, Terrains, Coachs). Il pourra gérer son propre planning.",
            provision_access_success_new: 'Compte créé. Transmettez ce lien au coach pour définir son mot de passe :',
            provision_access_success_existing: "Un compte existe déjà pour cet email — le coach se connecte avec son mot de passe actuel (ou via « Mot de passe oublié »).",
            provision_access_link_failed: "Compte créé, mais le lien n'a pas pu être généré. Le coach peut utiliser « Mot de passe oublié » avec cet email.",
            provision_access_copy_link: 'Copier le lien',
            provision_access_copied: 'Copié !',
            provision_access_one_time_note: "Ce lien est à usage unique et ne pourra pas être récupéré plus tard.",
            // MYS-75 — coach contact fields (admin-only on the dashboard).
            phone_calling_code: 'Indicatif',
            phone: 'Téléphone',
            phone_helper: 'Ex. 06 12 34 56 78 avec l’indicatif choisi, ou un numéro complet +33 6 12 34 56 78. Laissez vide pour effacer.',
            phone_invalid: 'Numéro invalide — vérifiez l’indicatif et le numéro.',
            phone_public: 'Afficher le numéro sur le profil public',
            phone_public_helper: 'Les joueurs voient le numéro sur leur séance réservée. Désactivé, il reste visible des seuls administrateurs.',
            notification_email: 'Email de notification',
            notification_email_helper: 'Le coach reçoit un email à chaque nouvelle réservation de coaching. Laissez vide pour ne rien envoyer.',
            notification_email_invalid: 'Adresse email invalide.',
            contact_load_error: 'Impossible de charger le téléphone et l’email de notification du coach.',
            contact_retry: 'Réessayer',
        },
        courts: {
            title: 'Titre',
            add_new_court: 'Ajouter un terrain',
            pricing_grid: {
                add_court_with_grid: 'Ajouter un terrain (grille tarifaire)',
                edit_with_grid: 'Grille tarifaire',
                beta_badge: 'Bêta',
                beta_hint: "Nouvelle façon de configurer les tarifs : découpez la journée en blocs, puis ajustez chaque case de la grille. L'ancien formulaire reste disponible à côté.",
                blocks_title: 'Configuration des créneaux par période',
                blocks_hint: "Découpez la journée en blocs indépendants — chacun avec sa propre durée de créneau, son intervalle d'affichage et, si besoin, un tarif unique. Pour proposer plusieurs durées (60 min, 90 min…) sur les mêmes horaires, ajoutez un bloc par durée : chaque durée a ses propres tarifs dans la grille.",
                block_start: 'Début',
                block_end: 'Fin',
                block_duration: 'Durée créneau',
                block_interval: 'Affiché toutes les',
                block_price: 'Tarif unique',
                block_price_placeholder: 'Par case',
                add_block: 'Ajouter un bloc',
                remove_block: 'Supprimer ce bloc',
                block_overlap_warning: 'Ce bloc chevauche un autre bloc de même durée — la partie en conflit sera ignorée dans la grille. (Deux blocs de durées différentes peuvent partager les mêmes horaires.)',
                block_invalid_time: 'Heure de début ou de fin invalide.',
                grid_title: 'Disponibilités',
                grid_hint: 'Cliquez une case, ou glissez sur plusieurs créneaux, pour leur appliquer un seul tarif.',
                no_slots: 'Aucun créneau — configurez au moins un bloc ci-dessus.',
                no_sport: 'Sélectionnez au moins un sport pour tarifer la grille.',
                sport_label: 'Sport affiché',
                duration_label: 'Durée affichée',
                duration_hint: 'La grille affiche les créneaux de {duration} min. Changez la durée ci-dessus pour tarifer les autres.',
                period_title: "Période d'application",
                period_start: 'Du',
                period_end: 'Au',
                period_hint: "La grille ci-dessous est un modèle hebdomadaire : les mêmes tarifs s'appliquent à CHAQUE semaine du {start} au {end}. Enregistrer remplace tout le planning de ce terrain sur cette période.",
                single_chunk_hint: "Activé : les réservations peuvent démarrer tous les quarts d'heure à l'intérieur d'une plage au même tarif. Désactivé : uniquement aux heures affichées dans la grille.",
                editor_slots: 'créneaux',
                editor_save: 'Enregistrer',
                editor_clear: 'Vider',
                unpriced_cell: 'Non réservable',
                summary: '{priced} cases tarifées · {unpriced} non réservables',
                nothing_priced: "Aucune case n'est tarifée : saisissez un tarif unique sur un bloc, ou un tarif sur des cases.",
                seeded_from_week: 'Point de départ : les tarifs pré-remplis sont ceux actuellement en vigueur la semaine du {date}. Ce que vous enregistrez s\'applique à toute la période ci-dessus, pas seulement à cette semaine.',
                loading_week: 'Chargement des tarifs actuels…',
                saved_summary: '{count} créneaux enregistrés du {start} au {end}.',
                save_refused: "Enregistrement refusé — rien n'a été modifié",
                week_read_failed: "Impossible de lire les tarifs actuels de ce terrain. La grille ne peut pas être enregistrée tant que cette lecture échoue — réessayez, ou utilisez le formulaire « Créer un nouveau créneau ».",
                minutes_short: 'min',
                days_short: {
                    '0': 'Dim',
                    '1': 'Lun',
                    '2': 'Mar',
                    '3': 'Mer',
                    '4': 'Jeu',
                    '5': 'Ven',
                    '6': 'Sam',
                },
            },
            title_in_form: 'Nom du terrain',
            availabilities: 'Disponibilités',
            availability_schedule: 'Horaires de disponibilité',
            slot_duration: 'Durée du créneau',
            price: 'Prix',
            invalid_price: 'Veuillez saisir un prix valide pour chaque configuration',
            availability_hours_may_be_wrong: "Les horaires ci-dessous ont été enregistrés par une ancienne version de ce formulaire et peuvent ne pas correspondre à ce que vous aviez configuré. Vérifiez chaque plage avant d'enregistrer — l'enregistrement remplace tout le planning de ce terrain.",
            unchargeable_capacity_prices: 'Enregistré, mais certains prix ne pourront pas être encaissés : la part par joueur est inférieure au minimum de 0,50 € imposé par Stripe, donc chaque réservation à cette capacité sera refusée. Augmentez le prix, baissez la capacité, ou mettez le prix à 0 si le terrain est gratuit.',
            unchargeable_capacity_price_row: '{{sport}} à {{capacity}} joueurs ({{price}} → {{cents}} centimes par joueur)',
            unchargeable_capacity_price_row_wildcard: '{{sport}} à {{capacity}} joueurs ({{price}} → {{cents}} centimes par joueur, via le prix toutes capacités — cette ligne tarife toutes les capacités proposées par votre club, donc {{capacity}} joueurs n\'est pas une valeur que vous avez saisie)',
            invalid_capacity: 'La capacité doit être un nombre entier de joueurs, ou laissée vide pour tarifer toutes les capacités',
            duplicate_capacity_pricing: 'Deux prix sont configurés pour le même sport, la même durée et la même capacité — supprimez-en un avant d\'enregistrer',
            duplicate_capacity_pricing_detail: 'Deux prix pour {{capacity}} joueurs partagent le même sport et la même durée. Un seul prix par capacité est autorisé : supprimez-en un avant d\'enregistrer.',
            unbookable_capacity: '{{capacity}} joueurs ne peut pas être réservé (le maximum est {{max}}) : ce prix ne s\'appliquera jamais.',
            capacity_without_fallback: '{{sport}} peut encore être réservé pour {unpriced} joueurs, et aucun prix ici ne couvre cette taille — la réservation est refusée au moment du paiement. Ajoutez un prix pour {{unpriced}}, ou une ligne en laissant la capacité vide pour couvrir toutes les tailles.',
            capacity_not_offered: 'Ce prix est défini pour {{capacity}} joueurs, mais {{sport}} ne peut être réservé qu\'à {{bookable}} joueurs dans cet établissement : personne ne peut l\'acheter. Ajoutez {{capacity}} dans la gestion des capacités de jeu, ou supprimez cette ligne.',
            capacity_uniform_price: '{{sport}} est proposé à {{capacities}} joueurs, mais un seul prix les couvre tous ici. Toutes les tailles coûtent le même montant, et une réduction d\'abonnement en pourcentage couvre une place — elle vaut donc davantage pour les petites tailles. Ajoutez un prix par capacité s\'ils doivent différer.',
            all_sports: 'Tous les sports',
            all_durations: 'Toutes les durées',
            all_capacities: 'Toutes les capacités',
            select_court: 'Sélectionner un terrain',
            default_hourly_tarification: 'Tarif horaire',
            default_hourly_tarification_helper_text: "La tarification horaire par défaut s'applique aux nouveaux créneaux créés pour ce terrain. Vous pourrez ajuster la tarification de chaque créneau individuellement dans l'onglet Tarification.",
            default_hourly_price_duration: 'Durée de la tarification par défaut',
            default_hourly_price_duration_helper: 'Durée en minutes pour la tarification par défaut',
            manage_configurations: 'Gérer les Configurations',
            court_availability_type_picker: {
                title: 'Type de disponibilité',
                error_message: 'Doit avoir selectionné au moins une option',
                helper_text: 'Chaque créaneau horaire peut-être marqué comme disponible où bien pour des matchs, ou des sessions de coaching, ou les deux',
                is_game_available: 'Disponible pour matchs',
                is_coaching_available: 'Disponible pour coaching'
            },
            blockade: {
                external_reservation: 'Réservation',
                pending_payment: "Paiement en Cours",
                add_new_blockade: 'Ajouter un blocage temporaire',
                maintenance: 'Maintenance',
                event: 'Événement',
                other: 'Autre',
                comment: 'Commentaire',
                batch: {
                    toggle_title: 'Appliquer à plusieurs terrains ou dates ?',
                    toggle_subtitle: 'Utilise le créneau sélectionné comme référence.',
                    preview_count: 'Créera {total} blocage(s) sur {courts} terrain(s) pour {dates} date(s)',
                    time_window: 'Plage horaire : {start} – {end}',
                    courts_label: 'Terrains',
                    filter_placeholder: 'Filtrer par nom…',
                    select_all: 'Tout sélectionner (filtrés)',
                    starting_label: 'Commence le',
                    repeat_until_label: 'Répéter chaque semaine jusqu\'au (optionnel)',
                    exceeds_max_weeks: 'Impossible de répéter plus de 25 semaines (~6 mois). Choisissez une date antérieure.',
                    confirm_title: 'Confirmer le blocage par lot',
                    confirm_body: 'Cela créera {total} blocages sur {courts} terrain(s) pour {dates} date(s). Raison : « {reason} ». Non annulable en masse.',
                    cancel: 'Annuler',
                    confirm: 'Confirmer',
                    result_title: 'Résultat du blocage par lot',
                    result_done: 'Terminé',
                    result_all_created: 'Tous les blocages ont été créés',
                    result_some_skipped: 'Certains blocages ont été ignorés',
                    result_nothing_created: "Rien n'a été créé",
                    result_summary: '{created} créé(s) sur {total} — {skipped} ignoré(s).',
                    skipped_pairs_heading: 'Paires ignorées',
                    court_fallback_name: 'Terrain {id}',
                    skip_reason: {
                        OVERLAP_WITH_BOOKING: 'Chevauche une réservation payée',
                        OVERLAP_WITH_GAME: 'Chevauche une partie',
                        OVERLAP_WITH_BLOCKADE: 'Chevauche un blocage existant',
                        OVERLAP_WITH_PENDING_HOLD: 'Chevauche un paiement en cours — réessayez dans quelques minutes',
                        COURT_NOT_FOUND: 'Terrain introuvable',
                    },
                },
            },
            court_edited_successfully: 'Le terrain a été modifié avec succès',
            commitments_repriced_title: 'Enregistré — mais un prix déjà réservé a changé',
            commitments_repriced:
                '{{count}} réservation(s) {{sport}} à venir à {{capacity}} joueurs sont désormais tarifées {{toPrice}} au lieu de {{fromPrice}} — la plus proche est le {{date}}. Les joueurs ayant déjà payé conservent leur prix ; toute personne qui rejoint à partir de maintenant, ou qui remplace un joueur partant, paie le nouveau.',
            commitments_unpriced_title: 'Enregistré — mais un créneau réservé n\'a plus de tarif',
            commitments_unpriced:
                '{{count}} réservation(s) {{sport}} à venir à {{capacity}} joueurs ne sont plus tarifées du tout sur ce terrain — la plus proche est le {{date}}. Personne ne peut les rejoindre, et le lien de remplacement d\'un joueur partant ne peut plus être utilisé, tant que vous n\'avez pas de nouveau tarifé ce créneau sur ce terrain.',
            capacity_pricing_lost_title: 'Enregistré — mais un format n\'est plus vendable',
            capacity_pricing_lost:
                '{{sport}} est toujours proposé à {{capacities}} joueurs, mais plus aucun terrain de ce club ne tarifie ce format — ces réservations sont acceptées puis échouent au moment du calcul du prix. Ajoutez un prix pour {{capacities}} sur un autre terrain, ou un prix valable pour tous les formats, ou retirez {{capacities}} dans la gestion des formats de jeu.',
            court_not_found: 'Terrain introuvable',
            court_not_found_description: 'Ce terrain n\'a pas pu être chargé. Il a peut-être été supprimé, ou le lien est invalide.',
            is_outdoor: 'Extérieur',
            is_outdoor_description: 'Ce terrain est en extérieur (la météo sera affichée)',
            coaching_priority: 'Priorité coaching',
            coaching_priority_helper: 'Ordre de préférence pour les coachings (1 = prioritaire). Laisser vide si le terrain n\'a pas de priorité.',
            coaching_priority_placeholder: 'ex : 1',
            duplicating: 'Duplication du terrain en cours...',
            duplicate_success: 'Le terrain a été dupliqué avec succès',
            return_as_one_chunk: 'Créer en tant qu\'un seul créneau',
            delete_court_confirmation_message: 'Êtes-vous sûr de vouloir supprimer ce terrain ? Cette action est irréversible.',
            delete_court_confirmation_title: 'Supprimer le terrain',
            is_composite: 'Terrain Composite',
            is_composite_helper: 'Ce terrain est composé de plusieurs terrains plus petits',
            select_subcourts: 'Sélectionner les Sous-Terrains',
            select_subcourts_helper: 'Choisissez les terrains qui feront partie de ce terrain composite',
            no_available_subcourts: 'Aucun terrain disponible pour sélection comme sous-terrain',
            create_event_with_court: 'Créer un événement avec ce terrain',
            create_event_with_court_helper: 'Créer optionnellement un événement qui sera associé à ce terrain',
            error_loading: 'Erreur lors du chargement des données du terrain. Veuillez réessayer.',
            delete_court_error: 'Impossible de supprimer le terrain. Veuillez réessayer.',
            duplicate_error: 'Impossible de dupliquer le terrain. Veuillez réessayer.',
            no_courts: 'Aucun terrain trouvé.',
            court_and_event_created: 'Terrain et événement créés avec succès.',
            court_created_event_failed: 'Terrain créé mais la création de l\'événement a échoué.',
            court_created: 'Terrain créé avec succès.',
            create_court_error: 'Impossible de créer le terrain. Veuillez réessayer.',
            sports: 'Sports',
            club: 'Club',
            must_select_club: 'Vous devez sélectionner un club.',
        },
        court: {
            court: 'Terrain',
            name: 'Nom',
            sports: 'Sports',
            add_availabilities: 'Créer un nouveau créneau',
            cancel_day: 'Annuler la journée',
            cancel_day_title: 'Annuler & rembourser la journée',
            cancel_day_description: 'Tous les matchs à venir sur les terrains sélectionnés ce jour-là seront annulés. Les joueurs seront remboursés et notifiés automatiquement.',
            cancel_day_date_label: 'Jour à annuler',
            cancel_day_summary: '{games} match(s) à venir sur {courts} terrain(s) · {players} joueur(s) seront remboursés',
            cancel_day_none: 'Aucun match à venir sur ce terrain ce jour-là.',
            cancel_day_courts_label: 'Terrains à annuler',
            cancel_day_no_court: 'Sélectionnez au moins un terrain.',
            cancel_day_loading_preview: 'Calcul des matchs concernés…',
            cancel_day_preview_error: 'Impossible de charger les matchs de ce jour. Réessayez avant d\'annuler.',
            cancel_day_not_canceled_note: '{coachings} séance(s) de coaching et {events} événement(s) ce jour-là ne seront PAS annulés — à gérer manuellement.',
            cancel_day_linked_warning: '{court} est lié à {linked}. Les matchs sur {linked} ne seront pas annulés — sélectionnez-le aussi si besoin.',
            cancel_day_block_too: 'Bloquer aussi la journée (empêche les nouvelles réservations)',
            cancel_day_block_description: 'Journée annulée (météo)',
            cancel_day_confirm_ack: 'Je confirme l\'annulation de {games} match(s) et le remboursement de {players} joueur(s) sur {courts} terrain(s).',
            cancel_day_progress: 'Terrain {done} / {total}…',
            cancel_day_confirm: 'Annuler & rembourser',
            cancel_day_success: '{count} match(s) annulé(s) et remboursé(s)',
            cancel_day_error: "L'annulation a échoué. Réessayez.",
            cancel_day_result_canceled: '{count} match(s) annulé(s) et remboursé(s).',
            cancel_day_result_failed_title: "{count} match(s) n'ont pas pu être annulés :",
            cancel_day_result_court_errors: "{count} terrain(s) n'ont pas pu être traités :",
            cancel_day_result_block_skipped: "La journée n'a pas pu être bloquée sur {count} terrain(s) (créneau déjà occupé ou bloqué) :",
            cancel_day_retry: 'Réessayer les échecs',
            cancel_day_failure_not_cancelable: "n'est plus annulable",
            cancel_day_failure_already_canceled: 'déjà annulé',
            cancel_day_failure_error: 'erreur — réessayez',
            calendar: 'Calendrier',
            monthly_calendar: 'Calendrier mensuel',
            pricing: 'Tarification',
            pricing_heatmap: 'Grille tarifaire',
            no_price: 'Pas de tarif'
        },
        event: {
            price: 'Prix (par participant)',
            price_helper: 'Indiquez le prix de l\'événement (par participant)',
            name: 'Nom de l\'événement',
            team_size: 'Taille de l\'équipe',
            team_size_helper: 'Indiquez la taille de chaque équipe (ex: 2 pour doubles). Laisser vide pour les événements individuels.',
            location: 'Lieu (Terrains concernés)',
            location_helper: 'Indiquez une description ou adresse pour le lieu de l\'événement',
            club: 'Club',
            court: 'Terrain',
            select_court: 'Sélectionner un terrain (optionnel)',
            court_helper: 'Associer optionnellement cet événement à un terrain spécifique',
            select_location_first: 'Veuillez d\'abord sélectionner un club',
            no_courts_available: 'Aucun terrain disponible pour ce club',
            courts_helper: 'Sélectionnez un ou plusieurs terrains pour cet événement',
            capacity: 'Capacité (Nombre de participants)',
            start_date: 'Date de début',
            end_date: 'Date de fin',
            start_time: 'Heure de début',
            end_time: 'Heure de fin',
            delete_event: 'Supprimer l\'événement',
            delete_recurring_events: 'Supprimer les événements récurrents',
            delete_confirmation: 'Êtes-vous sûr de vouloir supprimer',
            delete_recurring_confirmation: 'Cet événement fait partie d\'une série récurrente. Que souhaitez-vous supprimer ?',
            delete_future_only: 'Supprimer uniquement les événements futurs (conserver les passés)',
            delete_all_events: 'Supprimer tous les événements de la série',
            delete_this_event_only: 'Supprimer uniquement cet événement',
            delete_success: 'Événement(s) supprimé(s) avec succès',
            delete_error: 'Échec de la suppression de l\'événement',
            recurring_event: 'Événement récurrent',
            create_recurring_events: 'Créer des événements récurrents',
            create_recurring_events_helper: 'Créer plusieurs événements aux jours sélectionnés de la semaine',
            days_of_week: 'Jours de la semaine',
            select_days_helper: 'Sélectionnez les jours de la semaine pour créer les événements',
            repeat_until: 'Répéter jusqu\'au',
            repeat_until_helper: 'Dernière date de création des événements récurrents',
            recurring_occurrence_count: '{count} séances seront créées',
            recurring_occurrence_count_one: '1 séance sera créée',
            recurrence_error: {
                missing_start_time: 'Renseignez d\'abord la date et l\'heure de début',
                no_days_selected: 'Sélectionnez au moins un jour de la semaine',
                invalid_day: 'Un des jours sélectionnés n\'est pas un jour valide',
                missing_end_date: 'Choisissez une date de fin de répétition',
                invalid_end_date: 'La date de fin de répétition n\'est pas valide',
                end_date_before_start: 'La date de fin doit être postérieure ou égale à la date de début',
                horizon_too_long: 'Une série ne peut pas se répéter plus de {max} jours',
                no_occurrences: 'Les jours sélectionnés ne produisent aucune séance avant la date de fin',
                too_many_occurrences: 'Cela créerait plus de {max} séances — réduisez la période ou sélectionnez moins de jours',
            },
            days: {
                sun: 'Dim',
                mon: 'Lun',
                tue: 'Mar',
                wed: 'Mer',
                thu: 'Jeu',
                fri: 'Ven',
                sat: 'Sam',
            },
            event_type: 'Type d\'événement',
            level_required: 'Niveau requis',
            min_level: 'Niveau minimum',
            max_level: 'Niveau maximum',
            ranking_required: 'Classement requis',
            min_ranking: 'Classement minimum',
            max_ranking: 'Classement maximum',
            ranking_range: 'Plage de classement',
            select_min_ranking: 'Sélectionner le classement minimum (ou laisser vide)',
            select_max_ranking: 'Sélectionner le classement maximum (ou laisser vide)',
            min_ranking_helper: 'Sélectionnez le classement minimum requis pour ce tournoi',
            max_ranking_helper: 'Sélectionnez le classement maximum autorisé pour ce tournoi',
            none: 'Aucun',
            sport: 'Sport',
            add_new: 'Créer un évenement',
            edit_event: 'Modifier l\'événement',
            past: 'Précédents',
            future: 'À venir',
            prizes: 'Récompenses',
            entry_fees_per_player: "Frais d'entrée",
            notification_title: 'Titre de la notification',
            notification_title_helper: 'Ce message apparaîtra dans la notification envoyée aux joueurs',
            notification_title_description: 'Ce message apparaîtra dans la notification envoyée aux joueurs.',
            cohort_restriction_helper: 'Si défini, seuls les membres de cette cohorte peuvent rejoindre l\'événement.',
            coach: 'Coach / Animateur',
            coach_helper: 'Optionnel — le membre du staff qui anime l\'événement. Affiché aux joueurs sur la fiche événement.',
            type: {
                class: 'Cours',
                competition: 'Compétition',
                official_competition: 'Tournoi Officiel',
                other: 'Autre',
            },
            tournament_category: 'Catégorie de Tournoi',
            select_tournament_category: 'Sélectionner la catégorie de tournoi',
            tournament_category_helper: 'Sélectionnez la catégorie de tournoi officiel (ex: P25, P50, P100 pour le Padel)',
            gender_restriction: 'Restriction de Genre',
            gender_restriction_helper: 'Sélectionnez si ce tournoi est pour les hommes, les femmes, ou sans restriction de genre',
            requires_license_number: 'Numéro de licence obligatoire à l’inscription',
            requires_license_number_helper: 'Les joueurs sans numéro de licence sur leur fiche devront le renseigner avant de pouvoir s’inscrire',
            men: 'Hommes',
            women: 'Femmes',
            no_restriction: 'Aucune Restriction',
            details: 'Détails de l\'événement',
            participants: 'Participants',
            duration: 'Durée',
            courts: 'Terrains',
            type_label: 'Type',
            status_label: 'Statut',
            level_range: 'Niveau requis',
            minutes: 'minutes',
            no_participants: 'Aucun participant pour le moment',
            no_teams: 'Aucune équipe pour le moment',
            teams: 'Équipes',
            team: 'Équipe',
            players_per_team: 'joueurs par équipe',
            teams_available: 'équipes disponibles',
            team_available: 'équipe disponible',
            team_complete: 'Complète',
            team_incomplete: 'Incomplète',
            team_leader: 'Capitaine',
            remove_from_team: 'Retirer de l\'équipe',
            awaiting_team_member: 'En attente d\'un membre...',
            full: 'Complet',
            spots_available: 'places disponibles',
            level: 'Niveau',
            canceling: 'Annulation...',
            cancel_event: 'Annuler l\'événement',
            remove_participant: 'Retirer le Participant',
            remove_participant_title: 'Retirer le Participant de l\'Événement',
            remove_participant_message: 'Êtes-vous sûr de vouloir retirer',
            remove_participant_refund_info: 'Cette action remboursera le participant s\'il a payé pour rejoindre cet événement. Cette action ne peut pas être annulée.',
            kick_reason_label: 'Motif (Optionnel)',
            kick_reason_placeholder: 'Entrez le motif pour retirer ce participant...',
            kick_reason_helper: 'Ce motif sera enregistré à des fins de référence et d\'audit.',
            status: {
                active: 'Actif',
                completed: 'Terminé',
                cancelled: 'Annulé',
            },
            link_copied: 'Lien copié dans le presse-papiers',
            copy_link: 'Copier le lien',
            export_participants: 'Exporter en CSV',
            export_success: 'Export téléchargé avec succès',
            export_empty: 'Aucun participant ou équipe à exporter',
            attendance_export: {
                button: 'Exporter la fréquentation',
                title: 'Exporter la fréquentation des cours',
                description:
                    'Une ligne par séance sur la période choisie, triée chronologiquement, avec ses données de remplissage.',
                from: 'Du',
                to: 'Au',
                submit: 'Télécharger le CSV',
                type_filter: 'Séances à inclure',
                type_all: 'Tous les types d\'événements',
                type_class: 'Cours collectifs',
                type_competition: 'Compétition',
                type_official_competition: 'Compétition officielle',
                type_other: 'Autre',
                include_cancelled: 'Inclure les cours annulés',
                include_cancelled_helper:
                    'Recommandé : sans eux, une semaine d\'annulations se lit comme une semaine sans cours programmé.',
                attendance_notice:
                    'La colonne « Présents » n\'est renseignée que pour les séances couvertes par le contrôle d\'accès. Elle reste vide lorsqu\'aucun pointage n\'a pu être enregistré — ce qui n\'est pas la même chose que personne n\'est venu.',
                success: 'Export téléchargé avec succès',
                empty: 'Aucune séance trouvée sur cette période',
                truncated: 'Export limité aux {count} premières séances — réduisez la période pour obtenir la suite.',
                error: 'Échec de la génération de l\'export',
                error_dates_required: 'Choisissez une date de début et une date de fin',
                error_range_inverted: 'La date de début doit précéder la date de fin',
                error_range_too_long: 'La période ne peut pas dépasser {days} jours',
                col_date: 'Date',
                col_start_time: 'Début',
                col_end_time: 'Fin',
                col_name: 'Nom du cours',
                col_coach: 'Coach',
                col_capacity: 'Capacité',
                col_registered: 'Inscrits',
                col_fill_rate: 'Taux de remplissage',
                col_attended: 'Présents',
                col_status: 'Statut',
                col_type: 'Type',
            },
            export_col_index: 'N°',
            export_col_first_name: 'Prénom',
            export_col_last_name: 'Nom',
            export_col_email: 'Email',
            export_col_level: 'Niveau',
            export_col_license_id: 'N° Licence / ID',
            export_col_ranking: 'Classement',
            export_col_license_verified: 'Licence vérifiée',
            export_col_team_number: 'Équipe N°',
            export_col_team_status: 'Statut équipe',
            export_col_slot: 'Place',
            export_col_role: 'Rôle',
            export_role_member: 'Membre',
            export_yes: 'Oui',
            select_end_date_and_time: 'Sélectionnez la date et l\'heure de fin',
            select_start_date_and_time: 'Sélectionnez la date et l\'heure de début',
            time: 'Heure',
            created_successfully: 'Événement créé avec succès',
            updated_successfully: 'Événement mis à jour avec succès',
            recurring_created_successfully: 'Événements récurrents créés avec succès',
            link_not_available: 'Lien de l\'événement non disponible',
            copy_failed: 'Échec de la copie du lien',
            creation_failed: 'Échec de la création de l\'événement',
            update_failed: 'Échec de la mise à jour de l\'événement',
            error_occurred: 'Une erreur est survenue',
            actions: 'Actions',
            participants_count: 'participant(s)',
            no_events: 'Aucun événement trouvé',
            error_loading: 'Erreur lors du chargement des détails de l\'événement. Veuillez réessayer.',
            cancel_success: 'Événement annulé avec succès',
            cancel_error: 'Échec de l\'annulation de l\'événement',
            participant_removed_success: 'Participant retiré avec succès',
            participant_removed_error: 'Échec du retrait du participant',
            participant_removed_unexpected: 'Une erreur inattendue est survenue lors du retrait du participant.',
            license_number: 'N°Licence',
            ranking: 'Classement',
            id_label: 'ID',
            waitlist: {
                card_title: 'Liste d’attente',
                approval_requests: 'Demandes de validation',
                seat_queue: 'En attente d’une place',
                seat_queue_hint: 'Ces joueurs sont dans la fourchette de niveau de l’événement et sont en file d’attente car l’événement est complet. Une place libérée leur est proposée dans cet ordre.',
                no_entries: 'Personne n’est en liste d’attente.',
                event_level_range: 'Niveau de l’événement',
                rank: '#',
                player: 'Joueur',
                level: 'Niveau',
                requested_at: 'Demandé le',
                status: 'Statut',
                actions: 'Actions',
                pending: 'En attente de validation',
                waiting_for_seat: 'En attente',
                awaiting_payment: 'En attente de paiement',
                pay_by: 'à payer avant le',
                approve: 'Valider',
                reject: 'Refuser',
                promote: 'Promouvoir',
                remove: 'Retirer',
                approve_success: 'Demande validée',
                approve_error: 'Impossible de valider la demande',
                reject_success: 'Demande retirée',
                reject_error: 'Impossible de retirer la demande',
            },
        },
        user: {
            first_name: 'Prénom',
            last_name: 'Nom de famille',
            level: 'Niveau',
            email: 'Email',
            identification_number: 'Numéro d\'identification',
            official_ranking: 'Classement officiel',
            mooving_arena_point: 'Point Mooving Arena',
            user_level_invalid: 'Le niveau doit être compris entre 1.00 et 10.00',
            phone_number: 'Numéro de téléphone',
            postal_code: 'Code postal',
            search_first_name: 'Rechercher par prénom...',
            search_last_name: 'Rechercher par nom...',
            search_email: 'Rechercher par email...',
            archive_user: 'Archiver l\'utilisateur',
            unarchive_user: 'Désarchiver l\'utilisateur',
            archived_successfully: 'Utilisateur archivé avec succès',
            unarchived_successfully: 'Utilisateur désarchivé avec succès',
            archive_failed: 'Échec de l\'archivage de l\'utilisateur',
            unarchive_failed: 'Échec du désarchivage de l\'utilisateur',
            level_updated_successfully: 'Niveau mis à jour avec succès',
            main_level: 'Niveau principal',
            change_password: 'Changer le mot de passe',
            change_password_description: 'Définissez un nouveau mot de passe pour cet utilisateur. Il sera déconnecté de tous ses appareils.',
            new_password: 'Nouveau mot de passe',
            new_password_placeholder: 'Au moins 6 caractères',
            confirm_password: 'Confirmer le mot de passe',
            confirm_password_placeholder: 'Saisissez à nouveau le mot de passe',
            show_password: 'Afficher le mot de passe',
            hide_password: 'Masquer le mot de passe',
            set_password: 'Définir le mot de passe',
            password_too_short: 'Le mot de passe doit contenir au moins 6 caractères',
            passwords_do_not_match: 'Les mots de passe ne correspondent pas',
            password_updated_successfully: 'Mot de passe mis à jour',
            password_account_created: 'Compte créé avec ce mot de passe',
            password_sessions_revoked: 'L\'utilisateur a été déconnecté de tous ses appareils.',
            password_update_failed: 'Échec de la mise à jour du mot de passe',
            password_error_guest: 'Les profils invités n\'ont pas de compte de connexion, ils ne peuvent donc pas avoir de mot de passe.',
            password_error_no_account: 'Cet utilisateur n\'a pas encore activé son compte. Demandez-lui de s\'inscrire, ou invitez-le depuis l\'import de clients.',
            password_error_forbidden: 'Seuls les administrateurs de l\'organisation peuvent changer le mot de passe d\'un utilisateur.',
            notify_user: 'Notifier l\'utilisateur',
            notification_sent_successfully: 'Notification envoyée avec succès',
            notification_send_failed: 'Échec de l\'envoi de la notification',
            notification_title: 'Titre',
            notification_title_placeholder: 'Entrez le titre de la notification',
            notification_body: 'Message',
            notification_body_placeholder: 'Entrez le message de la notification',
            notification_url: 'URL (Optionnel)',
            notification_url_placeholder: 'ex: game/123 ou event/456',
            send_notification: 'Envoyer la notification',
            validated_by_admin: 'Validé par l\'administrateur',
            level_verified_by_admin: 'Niveau certifié',
            identification_verified_by_admin: 'Licence vérifiée',
            level_verified: 'Niveau Vérifié',
            license_verified: 'Licence Vérifiée',
            sport_level_validation_updated: 'Validation du niveau sportif mise à jour',
            selected: 'sélectionnés',
            add_to_cohort: 'Ajouter à une Cohorte',
            import_users: 'Importer des Utilisateurs',
            batch_import_results: 'Résultats de l\'Importation',
            import_instructions: 'Instructions',
            csv_must_have_columns: 'Le fichier CSV doit avoir ces colonnes',
            optional_columns: 'Colonnes optionnelles',
            extra_columns_kept:
              'Les autres colonnes sont conservées et visibles uniquement par les administrateurs',
            max_users_per_batch: 'Maximum d\'utilisateurs par lot',
            download_sample_template: 'Télécharger le Modèle',
            select_csv_file: 'Sélectionner un Fichier CSV',
            total: 'Total',
            valid: 'Valide',
            invalid: 'Invalide',
            validation_status: 'Statut',
            row: 'Ligne',
            wallet_balance: 'Solde du Portefeuille',
            success: 'Succès',
            skipped: 'Ignoré',
            errors: 'Erreurs',
            reason: 'Raison',
            download_error_report: 'Télécharger le Rapport d\'Erreurs',
            user_created: 'utilisateur créé avec succès',
            users_created: 'utilisateurs créés avec succès',
            assign_to_cohort: 'Assigner à une Cohorte',
            optional: 'optionnel',
            no_cohort: 'Aucune cohorte',
            import_ready: 'Prêt à importer',
            confirm_import: 'Confirmer l’import',
            will_import: 'À importer',
            duplicates: 'Doublons',
            discard: 'Abandonner',
            importing: 'Importation…',
            import_finished: 'Importation terminée',
            undo_import: 'Annuler l’import (supprimer les non réclamés)',
            rolled_back: 'Annulé — {count} client(s) non réclamé(s) supprimé(s).',
            rolled_back_kept:
              '{count} conservé(s) — ils ont désormais une activité (connexion ou crédit) et n’ont pas été supprimés.',
            rollback_confirm:
                'Supprimer les clients importés qui ne se sont pas encore connectés ? Les clients déjà connectés sont conservés. Cette action est irréversible.',
            rollback_failed: 'Échec de l’annulation de l’import',
            csv_parse_error: 'Erreur lors de l’analyse du fichier CSV',
            csv_read_error: 'Erreur de lecture du fichier : {message}',
            csv_missing_columns:
                'Colonne manquante dans le CSV : {columns}. Attendu : email, prénom et nom (en-têtes anglais ou français).',
            import_start_failed: 'Échec du démarrage de l’import',
            showing_first: 'Affichage des {limit} premiers / {total}',
            please_upload_csv: 'Veuillez importer un fichier CSV',
            file_too_large: 'La taille du fichier doit être inférieure à 20 Mo',
            select_existing_cohort: 'Sélectionner une cohorte existante',
            select_cohort: 'Sélectionner une cohorte',
            create_new_cohort: 'Créer une nouvelle cohorte',
            cohort_name: 'Nom de la cohorte',
            cohort_description: 'Description (optionnel)',
            members: 'membres',
            cohort_created_and_assigned: 'Cohorte créée et utilisateurs assignés',
            cohort_assigned: 'Utilisateurs assignés à la cohorte',
            user: 'utilisateur',
            users: 'utilisateurs',
            assigned: 'assignés',
            edit_profile: 'Modifier le profil',
            profile_updated_successfully: 'Profil mis à jour',
            profile_update_failed: 'Échec de la mise à jour du profil',
            filters: 'Filtres',
            activity_status: 'Statut d\'activité',
            all_users: 'Tous',
            active: 'Actifs',
            inactive: 'Inactifs',
            timeframe: 'Période',
            last_30_days: '30 derniers jours',
            last_60_days: '60 derniers jours',
            last_90_days: '90 derniers jours',
            all_levels: 'Tous les niveaux',
            membership: 'Adhésion',
            all_cohorts: 'Toutes les cohortes',
            cohort: 'Cohorte',
            last_active_at: 'Dernière activité',
            welcome_email: 'Email de bienvenue',
            email_not_sent: 'Non envoyé',
            email_pending: 'En attente',
            email_delivered: 'Délivré',
            email_bounced: 'Rebondi',
            email_failed: 'Échoué',
            never: 'Jamais',
            signup_document: "Document d'inscription",
            document_uploaded: 'Téléchargé',
            document_missing: 'Manquant',
            open_document: 'Ouvrir dans un nouvel onglet',
            loading_document: 'Chargement du document...',
            imported_csv_fields: 'Données importées (CSV)',
            imported_field: 'Champ',
            imported_value: 'Valeur',
            payment_links: 'Liens de paiement',
            create_payment_link: 'Créer un lien de paiement',
            pay_later_bookings: 'Réservations à payer plus tard',
            loading: 'Chargement…',
            no_payment_links_yet: 'Aucun lien de paiement pour l\'instant.',
            no_pay_later_bookings: 'Aucune réservation à payer plus tard.',
            payment_link_description: 'Description',
            payment_link_amount: 'Montant',
            payment_link_currency: 'Devise',
            payment_link_status: 'Statut',
            payment_link_created: 'Créé le',
            create_payment_link_modal_title: 'Créer un lien de paiement',
            payment_link_copy_share: 'Lien de paiement (copier et partager)',
            copy: 'Copier',
            amount: 'Montant',
            currency: 'Devise',
            description_optional: 'Description (optionnel)',
            amount_placeholder: 'ex. 25,00',
            description_placeholder: 'ex. Solde réservation terrain',
            close: 'Fermer',
            create_link: 'Créer le lien',
            payment_link_created_toast: 'Lien de paiement créé',
            payment_link_failed_toast: 'Échec de la création du lien de paiement',
            payment_link_invalid_amount_toast: 'Veuillez entrer un montant valide',
            copied_to_clipboard_toast: 'Copié dans le presse-papiers',
            court: 'Terrain',
            location: 'Lieu',
            start: 'Début',
            paid: 'Payé',
            unpaid: 'Impayé',
            can_book_courts: 'Peut réserver des terrains',
            can_use_pay_later: 'Peut utiliser la fonctionnalité "Payer plus tard"',
            status: 'Statut',
            status_archived: 'Archivé',
            status_active: 'Actif',
            payment_link_status_pending: 'En attente',
            payment_link_status_paid: 'Payé',
            payment_link_status_expired: 'Expiré',
            payment_link_expires: 'Expire le',
            no_users_found: 'Aucun utilisateur trouvé',
            error_loading: 'Erreur lors du chargement des données utilisateur. Veuillez réessayer.',
            details: 'Détails de l\'utilisateur',
        },
        calendar: {
            previous_day: 'Jour précédent',
            next_day: 'Jour suivant',
            weekly_calendar: "Calendrier hebdomadaire",
            available: 'Disponible',
            available_for_games: 'Disponible pour les matchs',
            available_for_coaching: 'Disponible pour le coaching',
            available_for_games_and_coaching: 'Disponible pour les matchs et le coaching',
            merge_availabilities: 'Fusionner les disponibilités',
            show_all_day: 'Montrer jour au complet',
            show_canceled_events: 'Afficher les matchs annulés',
            create_blockade_or_court_availability_modal: {
                blocked_court: 'Terrain bloqué',
                blockade_mode_title: 'Bloquer le terrain',
                add_availability_mode_title: 'Ajouter une disponibilité',
                blockade: 'Blocage',
                add_availability: 'Ajouter une disponibilité',
                admin_booking: 'Réserver pour un joueur',
            },
            games: 'Matchs',
            games_fully_booked: 'Matchs (Complets)',
            games_partially_booked: 'Matchs (Partiels)',
            coaching_sessions: 'Sessions de coaching',
            event: 'Événement',
            canceled: 'Annulé',
            has_orders: 'Commande(s)',
            neither: "Indisponible",
            unavailable: 'Réservé',
            toolbar: {
                next: 'Suivant',
                previous: 'Précédent',
                today: 'Aujourd\'hui',
                day: 'Jour',
                week: 'Semaine',
                month: 'Mois',
            },
            select_week: 'Sélectionner la semaine',
            export_to_csv: 'Exporter en CSV',
            export_success: 'Export téléchargé avec succès',
            export_empty: 'Aucun élément à exporter',
            export_col_type: 'Type',
            export_col_court: 'Terrain',
            export_col_start: 'Début',
            export_col_end: 'Fin',
            export_col_title: 'Titre',
            export_col_participants: 'Participants',
            export_col_status: 'Statut',
            export_type_game: 'Match',
            export_type_coaching: 'Coaching',
            export_type_blockade: 'Blocage',
            export_type_event: 'Événement',
            export_status_canceled: 'Annulé',
            loading: 'Chargement du calendrier…',
            error_loading: 'Échec du chargement de certains calendriers. Veuillez réessayer.',
        },
        analytics: {
            games: 'Matchs',
            game_hours: 'Heures de jeu',
            courts_usage: 'Utilisation des terrains',
            games_heatmap: 'Créaneaux des matchs',
            bookings: 'Réservations',
            revenue: 'Revenus',
            hours_booked: 'Heures réservées',
            subscriptions: 'Abonnements',
            user_levels_distribution: 'Distribution des niveaux',
            game_type_distribution: 'Distribution des types de match',
            ranked_public: 'Classé Public',
            ranked_private: 'Classé Privé',
            unranked_public: 'Non classé Public',
            unranked_private: 'Non classé Privé',
            no_games_yet: 'Aucun match pour le moment',
            no_games_yet_subtitle: 'Les matchs apparaîtront ici une fois que les joueurs commenceront à réserver.',
            no_games_match_filters: 'Aucun match ne correspond à vos filtres',
            no_games_match_filters_subtitle: 'Essayez de modifier la plage de dates ou la sélection de terrains.',
            level: 'Niveau',
            vs_previous_24h: 'vs 24h précédentes',
            vs_previous_7_days: 'vs 7 jours précédents',
            vs_previous_30_days: 'vs 30 jours précédents',
            vs_previous_90_days: 'vs 90 jours précédents',
            selector: {
                time_range: 'Plage de dates',
                all_time: 'Tout le temps',
                last_month: 'Dernier mois',
                last_24_hours: 'Dernières 24 heures',
                last_7_days: 'Derniers 7 jours',
                last_30_days: 'Derniers 30 jours',
                last_90_days: 'Derniers 90 jours',
                custom: 'Personnalisé',
            },
            filters: {
                all_courts: 'Tous les terrains',
                courts: 'Terrains',
                all_sports: 'Tous les sports',
                sports: 'Sports',
                select_all: 'Tout sélectionner',
                deselect_all: 'Tout désélectionner',
                start_date: 'Date de début',
                end_date: 'Date de fin',
            },
        },
        impact: {
            title: 'Impact',
            subtitle: 'Les revenus que vous n\'auriez pas eus sans MySportSet',
            total_bookings: 'Réservations totales',
            self_service_bookings: 'Libre-service',
            self_service_hint: 'Réservations faites par les joueurs via l\'application',
            spots_recovered: 'Places récupérées',
            spots_recovered_hint: 'Annulations remplacées par d\'autres joueurs',
            recovered_revenue: 'Revenus récupérés',
            recovered_revenue_hint: 'Argent sauvé grâce aux remplacements',
            new_players: 'Nouveaux joueurs',
            total_revenue: 'Revenus totaux',
            growth_trajectory: 'Trajectoire de croissance',
            growth_trajectory_hint: 'Progression hebdomadaire depuis le premier jour',
            top_players: 'Meilleurs joueurs par revenu',
            top_players_hint: 'Vos membres les plus fidèles',
            export_pdf: 'Exporter PDF',
            no_data: 'Pas encore assez de données',
            no_data_hint: 'Les données apparaîtront au fur et à mesure de l\'utilisation de MySportSet',
            no_location: 'Sélectionnez une location pour voir vos métriques d\'impact',
            bookings_axis: 'Réservations',
            revenue_axis: 'Revenus (€)',
            new_players_axis: 'Nouveaux joueurs',
            week: 'Semaine',
            bookings: 'réservations',
            homepage_widget_title: 'Impact MySportSet',
        },
        sportPicker: {
            select: 'Selectionnez les sports',
            unit: 'sports',
            search: 'Rechercher un sport',
            no_results: 'Aucun sport trouvé'
        },
        selected: 'Selectionné',
        multiple_selected: 'Selectionnés',
        dayPicker: {
            daysSelected: 'Jours',
            selectDays: 'Selectionnez jours',
            selectHours: 'Select Hours',
            selectMinutes: 'Select Minutes',
            selectDaysOfWeek: 'Selectionnez jours',
            selectedDays: 'Jours',
            selectAll: 'Tout sélectionner',
            deselectAll: 'Tout désélectionner',
            daysOfWeek: {
                'Sun': 'Dimanche',
                'Mon': 'Lundi',
                'Tue': 'Mardi',
                'Wed': 'Mercredi',
                'Thu': 'Jeudi',
                'Fri': 'Vendredi',
                'Sat': 'Samedi',
            }
        },
        access_codes: {
            title: "Codes d'accès",
            intro: "Définissez un code à 4 chiffres par terrain. Les joueurs le voient uniquement avant le début de leur match et pendant une courte période après la fin.",
            reveal_lead_label: 'Affichage (minutes avant le début)',
            reveal_lead_hint: 'Combien de minutes avant le début d\'un match le code devient visible pour les participants. Par défaut : 120.',
            grace_label: 'Tolérance (minutes après la fin)',
            grace_hint: 'Combien de minutes après la fin le code reste visible. Par défaut : 30.',
            notify_lead_label: 'Notifier le code (minutes avant le début)',
            notify_lead_hint: 'Envoyer à chaque joueur une notification avec le code d\'accès ce nombre de minutes avant son match. Laisser vide pour désactiver.',
            court: 'Terrain',
            code: 'Code',
            last_updated: 'Dernière mise à jour',
            save_all: 'Tout enregistrer',
            saved: "Codes d'accès enregistrés",
            randomize: 'Générer un code aléatoire',
            no_courts: 'Aucun terrain dans cette organisation.',
            no_organization: 'Sélectionnez une organisation pour gérer les codes.',
            feature_disabled: "Les codes d'accès sont désactivés pour cette organisation.",
        },
        auth: {
            logout: 'Se déconnecter',
            signin: 'Se connecter',
            signup: 'S\'inscrire',
            email: 'Email',
            password: 'Mot de passe',
            forgot_password: 'Mot de passe oublié',
            forgot_password_description: 'Entrez-votre adresse mail. Nous vous enverrons un email de réinitialisation',
            forgot_password_cta: 'Envoyer email de réinitialisation',
            forgot_password_success: 'Un email de réinitialisation a été envoyé à votre adresse email',
            enter_info_to_sign_in: 'Entrez votre email et votre mot de passe pour vous connecter !',
            enter_magic_code: 'Entrez le code qui vous a été envoyé par email',
            first_name: 'Prénom',
            last_name: 'Nom de famille',
            not_registered_yet: 'Pas encore de compte?',
            create_an_account_cta: 'Enregistrez-vous',
            back_to_signin: 'Retour à la connexion',
            sign_in_error_message: "Nous n'avons pas pu vous connecter. Veuillez vérifier vos identifiants et réessayer.",
            accept_invitation: 'Accepter l\'invitation',
            accept_invitation_description: 'Entrez votre email et votre mot de passe pour rejoindre l\'organisation !',
            accept_invitation_error: 'Impossible d\'accepter l\'invitation. Veuillez réessayer.',
            accept_invitation_signed_in_description: 'Vous êtes connecté en tant que {email}. Un clic et vous rejoignez l\'organisation — aucun nouveau mot de passe requis.',
            accept_invitation_wrong_account: 'Cette invitation a été envoyée à {email}, mais vous êtes connecté en tant que {currentEmail}. Déconnectez-vous, puis connectez-vous avec le compte invité pour l\'accepter.',
            accept_invitation_account_exists: 'Un compte avec cet email existe déjà. Connectez-vous avec ce compte, puis rouvrez le lien d\'invitation pour rejoindre en un clic.',
            accept_invitation_success: 'Invitation acceptée — bienvenue !',
            join_organization: 'Rejoindre l\'organisation',
            sign_in_with_google: 'Se connecter avec Google',
            or: 'ou',
            sign_up_error_message: 'Impossible de créer votre compte. Veuillez réessayer.',
            forgot_password_error: 'Impossible d\'envoyer l\'email de réinitialisation. Veuillez réessayer.',
            change_password: 'Changer de mot de passe',
            change_password_description: 'Saisissez votre mot de passe actuel, puis choisissez-en un nouveau. Vos autres appareils seront déconnectés.',
            change_password_current: 'Mot de passe actuel',
            change_password_new: 'Nouveau mot de passe',
            change_password_confirm: 'Confirmer le nouveau mot de passe',
            change_password_cta: 'Mettre à jour',
            change_password_toggle_visibility: 'Afficher ou masquer {field}',
            change_password_success: 'Votre mot de passe a été mis à jour.',
            change_password_error: 'Impossible de mettre à jour votre mot de passe. Veuillez réessayer.',
            change_password_wrong_current: 'Votre mot de passe actuel est incorrect.',
            change_password_too_short: 'Votre nouveau mot de passe doit contenir au moins 7 caractères.',
            change_password_too_long: 'Votre nouveau mot de passe ne doit pas dépasser 1024 caractères.',
            change_password_same_as_current: 'Votre nouveau mot de passe doit être différent de l\'actuel.',
            change_password_mismatch: 'Les deux mots de passe ne correspondent pas.',
            change_password_too_many_requests: 'Trop de tentatives. Patientez quelques minutes puis réessayez.',
            change_password_network_error: 'Erreur réseau. Vérifiez votre connexion et réessayez.',
            change_password_session_expired: 'Votre session a expiré. Rechargez la page et réessayez.',
            change_password_account_disabled: 'Ce compte a été désactivé. Contactez votre administrateur.',
            change_password_no_session: 'Impossible de vérifier votre session. Rechargez la page et réessayez.',
            change_password_no_password_provider: 'Ce compte ne se connecte pas avec un mot de passe. Utilisez l\'email de réinitialisation.'
        },
        pricing: {
            'court_hourly_pricing': 'Tarification horaire',
            day_header: 'Jour',
            start: 'Début',
            picker: 'Sélecteur d\'heure',
            end: 'Fin',
            participant_count: 'Nombre de participants',
            price: 'Prix',
            currency: 'Devise',
            invalid_participant_count: 'Doit être un nombre valide',
        },
        coachPricing: {
            number_of_allowed_participants: 'Nombre de participants',
            hourly_fees: 'Tarification horaire',
            sport: 'Sport',
        },
        title: 'Titre',
        delete: 'Effacer',
        submit: 'Sauvegarder',
        validate: 'Valider',
        cancel: 'Annuler',
        close: 'Fermer',
        add_new: '+',
        save: 'Sauvegarder',
        create: 'Créer',
        add: 'Ajouter',
        remove: 'Enlever',
        error: 'Erreur',
        no_data: 'Aucune donnée',
        upload_image: 'Changer de photo',
        hours: 'Heures',
        minutes: 'minutes',
        form: {
            cannot_be_empty: 'Ne peut pas être vide',
            must_be_number: 'Doit être un nombre valide',
            must_be_valid_date: 'Doit être une date valide',
        },
        invalid_pricing: 'Veuillez entrer une tarification valide',
        availabilities_edited_successfully: 'Créneaux enregistrés avec succès',
        modified_successfully: 'Modifié avec succès',
        court_configuration: {
            title: 'Configurations du Terrain',
            create_new: 'Créer une Nouvelle Configuration',
            no_configurations: 'Aucune configuration trouvée',
            loading: 'Chargement des configurations...',
            form: {
                is_applied_to_all_time: 'Appliquer en permanence',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                rules: 'Règles',
                add_rule: 'Ajouter une règle',
                remove_rule: 'Supprimer la règle',
                price: 'Prix',
                price_duration: 'Durée (minutes)',
                days_of_week: 'Jours de la semaine',
                start_time: 'Heure de début',
                end_time: 'Heure de fin',
                currency: 'Devise',
                minutes: 'minutes'
            }
        },
        days: {
            '0': 'Dim',
            '1': 'Lun',
            '2': 'Mar',
            '3': 'Mer',
            '4': 'Jeu',
            '5': 'Ven',
            '6': 'Sam'
        },
        time_windows: {
            groups: 'Groupes de Créneaux',
            create_group: 'Créer un Groupe',
            delete_group: 'Supprimer le Groupe',
            add_window: 'Ajouter un Créneau',
            start_time: 'Heure de Début',
            end_time: 'Heure de Fin',
            start_time_required: 'L\'heure de début est requise',
            end_time_required: 'L\'heure de fin est requise',
            end_time_after_start: 'L\'heure de fin doit être après l\'heure de début',
            group_name: 'Nom',
            group_name_required: 'Le nom est requis',
            group_name_placeholder: 'ex: Heures creuses, Heures de pointe, etc.',
            loading: 'Chargement...',
            time_range: 'Plage Horaire',
            no_groups: 'Aucun groupe de créneaux. Créez-en un pour commencer.',
            error_loading: 'Échec du chargement des créneaux.',
            save_error: 'Échec de la sauvegarde des créneaux.',
            create_group_error: 'Échec de la création du groupe.',
            delete_group_error: 'Échec de la suppression du groupe.',
            group_deleted: 'Groupe supprimé.',
            confirm_delete_group: 'Êtes-vous sûr de vouloir supprimer ce groupe ?',
        },
        game: {
            details: 'Détails du match',
            not_found: 'Match introuvable',
            not_found_description: 'Ce match n\'a pas pu être chargé. Il a peut-être été supprimé, ou le lien est invalide.',
            payments: 'Paiements',
            participants: 'Participants',
            orders: 'Commandes',
            orders_error_loading: 'Erreur lors du chargement des commandes',
            orders_no_orders_found: 'Aucune commande trouvée pour ce match',
            orders_table_user: 'Utilisateur',
            orders_table_status: 'Statut',
            orders_table_amount: 'Montant',
            orders_table_items: 'Articles',
            orders_table_created: 'Créé',
            orders_status_paid: 'Payé',
            orders_status_pending: 'En Attente',
            orders_status_cancelled: 'Annulé',
            clear_cart: 'Vider le Panier',
            organizer: 'Organisateur',
            organiser: 'Organisateur',
            joined_at: 'Rejoint le',
            payment_status: 'Statut du paiement',
            payment_amount: 'Montant',
            game_info: 'Informations du match',
            start_time: 'Heure de début',
            duration: 'Durée',
            court: 'Terrain',
            sport: 'Sport',
            capacity: 'Capacité',
            status: 'Statut',
            type: 'Type',
            level_range: 'Niveau requis',
            no_participants: 'Aucun participant pour le moment',
            payment_completed: 'Payé',
            payment_pending: 'En attente',
            payment_no_record: 'Aucun paiement',
            payment_failed: 'Échoué',
            payment_cancelled: 'Annulé',
            payment_pay_later: 'Payer plus tard',
            payment_nextore: 'Nextore',
            payment_refunded: 'Remboursé',
            payment_refunding: 'Remboursement en cours',
            payment_wallet: 'Portefeuille',
            total_expected: 'Total attendu',
            total_paid: 'Total payé',
            total_pending: 'Total en attente',
            paid_by: 'Payé par',
            paid_by_details_title: 'Détails du paiement groupé',
            covered_player: 'Joueur couvert',
            covered_share_amount: 'Part couverte',
            stripe_payment_intent_id: 'ID PaymentIntent Stripe',
            charge_pay_later: 'Facturer la carte enregistrée',
            charge_pay_later_modal_title: 'Facturer la réservation à paiement différé',
            original_booking_amount: 'Montant de la réservation initiale',
            amount_to_charge: 'Montant à facturer',
            enter_amount: 'Saisir le montant',
            charge_custom_amount_hint: 'Vous pouvez facturer un montant personnalisé (par exemple, pour des paiements partiels ou des réductions)',
            charge_button: 'Facturer',
            mark_paid_card: 'Payé par CB',
            mark_paid_cash: 'Payé en espèces',
            mark_paid_confirm_title: 'Confirmer l\'encaissement',
            mark_paid_confirm_message: 'Marquer ce paiement comme encaissé ? Cette action est irréversible.',
            mark_paid_success: 'Paiement marqué comme encaissé',
            mark_paid_error: 'Impossible de marquer le paiement comme encaissé',
            mark_refunded: 'Marquer comme remboursé',
            mark_refunded_confirm: 'Marquer ce paiement manuel comme remboursé ? Cela confirme que le remboursement a été effectué en dehors de la plateforme.',
            mark_refunded_success: 'Paiement marqué comme remboursé',
            mark_refunded_error: 'Impossible de marquer le paiement comme remboursé',
            payment_manual_card: 'Encaissé — CB',
            payment_manual_cash: 'Encaissé — Espèces',
            actions: 'Actions',
            minutes: 'minutes',
            private: 'Privé',
            public: 'Public',
            ranked: 'Classé',
            unranked: 'Non classé',
            ranked_mode: 'Mode classé',
            upcoming: 'À venir',
            completed: 'Terminé',
            canceled: 'Annulé',
            latest_booked_games: 'Dernières Parties Réservées',
            game_id: 'ID de la Partie',
            booked_at: 'Réservé le',
            no_games_found: 'Aucune partie trouvée',
            error_loading_games: 'Erreur lors du chargement des parties. Veuillez réessayer.',
            please_select_organization: 'Veuillez sélectionner une organisation pour voir les parties.',
            page_of: 'Page',
            of: 'de',
            total: 'total',
            previous: 'Précédent',
            next: 'Suivant',
            click_row_to_view_details: 'Cliquez sur une ligne pour voir les détails de la partie',
            time_ago: {
                second: 'seconde',
                seconds: 'secondes',
                minute: 'minute',
                minutes: 'minutes',
                hour: 'heure',
                hours: 'heures',
                day: 'jour',
                days: 'jours',
                week: 'semaine',
                weeks: 'semaines',
                month: 'mois',
                months: 'mois',
                ago: 'il y a',
            },
            participation_status: 'Statut de Participation',
            current_participant: 'Participant Actuel',
            former_participant: 'Ancien Participant',
            full: 'Complet',
            spots_available: 'places disponibles',
            level: 'Niveau',
            covered_by: '{count} couvert·e·s par {payer}',
            covered_players: 'Joueurs couverts',
            remove_participant: 'Retirer le Participant',
            remove_participant_title: 'Retirer le Participant',
            remove_participant_message: 'Êtes-vous sûr de vouloir retirer',
            remove_participant_refund_info: 'Cette action retire le participant du match. Elle ne le rembourse PAS — s\'il a déjà payé, effectuez le remboursement séparément. Cette action ne peut pas être annulée.',
            participant_removed_not_refunded: 'Retiré. {amount} {currency} n\'ont PAS été remboursés — effectuez le remboursement séparément.',
            refund_seat: 'Rembourser la place',
            guest: 'Invité',
            awaiting_acceptance: 'En attente d\'acceptation',
            refund_seat_tooltip: 'Rembourser la place de ce joueur à la personne qui l\'a payée (remboursement carte via Stripe, ou crédits recrédités sur son portefeuille)',
            refund_seat_confirm: 'Rembourser la place de {name} ? L\'argent retourne sur la carte qui l\'a payée — celle du joueur, ou celle de l\'ami qui l\'a couvert. Cette action est irréversible.',
            refund_seat_confirm_wallet: 'Rembourser la place de {name} ? Elle a été payée avec des crédits : les crédits retournent sur le portefeuille de la personne qui l\'a payée — le joueur, ou l\'ami qui l\'a couvert. Cette action est irréversible.',
            refund_seat_success: 'Remboursement de la place en cours',
            refund_seat_success_description: '{amount} seront rendus au payeur ({count} remboursement(s)). Les remboursements par carte sont traités par Stripe en moins d\'une minute ; les paiements en crédits sont recrédités sur le portefeuille du payeur.',
            refund_seat_success_description_wallet: '{amount} seront recrédités sur le portefeuille du payeur ({count} remboursement(s)).',
            refund_seat_nothing: 'Rien à rembourser',
            refund_seat_error: 'Impossible de rembourser la place',
            remove_and_refund_seat: 'Rembourser aussi sa place',
            remove_and_refund_seat_hint: 'Si un ami a payé cette place, l\'argent retourne à cet ami (remboursement carte via Stripe, ou crédits recrédités sur son portefeuille).',
            fully_paid: 'Entièrement Payé',
            fully_paid_comped_locked: 'Les matchs offerts sont toujours considérés comme entièrement payés — l\'organisateur ne doit rien. Pour faire payer les participants, changez plutôt le type de match.',
            booking_code: 'Code de Réservation',
            payment_status_updated: 'Statut de Paiement Mis à Jour',
            payment_status_updated_paid: 'Match marqué comme entièrement payé',
            payment_status_updated_not_paid: 'Match marqué comme non payé',
            error_updating_payment_status: 'Erreur lors de la Mise à Jour du Statut de Paiement',
            edit_times: 'Modifier les Horaires',
            update_times: 'Mettre à Jour les Horaires',
            times_updated: 'Horaires du match mis à jour',
            times_updated_description: 'L\'heure de début et la durée du match ont été mises à jour avec succès',
            error_updating_times: 'Erreur lors de la mise à jour des horaires',
            edit_court: 'Modifier le Terrain',
            current_court: 'Terrain Actuel',
            new_court: 'Nouveau Terrain',
            updating_court: 'Mise à Jour du Terrain...',
            court_updated: 'Terrain mis à jour',
            court_updated_description: 'Le terrain du match a été mis à jour avec succès',
            error_updating_court: 'Erreur lors de la mise à jour du terrain',
            current: 'Actuel',
            cancel_edit: 'Annuler',
            cancel_game: 'Annuler et rembourser',
            canceling: 'Annulation...',
            canceled_successfully: 'Match Annulé avec Succès',
            game_has_been_canceled_refunds_processed: 'Le match a été annulé et les remboursements sont en cours de traitement',
            error_canceling_game: 'Erreur lors de l\'Annulation du Match',
            generate_replacement_link: 'Lien de remplacement',
            generating_replacement_link: 'Génération...',
            replacement_link_generated: 'Lien de remplacement généré',
            error_generating_replacement_link: 'Erreur lors de la génération du lien',
            replacement_link_confirm_title: 'Générer un lien de remplacement ?',
            replacement_link_confirm_message: 'Cela va annuler le match en cours et générer un lien de remplacement. Tous les participants seront notifiés de l\'annulation. Voulez-vous continuer ?',
            replacement_link_confirm_action: 'Oui, annuler et générer le lien',
            add_user: 'Ajouter un Utilisateur',
            add_user_to_game: 'Ajouter un Utilisateur au Match',
            add_user_to_game_description: 'Ajouter un utilisateur à ce match sans exiger de paiement. L\'utilisateur sera immédiatement ajouté comme participant.',
            select_user: 'Sélectionner un Utilisateur',
            select_user_placeholder: 'Rechercher et sélectionner un utilisateur...',
            user_added_successfully: 'Utilisateur Ajouté avec Succès',
            user_has_been_added_to_game: 'L\'utilisateur a été ajouté au match',
            error_adding_user: 'Erreur lors de l\'Ajout de l\'Utilisateur',
            no_users_found: 'Aucun utilisateur trouvé',
            search_users: 'Rechercher des utilisateurs...',
            selected_user: 'Utilisateur sélectionné',
            adding: 'Ajout en cours...',
            payment_charged_successfully: 'Paiement facturé avec succès',
            error_charging_payment: 'Erreur lors de la facturation du paiement',
            participant_removed_successfully: 'Participant retiré avec succès',
            failed_to_remove_participant: 'Impossible de retirer le participant',
            error_removing_participant: 'Erreur lors du retrait du participant',
            error_loading_details: 'Erreur lors du chargement des détails du match. Veuillez réessayer.',
            replacement_requests: 'Demandes de remplacement',
            no_replacement_requests: 'Aucune demande de remplacement pour ce match.',
            replacement_type_full_cancel: 'Annulation complète',
            replacement_type_participant_left: 'Participant parti',
            replacement_status_pending: 'En attente',
            replacement_status_fulfilled: 'Pourvu',
            replacement_status_expired: 'Expiré',
            replacement_status_canceled: 'Annulé',
            replacement_original_user: 'Original',
            replacement_replaced_by: 'Remplacé par',
            replacement_expires: 'Expire',
            replacement_fulfilled_at: 'Pourvu',
            refunds_title: 'Remboursements',
            no_refunds: 'Aucun remboursement pour ce match.',
            refund_status_successful: 'Réussi',
            refund_status_retry: 'Nouvel essai',
            refund_status_failed: 'Échoué',
            refund_reason: 'Raison',
            refund_processed_at: 'Traité',
            replacement_new_game: 'Nouveau match',
            replacement_copy_link: 'Copier le lien',
            replacement_link_copied: 'Lien de remplacement copié',
            replaced_from_game: 'Ce match a remplacé le Match',
            cancel_game_title: 'Annuler le match',
            // Conservé pour compat. avec d\'éventuels anciens appels ; ré-écrit
            // pour refléter le vrai comportement (pas de lien auto-généré).
            cancel_game_confirm: 'Le match sera annulé. Utilisez le bouton « Lien de remplacement » séparément si vous voulez proposer le créneau.',
            game_canceled: 'Match annulé',
            // Copie des trois politiques d\'annulation admin.
            cancel_and_refund: 'Annuler et rembourser',
            cancel_without_refund: 'Annuler sans remboursement',
            cancel_and_credit_wallets: 'Annuler et créditer les portefeuilles',
            cancel_and_refund_dialog_body: 'Annule le match et lance les remboursements Stripe pour chaque participant ayant payé. Les remboursements sont traités de façon asynchrone par le cron de retry et peuvent prendre quelques minutes à apparaître sur la carte.',
            cancel_without_refund_dialog_body: 'Annule le match sans émettre de remboursement. Les participants sont notifiés mais gardent le débit. Réservé aux no-show et cas similaires — à utiliser avec parcimonie.',
            cancel_and_credit_wallets_dialog_body: 'Annule le match et crédite le portefeuille de chaque participant ayant payé, à hauteur de la valeur équivalente au taux de crédit de l\'organisation. Aucun remboursement de carte n\'est émis ; les crédits sont utilisables sur les prochaines réservations.',
            cancel_dialog_pi_summary_title: 'Paiements concernés :',
            cancel_dialog_succeeded_label: 'payés (remboursés / crédités / conservés selon la politique)',
            cancel_dialog_requires_capture_label: 'autorisations en attente (seront annulées sur Stripe)',
            cancel_dialog_pay_later_label: 'pay-later (ne seront pas débités)',
            cancel_dialog_pos_label: 'POS / portefeuille POS (le caissier traite le remboursement manuellement)',
            cancel_dialog_manual_label: 'Encaissé sur place — CB/espèces (remboursement manuel par l\'admin)',
            cancel_reason_label: 'Raison',
            cancel_reason_placeholder: 'Choisir une raison (optionnel)',
            cancel_reason_no_show: 'No-show',
            cancel_reason_weather: 'Météo',
            cancel_reason_venue_issue: 'Problème de site',
            cancel_reason_admin_error: 'Erreur admin',
            cancel_reason_other: 'Autre',
            cancel_reason_text_placeholder: 'Décrivez la raison de l\'annulation... (obligatoire pour Autre)',
            cancel_disabled_tooltip: 'Déjà annulé avec une autre politique. Utilisez l\'action admin « annuler les remboursements » pour changer de politique.',
            game_canceled_no_refund_description: 'Le match a été annulé. Aucun remboursement n\'a été émis.',
            game_canceled_wallet_credit_description: 'Le match a été annulé et les participants ont été crédités sur leur portefeuille.',
        },
        admin_comments: {
            title: 'Commentaires',
            add_comment: 'Ajouter un Commentaire',
            edit_comment: 'Modifier le Commentaire',
            delete_comment: 'Supprimer le Commentaire',
            save_changes: 'Enregistrer les Modifications',
            delete: 'Supprimer',
            edit: 'Modifier',
            content: 'Commentaire',
            category: 'Catégorie',
            select_category: 'Sélectionner une catégorie (optionnel)',
            category_help: 'Choisir une catégorie pour organiser les commentaires',
            content_placeholder: 'Entrez votre commentaire ici...',
            all: 'Tous',
            no_comments: 'Aucun commentaire pour le moment. Ajoutez le premier commentaire pour suivre les informations importantes de cette partie.',
            no_comments_category: 'Aucun commentaire dans cette catégorie.',
            created_at: 'Créé',
            updated_at: 'Modifié',
            created_successfully: 'Commentaire ajouté avec succès',
            updated_successfully: 'Commentaire mis à jour avec succès',
            deleted_successfully: 'Commentaire supprimé avec succès',
            create_error: 'Échec de la création du commentaire',
            update_error: 'Échec de la mise à jour du commentaire',
            delete_error: 'Échec de la suppression du commentaire',
            load_error: 'Échec du chargement des commentaires',
            delete_warning: 'Cette action ne peut pas être annulée.',
            delete_confirmation: 'Êtes-vous sûr de vouloir supprimer ce commentaire ?',
            payment_external_tip: 'Utilisez cette catégorie pour suivre les paiements effectués en dehors de l\'application (espèces, virement bancaire, etc.). Incluez les détails comme le montant, le mode de paiement et la date.',
            payment_category: {
                payment_external: 'Paiement Externe',
                general: 'Général',
                issue: 'Problème',
                refund: 'Remboursement',
            },
        },
        coaching_session: {
            details: 'Détails de la Séance de Coaching',
            coach: 'Coach',
            student: 'Utilisateur',
            start_time: 'Heure de début',
            end_time: 'Heure de fin',
            duration: 'Durée',
            email: 'Email',
            level: 'Niveau',
            court: 'Terrain',
            coach_sports: 'Sports du Coach',
            minutes: 'minutes',
            status: 'Statut',
            upcoming: 'À venir',
            completed: 'Terminé',
            canceled: 'Annulé',
            cancel_session: 'Annuler la Séance',
            canceling: 'Annulation...',
            canceled_successfully: 'Séance annulée avec succès',
            session_has_been_canceled_refunds_processed: 'La séance de coaching a été annulée et les remboursements sont en cours de traitement.',
            error_canceling_session: 'Erreur lors de l\'annulation de la séance',
            error_loading: 'Erreur lors du chargement des détails de la séance de coaching. Veuillez réessayer.',
            edit_court: 'Modifier le Terrain',
            current_court: 'Terrain Actuel',
            new_court: 'Nouveau Terrain',
            updating_court: 'Mise à Jour du Terrain...',
            court_updated: 'Terrain mis à jour',
            court_updated_description: 'Le terrain de la séance de coaching a été mis à jour avec succès',
            error_updating_court: 'Erreur lors de la mise à jour du terrain de la séance de coaching',
            participants: 'Participants',
            error_loading_payment_intents: 'Erreur lors du chargement des intentions de paiement',
            no_payment_intents: 'Aucune intention de paiement trouvée',
            court_updated_successfully: 'Terrain mis à jour avec succès',
        },
        product: {
            name: 'Nom',
            description: 'Description',
            category: 'Catégorie',
            price: 'Prix',
            currency: 'Devise',
            stock: 'Stock',
            status: 'Statut',
            sports: 'Sports',
            location: 'Emplacement',
            image: 'URL de l\'image',
            create: 'Créer un produit',
            edit: 'Modifier le produit',
            name_placeholder: 'Entrez le nom du produit',
            description_placeholder: 'Entrez la description du produit',
            image_placeholder: 'Entrez l\'URL de l\'image',
            unlimited_stock: 'Stock illimité',
            associated_sports: 'Sports associés',
            cancel: 'Annuler',
            create_success: 'Produit créé avec succès',
            create_error: 'Erreur lors de la création du produit',
            update_success: 'Produit mis à jour avec succès',
            update_error: 'Erreur lors de la mise à jour du produit',
            location_required: 'L\'emplacement est requis',
            select_location_message: 'Veuillez sélectionner un emplacement pour créer le produit',
            unknown_error: 'Erreur inconnue',
            select_new_image: 'Sélectionner une nouvelle image',
            current_image: 'Image actuelle :',
            categories: {
                EQUIPMENT: 'Équipement',
                BEVERAGES: 'Boissons',
                FOOD: 'Nourriture',
                ACCESSORIES: 'Accessoires',
                APPAREL: 'Vêtements',
            },
            status_active: 'Actif',
            status_inactive: 'Inactif',
            stock_unlimited: 'Illimité',
            stock_out_of_stock: 'Rupture de stock',
            actions: 'Actions',
            delete_confirm: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
            save: 'Sauvegarder',
            select_image: 'Sélectionner une image',
            remove: 'Supprimer',
            preview: 'Aperçu :',
            selected: 'Sélectionné :',
            new_image_preview: 'Aperçu de la nouvelle image :',
            delete_success: 'Produit supprimé avec succès',
            delete_error: 'Erreur lors de la suppression du produit',
            no_products: 'Aucun produit trouvé',
            error_loading: 'Erreur lors du chargement des produits. Veuillez réessayer.',
        },
        article: {
            articles: 'Articles',
            title: 'Titre',
            content: 'Contenu',
            author: 'Auteur',
            reading_time: 'Temps de lecture',
            status: 'Statut',
            published: 'Publié',
            draft: 'Brouillon',
            popular: 'Populaire',
            created_at: 'Créé le',
            show_unpublished: 'Afficher les non publiés',
            create: 'Créer un article',
            edit: 'Modifier l\'article',
            image_url: 'URL de l\'image',
            delete_success: 'Article supprimé avec succès',
            delete_error: 'Erreur lors de la suppression de l\'article',
            delete_confirm: 'Supprimer l\'article',
            delete_confirm_message: 'Êtes-vous sûr ? Cette action ne peut pas être annulée.',
            create_success: 'Article créé avec succès',
            update_success: 'Article mis à jour avec succès',
            error: 'Erreur',
            error_loading: 'Impossible de charger les articles',
            no_articles: 'Aucun article pour le moment. Créez votre premier article !',
            title_required: 'Le titre est requis',
            content_required: 'Le contenu est requis',
            title_placeholder: 'Entrez le titre de l\'article',
            content_placeholder: 'Entrez le contenu de l\'article',
            image_drop_hint: 'Glissez-déposez une image ici, ou cliquez pour sélectionner',
            select_image: 'Sélectionner une image',
            preview: 'Aperçu :',
            selected_file: 'Sélectionné',
        },
        sponsor: {
            sponsors: 'Sponsors',
            name: 'Nom',
            logo: 'Logo',
            website: 'Site Web',
            active: 'Actif',
            created_at: 'Créé le',
            show_inactive: 'Afficher les inactifs',
            create: 'Créer un sponsor',
            edit: 'Modifier le sponsor',
            delete_success: 'Sponsor supprimé avec succès',
            delete_error: 'Erreur lors de la suppression du sponsor',
            delete_confirm: 'Supprimer le sponsor',
            delete_confirm_message: 'Êtes-vous sûr ? Cette action ne peut pas être annulée.',
            create_success: 'Sponsor créé avec succès',
            update_success: 'Sponsor mis à jour avec succès',
            error: 'Erreur',
            name_required: 'Le nom est requis',
            drag_drop_logo: 'Glissez-déposez un logo ici, ou cliquez pour sélectionner',
            select_logo: 'Sélectionner un logo',
            preview: 'Aperçu :',
            selected_file: 'Sélectionné',
            error_loading: 'Impossible de charger les sponsors.',
            empty: 'Aucun sponsor trouvé.',
            name_placeholder: 'Entrez le nom du sponsor',
        },
        support: {
            support_requests: 'Demandes de Support',
            click_row_to_view_details: 'Cliquez sur une ligne pour voir les détails',
            submitted_at: 'Soumis le',
            user: 'Utilisateur',
            email: 'Email',
            phone_number: 'Numéro de téléphone',
            reason: 'Raison',
            message: 'Message',
            status: 'Statut',
            pending: 'En attente',
            resolved: 'Résolu',
            request_details: 'Détails de la demande',
            error_loading_requests: 'Erreur lors du chargement des demandes',
            no_requests_found: 'Aucune demande trouvée',
            reasons: {
                payment_issue: 'Problèmes de Paiement',
                booking_issue: 'Problèmes de Réservation',
                account_issue: 'Problèmes de Compte',
                technical_issue: 'Problèmes Techniques',
                refund_request: 'Demande de Remboursement',
                general_inquiry: 'Demande Générale',
                feedback: 'Commentaires',
                other: 'Autre',
            },
        },
        access_control: {
            title: "Contrôle d'accès",
            provider: 'Fournisseur',
            location: 'Emplacement',
            org_wide: "Toute l'organisation (tous les emplacements)",
            enabled: 'Activé',
            disabled: 'Désactivé',
            actions: 'Actions',
            add_config: 'Ajouter une configuration',
            edit_config: 'Modifier la configuration',
            config_saved: "Configuration de contrôle d'accès enregistrée",
            config_save_error: "Erreur lors de l'enregistrement de la configuration",
            load_error: "Erreur lors du chargement des configurations",
            no_configs_found: "Aucune configuration trouvée. Ajoutez-en une pour commencer.",
            door_mappings: 'Association des portes',
            court_id: 'ID du terrain',
            door_id: 'ID de la porte',
            add_mapping: 'Ajouter une association',
            remove_mapping: "Supprimer l'association",
            advanced_settings: 'Paramètres avancés (JSON)',
            advanced_settings_helper: "Paramètres spécifiques au fournisseur, stockés tels quels. Clés connues : \"timezone\" (ex. \"Europe/Paris\"), \"entryLeadMinutes\" (avance d'activation du code avant la réservation, défaut 15), \"exitGraceMinutes\" (validité après la fin, défaut 60).",
            settings_invalid_json: 'Les paramètres doivent être un JSON valide',
            credentials: 'Identifiants',
            credentials_set: 'Définis',
            credentials_missing: 'Non définis',
            set_credentials: 'Définir les identifiants',
            credentials_saved: 'Identifiants du fournisseur enregistrés',
            credentials_save_error: "Erreur lors de l'enregistrement des identifiants",
            credentials_write_only_warning:
                "Les identifiants sont en écriture seule : les valeurs existantes ne sont jamais affichées, et l'enregistrement les remplace entièrement.",
            credentials_missing_fields: 'Champs obligatoires manquants',
            credentials_json: 'Identifiants (JSON)',
            credentials_json_helper: "Clés/API tokens du fournisseur sous forme d'objet JSON, ex. { \"apiKey\": \"...\" }.",
            credentials_invalid_json: 'Les identifiants doivent être un objet JSON non vide',
            logs_title: "Journaux d'accès",
            player_passages_title: 'Passages Enzo Card',
            no_player_passages_found: "Aucun passage enregistré pour ce joueur pour l'instant",
            player: 'Joueur',
            occurred_at: 'Survenu le',
            event_type: "Type d'événement",
            filter_door_id: 'Filtrer par zone',
            all_event_types: "Tous les types d'événements",
            error_loading_logs: "Erreur lors du chargement des journaux",
            no_logs_found: 'Aucun journal trouvé',
            event_entry: 'Entrée',
            event_exit: 'Sortie',
            event_denied: 'Refusé',
            event_forced: 'Forcé',
            game_codes_title: "Codes d'accès",
            credential_player: 'Joueur',
            credential_code: 'Code',
            credential_status: 'Statut',
            credential_valid_from: 'Valide à partir de',
            credential_valid_until: "Valide jusqu'à",
            credential_unknown_player: 'Joueur inconnu',
            credential_status_active: 'Actif',
            credential_status_used: 'Utilisé',
            credential_status_revoked: 'Révoqué',
            credential_status_expired: 'Expiré',
            code_no_longer_available: 'Plus disponible',
            copy_code: 'Copier le code',
            code_copied: 'Copié',
            no_usable_credentials: "Aucun code utilisable pour cette réservation — tous les codes émis ont été révoqués ou ont expiré.",
            show_credential_history: 'Afficher les codes révoqués/expirés ({count})',
            hide_credential_history: 'Masquer les codes révoqués/expirés',
            error_loading_credentials: "Erreur lors du chargement des codes d'accès",
        },
        notification: {
            title: 'Notifications',
            subtitle: 'Cliquez sur une ligne pour voir les détails',
            date: 'Date',
            recipient: 'Destinataire',
            type: 'Type',
            message: 'Message',
            status: 'Statut',
            read: 'Lu',
            unread: 'Non lu',
            details: 'Détails de la notification',
            triggered_by: 'Déclenché par',
            all_types: 'Tous les types',
            search_placeholder: 'Rechercher par nom ou email...',
            url: 'URL',
            error_loading: 'Erreur lors du chargement des notifications',
            no_notifications: 'Aucune notification trouvée',
            types: {
                userJoinedGame: 'Partie rejointe',
                userRequestedToJoinGame: 'Demande de participation',
                userInvitedToJoinGame: 'Invitation à une partie',
                userApprovedRequestToJoinGame: 'Demande acceptée',
                userCreatedGame: 'Partie créée',
                userCanceledGame: 'Partie annulée',
                userLeftGame: 'Partie quittée',
                userApprovedInvitationToJoinGame: 'Invitation acceptée',
                timeSlotAvailable: 'Créneau disponible',
                eventCreated: 'Événement créé',
                userJoinedEvent: 'Événement rejoint',
                cohortNotification: 'Cohorte',
            },
        },
        campaign: {
            campaigns: 'Campagnes',
            create_campaign: 'Créer une Campagne',
            name: 'Nom',
            name_placeholder: 'ex. Relancer les utilisateurs inactifs',
            status: 'Statut',
            rules: 'Règles',
            schedule: 'Planification',
            next_run: 'Prochaine exécution',
            last_run: 'Dernière exécution',
            actions: 'Actions',
            delete: 'Archiver la Campagne',
            delete_confirm: 'Êtes-vous sûr de vouloir archiver "{name}" ?',
            deleted_successfully: 'Campagne archivée avec succès',
            delete_error: 'Erreur lors de l\'archivage de la campagne',
            notification_title: 'Titre de la Notification',
            notification_title_placeholder: 'ex. Vous nous manquez !',
            notification_body: 'Corps de la Notification',
            notification_body_placeholder: 'ex. Hey {{firstName}}, revenez jouer !',
            template_hint: 'Utilisez {{firstName}} et {{lastName}} pour la personnalisation',
            frequency: 'Fréquence',
            daily: 'Quotidien',
            weekly: 'Hebdomadaire',
            day_of_week: 'Jour de la Semaine',
            monday: 'Lundi',
            tuesday: 'Mardi',
            wednesday: 'Mercredi',
            thursday: 'Jeudi',
            friday: 'Vendredi',
            saturday: 'Samedi',
            sunday: 'Dimanche',
            hour: 'Heure',
            timezone: 'Fuseau horaire',
            add_rule: 'Ajouter une Règle',
            rule_inactive_days: 'Inactif depuis',
            rule_no_game_days: 'Pas de match depuis',
            rule_no_event_days: 'Pas d\'événement depuis',
            days: 'jours',
            day: 'Jour',
            create: 'Créer',
            validation_error: 'Veuillez remplir tous les champs requis',
            created_successfully: 'Campagne créée avec succès',
            create_error: 'Erreur lors de la création de la campagne',
            updated_successfully: 'Campagne mise à jour avec succès',
            update_error: 'Erreur lors de la mise à jour de la campagne',
            activate: 'Activer',
            pause: 'Mettre en pause',
            resume: 'Reprendre',
            archive: 'Archiver',
            preview_audience: 'Aperçu de l\'Audience',
            back_to_campaigns: 'Retour aux Campagnes',
            execution_history: 'Historique des Exécutions',
            date: 'Date',
            audience_size: 'Audience',
            sent: 'Envoyés',
            failed: 'Échoués',
            no_campaigns: 'Aucune campagne pour le moment. Créez-en une pour commencer.',
            no_executions: 'Aucune exécution pour le moment. Activez la campagne pour commencer l\'envoi.',
            overlap_warning: 'Chevauchement d\'audience',
            users_also_in: '{count} utilisateurs aussi ciblés par "{name}"',
            analytics: 'Analytique de Campagne',
            total_sent: 'Total Envoyés',
            total_opened: 'Total Ouverts',
            total_conversions: 'Total Conversions',
            conversion_rate: 'Taux de Conversion',
            coupon_redeemed: 'Coupons Utilisés',
            total_failed: 'Total Échoués',
            opened: 'Ouverts',
            converted: 'Convertis',
            incentive: 'Incentive',
            incentive_none: 'Aucun',
            incentive_coupon: 'Coupon',
            incentive_credits: 'Crédits',
            select_coupon: 'Sélectionner un Coupon',
            credit_amount: 'Montant des Crédits',
            conversion_window: 'Fenêtre de Conversion',
            conversion_window_24h: '24 heures',
            conversion_window_48h: '48 heures',
            conversion_window_72h: '72 heures (par défaut)',
            conversion_window_7d: '7 jours',
            one_time: 'Ponctuel',
            run_at: 'Date d\'exécution',
            error_loading: 'Erreur lors du chargement des données de la campagne',
            remove_rule: 'Supprimer la règle',
        },
        coupon: {
            coupons: 'Coupons',
            create_coupon: 'Créer un Coupon',
            create_first_coupon: 'Créer votre premier coupon',
            no_coupons: 'Aucun coupon pour le moment. Créez-en un pour commencer.',
            name: 'Nom',
            name_placeholder: 'ex. Bienvenue -50%',
            discount: 'Remise',
            discount_type: 'Type de Remise',
            discount_type_percentage: 'Pourcentage (%)',
            discount_type_fixed: 'Montant Fixe',
            discount_value: 'Valeur de la Remise',
            discount_value_percentage: 'Valeur de la Remise (%)',
            currency: 'Devise',
            select_currency: 'Sélectionner la devise',
            applicable_to: 'Applicable à',
            applicable_court_booking: 'Réservation de Terrain',
            applicable_game_joining: 'Rejoindre un Match',
            applicable_event_joining: 'Rejoindre un Événement',
            applicable_coaching_session: 'Séance de Coaching',
            expires_at: 'Expire le',
            max_usage_per_user: 'Utilisations Max par Utilisateur',
            max_uses: 'Utilisations Max',
            assigned_used: 'Attribués / Utilisés',
            used_attributed: 'Utilisés / Attribués',
            actions: 'Actions',
            create: 'Créer',
            loading: 'Chargement...',
            // Validation
            name_required: 'Le nom est requis',
            discount_value_required: 'La valeur de la remise doit être supérieure à 0',
            discount_value_max_percentage: 'Le pourcentage ne peut pas dépasser 100',
            currency_required: 'La devise est requise pour les remises à montant fixe',
            expiry_required: 'La date d\'expiration est requise',
            applicable_to_required: 'Sélectionnez au moins un type applicable',
            // Create
            created_successfully: 'Coupon créé avec succès',
            create_error: 'Erreur lors de la création du coupon',
            // Delete
            delete_coupon: 'Supprimer le Coupon',
            delete_confirm: 'Êtes-vous sûr de vouloir supprimer "{name}" ? Cette action est irréversible.',
            deleted_successfully: 'Coupon supprimé avec succès',
            delete_error: 'Erreur lors de la suppression du coupon',
            // Assign
            assign_coupon: 'Attribuer le Coupon',
            assign_to: 'Attribuer "{name}"',
            search_users: 'Rechercher des Utilisateurs',
            search_by_name_or_email: 'Rechercher par nom ou email...',
            search: 'Rechercher',
            no_users_selected: 'Aucun utilisateur sélectionné',
            assign_to_users: 'Attribuer à {count} Utilisateur(s)',
            assigned_successfully: 'Coupon attribué à {count} utilisateur(s)',
            assign_error: 'Erreur lors de l\'attribution du coupon',
            // Detail page
            back_to_coupons: 'Retour aux Coupons',
            coupon_details: 'Détails du Coupon',
            assigned_users: 'Utilisateurs Attribués',
            no_assigned_users: 'Aucun utilisateur n\'a ce coupon',
            add_users: 'Attribuer des Utilisateurs',
            add_first_users: 'Attribuer vos premiers utilisateurs',
            user: 'Utilisateur',
            email: 'Email',
            usage: 'Utilisation',
            assigned_at: 'Attribué le',
            revoke: 'Révoquer',
            confirm_revoke_user: 'Êtes-vous sûr de vouloir révoquer ce coupon de',
            user_revoked_successfully: 'Coupon révoqué avec succès',
            revoke_failed: 'Échec de la révocation du coupon',
            expired: 'Expiré',
            uses_left: 'utilisations restantes',
            fully_used: 'Entièrement Utilisé',
            search_coupons: 'Rechercher des Coupons',
            search_by_name: 'Rechercher par nom de coupon...',
            no_coupons_found: 'Aucun coupon trouvé',
            no_active_coupons: 'Aucun coupon actif disponible',
            no_coupons_selected: 'Veuillez sélectionner au moins un coupon',
            coupons_selected: 'coupon(s) sélectionné(s)',
            expires: 'Expire',
        },
        credit_pack: {
            credit_packs: 'Packs de Crédits',
            create_pack: 'Créer un Pack',
            edit_pack: 'Modifier le Pack',
            delete_pack: 'Supprimer le Pack',
            no_packs: 'Aucun pack de crédits. Créez-en un pour commencer.',
            name: 'Nom',
            name_placeholder: 'ex. Pack Gold',
            price: 'Prix (EUR)',
            credits: 'Crédits',
            sort_order: 'Ordre',
            active: 'Actif',
            actions: 'Actions',
            edit: 'Modifier',
            delete: 'Supprimer',
            create: 'Créer',
            save: 'Enregistrer',
            name_required: 'Le nom est requis',
            price_required: 'Le prix doit être supérieur à 0',
            credits_required: 'Les crédits doivent être supérieurs à 0',
            created_successfully: 'Pack de crédits créé avec succès',
            create_error: 'Erreur lors de la création du pack',
            updated_successfully: 'Pack de crédits mis à jour avec succès',
            update_error: 'Erreur lors de la mise à jour du pack',
            deleted_successfully: 'Pack de crédits supprimé avec succès',
            delete_error: 'Erreur lors de la suppression du pack',
            delete_confirm: 'Êtes-vous sûr de vouloir supprimer "{name}" ? Cette action est irréversible.',
            activated: 'Pack de crédits activé',
            deactivated: 'Pack de crédits désactivé',
            conversion_rate: 'Taux de conversion',
            conversion_rate_saved: 'Taux de conversion enregistré',
            load_error: 'Échec du chargement des packs de crédits. Veuillez réessayer plus tard.',
            pricing: 'Tarification',
            display: 'Affichage',
        },
        cohort: {
            cohorts: 'Cohortes',
            cohort: 'Cohorte',
            name: 'Nom',
            description: 'Description',
            members: 'Membres',
            members_count: 'membres',
            member_count: 'membres',
            created_at: 'Créé le',
            actions: 'Actions',
            loading: 'Chargement...',
            not_found: 'Cohorte introuvable ou erreur de chargement',
            no_cohorts: 'Aucune cohorte trouvée',
            create_cohort: 'Créer une Cohorte',
            create_first_cohort: 'Créer votre première cohorte',
            create_new_cohort: 'Créer une Nouvelle Cohorte',
            cohort_name: 'Nom de la Cohorte',
            cohort_name_placeholder: 'ex. Membres Premium, Joueurs Avancés',
            description_optional: 'Description (Optionnelle)',
            description_placeholder: 'Entrez une description pour cette cohorte...',
            name_required: 'Le nom de la cohorte est requis',
            create: 'Créer',
            created_successfully: 'Cohorte créée avec succès',
            create_failed: 'Échec de la création de la cohorte',
            confirm_delete: 'Êtes-vous sûr de vouloir supprimer',
            deleted_successfully: 'Cohorte supprimée avec succès',
            delete_failed: 'Échec de la suppression de la cohorte',
            no_members: 'Aucun membre dans cette cohorte',
            add_users: 'Ajouter des Utilisateurs',
            add_first_users: 'Ajouter vos premiers utilisateurs',
            back_to_cohorts: 'Retour aux Cohortes',
            loading_members: 'Chargement des membres...',
            user: 'Utilisateur',
            email: 'Email',
            added_at: 'Ajouté le',
            confirm_remove_user: 'Êtes-vous sûr de vouloir retirer',
            user_removed_successfully: 'Utilisateur retiré avec succès',
            remove_user_failed: 'Échec du retrait de l\'utilisateur',
            add_users_to_cohort: 'Ajouter des Utilisateurs à la Cohorte',
            search_users: 'Rechercher des Utilisateurs',
            search_by_name_or_email: 'Rechercher par nom ou email...',
            select_all: 'Tout Sélectionner',
            no_users_found: 'Aucun utilisateur trouvé',
            users_selected: 'utilisateurs sélectionnés',
            add_selected_users: 'Ajouter les Utilisateurs Sélectionnés',
            no_users_selected: 'Aucun utilisateur sélectionné',
            users_added_successfully: 'Utilisateurs ajoutés à la cohorte avec succès',
            added: 'ajoutés',
            skipped: 'déjà dans la cohorte',
            add_users_failed: 'Échec de l\'ajout des utilisateurs',
            send_notification: 'Envoyer une Notification',
            send_notification_to_cohort: 'Envoyer une Notification à la Cohorte',
            notification_title: 'Titre',
            notification_title_placeholder: 'ex. Annonce de Nouveau Tournoi',
            notification_body: 'Message',
            notification_body_placeholder: 'Entrez votre message de notification...',
            notification_url_optional: 'URL de Lien Profond (Optionnelle)',
            notification_url_placeholder: 'ex. /events/123',
            title_required: 'Le titre est requis',
            body_required: 'Le message est requis',
            send: 'Envoyer',
            notification_sent_successfully: 'Notification envoyée avec succès',
            sent: 'envoyées',
            failed: 'échouées',
            send_notification_failed: 'Échec de l\'envoi de la notification',
            select_cohort_for_users: 'Sélectionner une Cohorte pour les Utilisateurs',
            select_cohort: 'Sélectionner une Cohorte',
            choose_cohort: 'Choisissez une cohorte...',
            add_to_cohort: 'Ajouter à une Cohorte',
            no_cohort_selected: 'Veuillez sélectionner une cohorte',
            remove_from_cohort: 'Retirer de la cohorte',
            no_cohorts_for_user: 'Aucune cohorte',
            assign_coupons: 'Attribuer des Coupons',
            assign_coupons_to: 'Attribuer des Coupons à',
            coupons_assigned_successfully: 'Coupons attribués avec succès',
            assign_coupons_failed: 'Échec de l\'attribution des coupons',
            error_loading_members: 'Erreur lors du chargement des membres de la cohorte. Veuillez réessayer.',
            remove_user: 'Retirer l\'utilisateur',
            edit_cohort: 'Modifier la cohorte',
            delete_cohort: 'Supprimer la cohorte',
            error_loading: 'Erreur lors du chargement des cohortes. Veuillez réessayer.',
        },
        churn_prediction: {
            title: 'Prédiction d\'attrition',
            recompute: 'Recalculer les scores',
            recompute_success: 'Scores d\'attrition recalculés avec succès',
            recompute_error: 'Échec du recalcul des scores d\'attrition',
            empty_state: 'Aucun score d\'attrition calculé. Cliquez sur "Recalculer les scores" pour générer les prédictions.',
            score_distribution: 'Distribution des scores',
            smart_cohorts: 'Cohortes intelligentes',
            users: 'Utilisateurs à risque',
            tier_safe: 'Sûr',
            tier_watch: 'Surveillance',
            tier_at_risk: 'À risque',
            tier_critical: 'Critique',
            all_tiers: 'Tous les niveaux',
            name: 'Nom',
            email: 'Email',
            score: 'Score',
            tier: 'Niveau',
            last_calculated: 'Dernier calcul',
            search_placeholder: 'Rechercher par nom ou email...',
            no_users: 'Aucun utilisateur trouvé',
            loading: 'Chargement...',
            members: 'membres',
            total: 'Total',
            overall_score: 'Score global d\'attrition',
            signal_booking_decline: 'Baisse de fréquence de réservation',
            signal_days_since_booking: 'Risque d\'inactivité',
            signal_payment_failure: 'Échec de paiement',
            signal_social_isolation: 'Isolation sociale',
            signal_subscription: 'Statut d\'abonnement',
            signal_cancellation: 'Taux d\'annulation',
            signal_wallet_depletion: 'Épuisement du portefeuille',
            signal_yes: 'Oui',
            signal_no: 'Non',
            signal_sub_active: 'Actif',
            signal_sub_none: 'Aucun',
            signal_sub_past_due: 'En retard',
            signal_sub_canceled: 'Annulé',
            previous: 'Précédent',
            next: 'Suivant',
            page: 'Page',
            of: 'sur',
            cohort_churn_watch_name: 'Attrition : Surveillance',
            cohort_churn_watch_desc: 'Utilisateurs montrant des signes de désengagement',
            cohort_churn_at_risk_name: 'Attrition : À risque',
            cohort_churn_at_risk_desc: 'Utilisateurs avec un risque significatif de départ',
            cohort_churn_critical_name: 'Attrition : Critique',
            cohort_churn_critical_desc: 'Utilisateurs très susceptibles de partir sans intervention',
            cohort_power_users_name: 'Utilisateurs actifs',
            cohort_power_users_desc: 'Utilisateurs avec 8+ réservations au cours des 30 derniers jours',
            cohort_new_users_name: 'Nouveaux utilisateurs',
            cohort_new_users_desc: 'Utilisateurs inscrits au cours des 30 derniers jours',
            cohort_social_connectors_name: 'Connecteurs sociaux',
            cohort_social_connectors_desc: 'Utilisateurs avec 10+ connexions de suivi',
            cohort_lapsed_members_name: 'Membres inactifs',
            cohort_lapsed_members_desc: 'Utilisateurs dont l\'abonnement a expiré',
            cohort_weekend_warriors_name: 'Joueurs du week-end',
            cohort_weekend_warriors_desc: 'Utilisateurs jouant principalement le week-end (60%+)',
            cohort_payment_issues_name: 'Problèmes de paiement',
            cohort_payment_issues_desc: 'Utilisateurs avec des échecs de paiement récents',
            error_loading: 'Impossible de charger les données. Veuillez réessayer plus tard.',
        },
        transaction: {
            title: 'Transactions',
            search_placeholder: 'Rechercher par nom ou email...',
            all_statuses: 'Tous les statuts',
            all_methods: 'Toutes les méthodes',
            all_types: 'Tous les types',
            date_from: 'Du',
            date_to: 'Au',
            user: 'Utilisateur',
            type: 'Type',
            amount: 'Montant',
            collected: 'Encaissé',
            status: 'Statut',
            payment_method: 'Méthode de paiement',
            date: 'Date',
            export_csv: 'Exporter Page CSV',
            empty_state: 'Aucune transaction trouvée',
            error_loading: 'Impossible de charger les transactions. Veuillez réessayer plus tard.',
            succeeded: 'Réussie',
            pending: 'En attente',
            canceled: 'Annulée',
            refunded: 'Remboursée',
            refunding: 'Remboursement en cours',
            pay_later: 'Payer plus tard',
            method_stripe: 'Stripe',
            method_wallet: 'Portefeuille',
            method_pay_later: 'Payer plus tard',
            type_court_booking: 'Réservation de terrain',
            type_game_joining: 'Rejoindre une partie',
            type_event: 'Événement',
            type_coaching: 'Coaching',
            type_credit_pack: 'Pack de crédits',
            type_unknown: 'Inconnu',
        },
        wallet_admin: {
            wallet: 'Portefeuille',
            balance: 'Solde',
            adjust_balance: 'Ajuster le solde',
            all_types: 'Tous les types',
            date: 'Date',
            type: 'Type',
            amount: 'Montant',
            balance_after: 'Solde après',
            description: 'Description',
            credit_pack: 'Pack de crédits',
            payment_id: 'ID paiement',
            no_transactions: 'Aucune transaction trouvée',
            page_info: 'Page {current} sur {total}',
            type_purchase: 'Achat',
            type_spend: 'Dépense',
            type_refund: 'Remboursement',
            type_admin_adjustment: 'Ajustement admin',
            type_campaign_incentive: 'Incentive campagne',
            type_achievement_reward: 'Récompense de réalisation',
            adjust_success: 'Solde ajusté avec succès',
            adjust_error: "Échec de l'ajustement du solde",
            reason: 'Motif',
            reason_placeholder: 'Décrivez la raison de cet ajustement',
            amount_hint: 'Positif pour créditer, négatif pour débiter',
            preview: 'Aperçu',
            debit_exceeds_balance: 'Le débit entraînerait un solde négatif',
            confirm_adjust: "Confirmer l'ajustement",
            grant_credits: 'Accorder des crédits',
            bulk_grant_success: 'Crédits accordés avec succès',
            bulk_grant_summary: '{success}/{total} utilisateurs crédités',
            bulk_grant_error: "Échec de l'attribution des crédits",
            errors: 'erreurs',
            error_loading: 'Erreur lors du chargement des transactions. Veuillez réessayer.',
        },
        user_history: {
            title: 'Historique',
            search_placeholder: 'Rechercher par montant ou libellé...',
            all_kinds: 'Tous les types',
            kind_payment: 'Paiement',
            kind_wallet: 'Wallet',
            kind_refund: 'Remboursement',
            kind_activity: 'Activité',
            all_methods: 'Toutes les méthodes',
            method_wallet: 'Wallet',
            method_card: 'Carte',
            method_manual: 'Manuel',
            method_free: 'Inclus',
            method_pay_later: 'À régler',
            date_from: 'Du',
            date_to: 'Au',
            col_date: 'Date',
            col_item: 'Élément',
            activity_date: 'pour le {date}',
            refund_original_date: 'sur le paiement du {date}',
            col_method: 'Méthode',
            col_amount: 'Montant',
            col_balance: 'Solde',
            col_status: 'Statut',
            export_csv: 'Exporter en CSV',
            export_error: "Échec de l'export de l'historique. Veuillez réessayer.",
            load_more: 'Charger plus',
            empty_state: 'Aucun historique trouvé',
            empty_state_first_use: 'Aucun mouvement pour le moment — les paiements, remboursements et mouvements wallet apparaîtront ici.',
            error_loading: "Échec du chargement de l'historique. Veuillez réessayer plus tard.",
            filter_chip_kind: 'Type : {value}',
            filter_chip_method: 'Méthode : {value}',
            filter_chip_date_from: 'Du {date}',
            filter_chip_date_to: 'Au {date}',
            detail_title: 'Détail de la transaction',
            activity_date_label: "Date de l'activité",
            refund_original_date_label: "Paiement d'origine",
            import_banner: "Historique disponible depuis l'import du {date} — les mouvements antérieurs à cette date ne sont pas disponibles.",
        },
        leaderboard: {
            title: 'Classement',
            rank: 'Rang',
            player: 'Joueur',
            level: 'Niveau',
            wins: 'Victoires',
            losses: 'Défaites',
            win_rate: 'Taux de victoire',
            trend: 'Tendance',
            players: 'joueurs',
            search_player: 'Rechercher un joueur...',
            loading: 'Chargement du classement...',
            empty: 'Pas encore de données de classement. Les joueurs apparaîtront ici après la finalisation des parties classées.',
            error_loading: 'Échec du chargement du classement. Veuillez réessayer plus tard.',
        },
        roadmap: {
            title: 'Feuille de route',
            subtitle: 'Suivez l’avancement des fonctionnalités demandées et à venir.',
            shared_title: 'Feuille de route produit',
            shared_subtitle: 'Ce sur quoi nous travaillons pour la plateforme.',
            client_title: 'Vos demandes',
            client_subtitle: 'L’avancement des fonctionnalités que votre club a demandées.',
            status_requested: 'Demandé',
            status_planned: 'Prévu',
            status_in_progress: 'En cours',
            status_done: 'Livré',
            loading: 'Chargement de la feuille de route...',
            error_loading: 'Échec du chargement de la feuille de route. Veuillez réessayer plus tard.',
            empty_shared: 'Aucune fonctionnalité publiée pour le moment. Revenez bientôt.',
            empty_client: 'Aucune demande en cours pour votre club.',
            column_empty: 'Rien ici pour l’instant',
            updated_at: 'Mis à jour le {date}',
            view_details: 'Détails',
            filter_by_label: 'Filtrer :',
            filter_clear: 'Effacer',
            mapping_title: 'Mappage roadmap',
            mapping_subtitle: 'Associez chaque organisation à son étiquette client Linear.',
            mapping_org: 'Organisation',
            mapping_label: 'Étiquette client Linear',
            mapping_unassigned: '— Non assignée —',
            mapping_saved: 'Mappage enregistré',
            mapping_save_error: 'Échec de l’enregistrement du mappage',
            mapping_no_labels: 'Aucune étiquette client Linear disponible. Vérifiez la clé API Linear et le groupe d’étiquettes « Client ».',
            mapping_restricted_title: 'Réservé aux super-admins',
            mapping_restricted_desc: 'Vous n’avez pas les droits nécessaires pour gérer le mappage roadmap.',
            mapping_deleted_label: 'Étiquette supprimée',
            select_org_title: 'Sélectionnez une organisation',
            select_org_desc: 'Choisissez une organisation pour afficher sa feuille de route.',
        },
        org_provisioning: {
            title: 'Préparer un club',
            subtitle: 'Crée en une fois l\'organisation, son compte Stripe, les terrains avec un an de créneaux tarifés, les coachs et les abonnements — prêts à montrer pendant l\'appel d\'onboarding. Tout reste modifiable ensuite.',
            restricted_title: 'Réservé aux superadmins',
            restricted_desc: 'Seuls les administrateurs de la plateforme peuvent préparer un club.',
            submit: 'Créer le club',
            submitting: 'Création…',
            error: 'Le club n\'a pas pu être créé',
            club: 'Club',
            name: 'Nom du club',
            admin_email: 'Email du gérant',
            admin_email_help: 'Optionnel. Laissez vide pour l\'ajouter depuis la page équipe pendant l\'appel.',
            admin_access_mode: 'Accès du gérant',
            admin_access_add: "Ajouter maintenant, sans e-mail — il crée son compte sur le dashboard",
            admin_access_invite: 'Envoyer une invitation par e-mail',
            admin_added: '{email} ajouté comme administrateur (aucun e-mail envoyé)',
            admin_sign_up_hint: "Envoyez à {email} ce lien pour créer son compte avec cette adresse : {url} — le club y sera. Tant qu'il ne s'est pas inscrit, quiconque s'inscrit avec cette adresse obtient l'accès admin.",
            address: 'Adresse',
            postal_code: 'Code postal',
            city: 'Ville',
            courts: 'Terrains',
            court_name: 'Nom du terrain',
            sport: 'Sport',
            outdoor: 'Extérieur',
            remove: 'Retirer',
            add_court: 'Ajouter un terrain',
            hours_and_prices: 'Horaires & tarifs',
            opening: 'Ouverture',
            closing: 'Fermeture (24:00 = minuit)',
            peak_start: 'Heures pleines en semaine dès',
            weekend_peak: 'Week-end en heures pleines toute la journée',
            slot_length: '{sport} — durée du créneau',
            off_peak_price: 'Prix heures creuses par terrain (€)',
            peak_price: 'Prix heures pleines par terrain (€)',
            prices_help: 'Les prix s\'entendent pour le terrain entier et un créneau. Les horaires doivent tomber sur des créneaux entiers.',
            coaches: 'Coachs',
            first_name: 'Prénom',
            last_name: 'Nom',
            hourly_rate: 'Tarif horaire (€)',
            add_coach: 'Ajouter un coach',
            memberships: 'Abonnements',
            offer_name: 'Nom de l\'offre',
            monthly_price: '€ / mois',
            commitment: 'Engagement',
            commitment_months: '{months} mois',
            court_discount: 'Remise terrain (%)',
            add_membership: 'Ajouter une offre',
            memberships_help: 'Les joueurs pourront souscrire une fois l\'onboarding Stripe du club terminé. L\'offre gratuite « Default » est toujours créée.',
            success_title: '{name} est prêt',
            provision_another: 'Préparer un autre club',
            open_organization: 'Ouvrir ce club',
            open_fallback: 'Sélectionnez le nouveau club dans le sélecteur d\'organisation.',
            result_stripe: 'Compte Stripe',
            result_invitation: 'Invitation admin',
            invitation_sent: 'Envoyée à {email}',
            invitation_failed: 'Non envoyée — voir l’avertissement ci-dessus',
            invitation_skipped: 'Non envoyée — invitez le gérant depuis la page équipe',
            result_court: '{name} ({sport}) — {count} créneaux',
            result_membership: '{name} — {price} € / mois, engagement {months} mois',
            next_steps: 'Ensuite, pendant l\'appel : le gérant accepte l\'invitation, finalise l\'onboarding Stripe (Enterprise → Configuration de Stripe) et ajuste tarifs et horaires.',
        },
        pricing_insights: {
            courts_analyzed: 'Terrains analysés',
            recommendations: 'Recommandations',
            price_increases: 'Hausses de prix',
            price_decreases: 'Baisses de prix',
            analysis_period: "Période d'analyse",
            pricing_slots_analyzed: 'créneaux tarifaires analysés',
            all_optimal: 'Tous les tarifs sont actuellement optimaux. Aucun ajustement recommandé.',
            select_location: 'Veuillez sélectionner un club pour afficher les recommandations tarifaires.',
            load_error: 'Échec du chargement des recommandations tarifaires.',
            price_updated: 'Prix mis à jour',
            court: 'Terrain',
            sport: 'Sport',
            min_short: 'min',
            time_window: 'Créneau horaire',
            utilization: 'Utilisation',
            reason: 'Raison',
            confidence: 'Confiance',
            current: 'Actuel',
            recommended: 'Recommandé',
            change: 'Variation',
            apply: 'Appliquer',
            low_demand: 'Faible demande',
            below_average: 'Sous la moyenne',
            high_demand: 'Forte demande',
            peak_demand: 'Demande maximale',
            days: {
                '0': 'Dimanche',
                '1': 'Lundi',
                '2': 'Mardi',
                '3': 'Mercredi',
                '4': 'Jeudi',
                '5': 'Vendredi',
                '6': 'Samedi',
            },
        },
        setup_wizard: {
            step_organization: 'Organisation',
            step_location: 'Club',
            step_court: 'Terrain',
            step_stripe: 'Paiements',
            next: 'Suivant',
            back: 'Retour',
            finish: 'Terminer la configuration',
            skip_to_dashboard: 'Aller au tableau de bord',
            org_title: 'Créez votre organisation',
            org_description: 'Commencez par donner un nom à votre établissement. Vous pourrez le modifier plus tard.',
            org_name_placeholder: 'ex. Mon Club de Sport',
            location_title: 'Ajoutez votre premier club',
            location_description: 'Configurez le lieu physique où se trouvent vos terrains.',
            court_title: 'Créez votre premier terrain',
            court_description: 'Ajoutez un terrain pour que les joueurs puissent réserver. Vous pourrez configurer les horaires plus tard.',
            court_name: 'Nom du terrain',
            court_name_placeholder: 'ex. Terrain 1',
            hourly_price: 'Prix horaire',
            currency: 'Devise',
            stripe_title: 'Connecter les paiements',
            stripe_description: 'Connectez votre compte Stripe pour commencer à recevoir les paiements des joueurs.',
            stripe_connected: 'Stripe est connecté !',
            stripe_explanation: 'Vous serez redirigé vers Stripe pour finaliser la configuration. Vous pouvez également le faire plus tard depuis la page Organisation.',
            connect_stripe: 'Connecter Stripe',
            sport: 'Sport',
            sports: 'Sports',
            error_creating: 'Une erreur est survenue. Veuillez réessayer.',
            error_connecting_stripe: 'Échec de la connexion à Stripe. Veuillez réessayer.',
        },
        video_review: {
            video_reviews: 'Revues Vidéo',
            title: 'Titre',
            description: 'Description',
            sport: 'Sport',
            status: 'Statut',
            player: 'Joueur',
            assigned_to: 'Assigné à',
            date: 'Date',
            view: 'Voir',
            pending: 'En attente',
            in_review: 'En cours de revue',
            reviewed: 'Revu',
            all_statuses: 'Tous les statuts',
            detail_title: 'Revue Vidéo',
            video: 'Vidéo',
            comments: 'Commentaires',
            no_comments: 'Aucun commentaire pour le moment',
            add_comment: 'Ajouter un commentaire',
            comment_placeholder: 'Écrire un commentaire...',
            timestamp_seconds: 'Temps (sec)',
            capture_time: 'Temps actuel',
            start_review: 'Commencer la revue',
            mark_reviewed: 'Marquer comme revu',
            status_updated: 'Statut mis à jour',
            error_loading: 'Erreur lors du chargement de la soumission vidéo',
            error_updating: 'Erreur lors de la mise à jour',
            error_adding_comment: "Erreur lors de l'ajout du commentaire",
            error_deleting_comment: 'Erreur lors de la suppression du commentaire',
            delete_confirm: 'Supprimer la soumission vidéo',
            delete_confirm_message: 'Êtes-vous sûr ? Cette action est irréversible.',
            delete_success: 'Soumission vidéo supprimée avec succès',
            delete_error: 'Erreur lors de la suppression de la soumission vidéo',
            avg_review_time: 'Temps moyen de revue',
            video_not_supported: 'Votre navigateur ne prend pas en charge la lecture vidéo.',
            no_submissions: 'Aucune soumission vidéo pour le moment',
            delete_submission: 'Supprimer la soumission',
            delete_comment: 'Supprimer le commentaire',
        },
        ai_assistant: {
            title: 'Assistant IA',
            new_chat: 'Nouvelle conversation',
            send: 'Envoyer',
            placeholder: 'Tapez un message...',
            empty_state: 'Envoyez un message pour démarrer une conversation',
            untitled: 'Sans titre',
            delete_conversation: 'Supprimer la conversation',
            error: 'Une erreur est survenue',
            today: 'Aujourd\'hui',
            yesterday: 'Hier',
            this_week: 'Cette semaine',
            older: 'Plus ancien',
            dictate: 'Dicter',
            start_recording: 'Cliquez pour dicter',
            stop_recording: 'Cliquez pour arrêter',
            transcribing: 'Transcription...',
            listening: 'Écoute en cours...',
            dictation_error: 'Erreur de dictée',
            message_too_long_title: 'Message trop long',
            message_too_long: 'Ce message fait {count} caractères. L\'assistant en accepte {max} au maximum — raccourcissez-le puis renvoyez-le.',
        },
        court_recording: {
            failure_reason: 'Cause de l\'échec :',
            video_expired_title: 'Vidéo expirée',
            video_expired_description: 'Supprimée le {date}, {days} jours après que l\'enregistrement était prêt, selon le réglage de conservation de cette organisation.',
            video_expired_description_no_days: 'Supprimée le {date} selon le réglage de conservation de cette organisation.',
            title: 'Enregistrements Terrain',
            upload_video: 'Importer une Vidéo',
            failed_to_load: 'Échec du chargement des enregistrements.',
            empty_state: 'Aucun enregistrement. Importez une vidéo pour commencer.',
            court: 'Terrain',
            status: 'Statut',
            created: 'Créé le',
            created_by: 'Créé par',
            auto_triggered: 'Déclenché automatiquement',
            actions: 'Actions',
            view_analysis: 'Voir l\'analyse',
            retry_analysis: 'Relancer l\'analyse',
            delete: 'Supprimer',
            delete_confirm: 'Supprimer cet enregistrement ? Cette action est irréversible.',
            recording_analysis: 'Analyse de l\'enregistrement',
            recording_not_found: 'Enregistrement introuvable',
            back_to_list: 'Retour à la liste',
            failed_to_load_analysis: 'Échec du chargement des données d\'analyse.',
            analysis_not_available: 'Données d\'analyse non disponibles.',
            analysis_title: 'Analyse',
            event_log: 'Journal des événements',
            time: 'Temps',
            type: 'Type',
            frame: 'Image',
            details: 'Détails',
            // Modal d'import
            upload_title: 'Importer un Enregistrement',
            select_court: 'Sélectionner un terrain',
            video_file: 'Fichier Vidéo',
            uploading: 'Import en cours...',
            invalid_file_type: 'Type de fichier invalide',
            invalid_file_type_desc: 'Seuls les fichiers MP4 et MOV sont acceptés.',
            file_too_large: 'Fichier trop volumineux',
            file_too_large_desc: 'La taille maximale est de {size} Mo.',
            recording_uploaded: 'Enregistrement importé',
            analysis_will_begin: 'L\'analyse va commencer sous peu.',
            cancel: 'Annuler',
            upload: 'Importer',
            // Statistiques joueurs
            players: 'Joueurs',
            total_shots: 'Total Frappes',
            rallies: 'Échanges',
            duration: 'Durée',
            player_details: 'Détails des Joueurs',
            player: 'Joueur',
            coverage: 'Couverture',
            shots: 'Frappes',
            distance: 'Distance',
            avg_speed: 'Vitesse Moy.',
            time_visible: 'Temps Visible',
            // Lecteur vidéo
            drop_video: 'Glissez une vidéo ici ou cliquez pour parcourir',
            paste_url: 'ou collez une URL et appuyez sur Entrée',
            no_video: 'Aucune vidéo fournie',
            // Timeline événements
            event_timeline: 'Chronologie des Événements',
            shot: 'Frappe',
            rally_start: 'Début d\'échange',
            rally_end: 'Fin d\'échange',
            // Carte des frappes
            shot_chart: 'Carte des Frappes',
            no_shots_detected: 'Aucune frappe détectée',
            x_position: 'Position X',
            y_position: 'Position Y',
            // Carte thermique
            court_heatmap: 'Carte Thermique du Terrain',
            court_coords: 'Coords terrain',
            no_heatmap_data: 'Aucune donnée de carte thermique',
            // Étapes de traitement
            stage_downloading: 'Téléchargement de la vidéo',
            stage_video_metadata: 'Lecture des métadonnées vidéo',
            stage_tracking: 'Suivi des joueurs et de la balle',
            stage_detecting_court: 'Détection du terrain',
            stage_heatmaps: 'Calcul des cartes thermiques',
            stage_events: 'Extraction des événements',
            stage_statistics: 'Calcul des statistiques',
            processing_step: 'Étape {current}/{total} : {label}',
            processing_timeline: 'Progression du traitement',
            stage_completed: 'Terminé',
            stage_in_progress: 'En cours',
            stage_pending: 'En attente',
            stage_failed: 'Échoué',
            // Messages toast des hooks
            upload_failed: 'Échec de l\'import de l\'enregistrement',
            recording_deleted: 'Enregistrement supprimé',
            delete_failed: 'Échec de la suppression de l\'enregistrement',
            retry_queued: 'Relance en file d\'attente',
            retry_failed: 'Échec de la relance de l\'enregistrement',
            angle: 'Angle',
            // Diagnostics
            queued_ago: 'En file d\'attente depuis {duration}',
            processing_for: 'En traitement depuis {duration}',
            last_trigger_attempt: 'Dernière tentative : {time}',
            trigger_error: 'Erreur de déclenchement : {error}',
            auto_retry_note: 'Relance auto toutes les 5 min',
            waiting_for_slot: 'En attente d\'un créneau de traitement',
            // Agents de site (flotte de boîtiers enregistreurs)
            venue_agents: {
                title: 'Agents de site',
                mint_key: 'Générer une clé',
                intro: 'Boîtiers enregistreurs sur site qui filment les terrains et téléversent les enregistrements achetés. {count} actif(s).',
                error_title: 'Impossible de charger les agents de site',
                error_hint: 'Lister les agents nécessite que le compte avec lequel vous êtes connecté soit admin de cette organisation (ou admin de la plateforme). Les boîtiers continuent d\'enregistrer quoi qu\'il arrive.',
                empty_title: 'Aucun agent de site pour l\'instant',
                empty_description: 'Générez une clé d\'agent, puis placez-la dans recorder/config.json sur le mini-PC.',
                col_name: 'Nom',
                col_health: 'État',
                col_last_seen: 'Dernier contact',
                col_clock_skew: 'Décalage horloge',
                col_recording: 'Enregistrement',
                col_retention: 'Rétention',
                show_telemetry: 'Afficher la télémétrie de {name}',
                hide_telemetry: 'Masquer la télémétrie de {name}',
                scope_mismatch_tooltip: 'Les terrains déclarés par le boîtier ne correspondent pas au périmètre provisionné — dépliez pour le détail',
                scope_mismatch_aria: 'Écart de périmètre terrain sur {name}',
                revoke_tooltip: 'Révoquer la clé de cet agent',
                revoke_aria: 'révoquer',
                revoke_confirm: 'Révoquer « {name} » ? L\'agent sera bloqué immédiatement.',
                agent_revoked: 'Agent révoqué',
                revoke_failed: 'Échec de la révocation',
                create_failed: 'Échec de la création de l\'agent',
                copied: 'Copié dans le presse-papiers',
                copy_aria: 'copier',
                // Modal de génération de clé
                mint_modal_title: 'Générer un agent de site',
                display_name: 'Nom d\'affichage',
                display_name_placeholder: 'ex. mini-PC Fréjus',
                retention_label: 'Rétention du tampon local (heures)',
                retention_hint: 'Les achats portant sur des réservations plus anciennes seront refusés automatiquement.',
                cancel: 'Annuler',
                mint: 'Générer',
                // Modal d'affichage unique de la clé
                key_modal_title: 'Clé d\'agent — à copier maintenant',
                key_modal_body_before: 'La clé brute n\'est affichée qu\'une seule fois. Copiez-la maintenant et placez-la dans',
                key_modal_body_after: 'sur le mini-PC. Si vous la perdez, générez un nouvel agent.',
                saved_it: 'Je l\'ai enregistrée',
                // Activation (pré-provisionnement) : créer une clé ne rend plus l'enregistrement disponible
                recording_live: 'EN SERVICE',
                recording_live_tooltip: 'Les joueurs peuvent réserver un enregistrement sur les terrains de cet agent (en service depuis le {date})',
                recording_provisioned: 'PROVISIONNÉ — PAS ENCORE EN SERVICE',
                recording_provisioned_tooltip: 'Le boîtier peut se connecter et remonter ses caméras, mais les joueurs ne peuvent pas réserver d\'enregistrement sur ses terrains tant que vous ne l\'avez pas activé.',
                activate: 'Activer l\'enregistrement',
                activate_tooltip: 'Permettre aux joueurs de réserver un enregistrement sur les terrains de cet agent',
                activate_disabled_tooltip: 'Disponible dès que l\'agent a au moins un terrain — assignez des terrains, ou attendez que le boîtier remonte les terrains couverts par ses caméras.',
                activate_confirm: 'Activer l\'enregistrement pour « {name} » ? Les joueurs pourront immédiatement réserver un enregistrement sur ses terrains. À faire uniquement une fois les caméras confirmées en diffusion.',
                agent_activated: 'L\'enregistrement est en service pour cet agent',
                activate_failed: 'Échec de l\'activation',
                // Badge d'état
                health_revoked: 'RÉVOQUÉ',
                health_revoked_tooltip: 'La clé de l\'agent a été révoquée',
                health_never_seen: 'JAMAIS VU',
                health_never_seen_tooltip: 'L\'agent ne s\'est jamais connecté depuis sa création',
                health_stale: 'INACTIF',
                health_stale_tooltip: 'Aucun heartbeat depuis {minutes} min',
                health_clock_unreadable: 'HORLOGE ILLISIBLE',
                health_clock_unreadable_tooltip: 'L\'agent a envoyé un en-tête X-Venue-Agent-Clock-Ms inutilisable (RTC non réglée, ou secondes à la place de millisecondes). Le décalage d\'horloge ne peut pas être vérifié : les téléversements sont rejetés et les enregistrements échoueront — synchronisez l\'horloge de la machine (chronyd/ntp).',
                health_clock_skew: 'DÉCALAGE HORLOGE',
                health_clock_skew_tooltip: 'Décalage signalé de {skew}s, au-delà de {threshold}s — les téléversements seront rejetés',
                health_online: 'EN LIGNE',
                health_online_tooltip: 'L\'agent fonctionne normalement',
                // Temps relatif
                time_never: 'jamais',
                time_in_future: 'dans le futur',
                time_seconds_ago: 'il y a {count}s',
                time_minutes_ago: 'il y a {count}min',
                time_hours_ago: 'il y a {count}h',
                time_days_ago: 'il y a {count}j',
                // Listes de terrains
                court_list_none: 'aucun',
                unknown_court: '#{id} (terrain inconnu)',
                // Panneau de télémétrie
                never_seen_before: 'Cet agent n\'a jamais envoyé de heartbeat, il n\'y a donc pas encore de télémétrie. Placez sa clé dans',
                never_seen_after: 'sur le mini-PC et démarrez le service.',
                dlq_title_one: '1 téléversement dans la DLQ (file des rebuts)',
                dlq_title_many: '{count} téléversements dans la DLQ (file des rebuts)',
                dlq_body: 'Ces clips ont épuisé leurs tentatives et n\'atteindront jamais le client sans intervention. Vérifiez la DLQ du recorder sur le boîtier.',
                last_error: 'Dernière erreur signalée',
                metric_agent_version: 'Version de l\'agent',
                metric_uptime: 'Uptime',
                metric_last_seen: 'Dernier contact',
                metric_disk_free: 'Espace disque libre',
                disk_low_hint: 'Sous le seuil d\'alerte de {threshold} Go — le tampon local commencera à supprimer des clips avant qu\'ils ne soient achetés',
                metric_upload_queue: 'File de téléversement',
                metric_dlq_depth: 'Taille DLQ',
                dlq_hint: 'Téléversements ayant épuisé leurs tentatives — chacun est un enregistrement payé que le client ne recevra jamais',
                metric_active_recordings: 'Enregistrements en cours',
                metric_ntp_offset: 'Décalage NTP',
                ntp_drift_hint: 'Dérive au-delà de ±{threshold} ms — au-delà de 30 s, l\'API rejette purement et simplement les téléversements de cet agent',
                metric_upload_gate: 'Délai de retenue',
                segment_refused: 'longueur de segment refusée',
                gate_refused_intro: 'Ce boîtier a signalé une longueur de segment que l\'API a refusée ; cette valeur a donc été ignorée. Le délai de retenue en vigueur pour ce boîtier est de {gate}',
                gate_refused_from_report: ', toujours calculé à partir de son dernier signalement accepté de {reported}s.',
                gate_refused_default: ' — la valeur par défaut du déploiement, ce boîtier n\'ayant aucun signalement accepté.',
                gate_refused_remedy: 'Si le boîtier écrit réellement des segments plus longs, son dernier segment n\'est pas encore sur le disque à l\'ouverture du délai et les clips seront tronqués — corrigez segmentSeconds dans recorder/config.json (60–3600).',
                gate_normal: 'Un enregistrement terminé est retenu pendant {gate} après la fin de la partie avant d\'être proposé à ce boîtier, afin que son dernier segment ffmpeg soit écrit avant le découpage.',
                gate_normal_reported: 'Ce boîtier signale des segments de {reported}s.',
                gate_normal_default: 'Ce boîtier n\'a signalé aucune longueur de segment ; la valeur par défaut du déploiement s\'applique.',
                court_scope: 'Périmètre terrain',
                scope_disagree: 'Le boîtier et le périmètre admin ne concordent pas',
                recording_unauthorized_before: 'Enregistré mais non provisionné :',
                recording_unauthorized_after: '— les clips sont capturés sur le boîtier et jamais collectés.',
                provisioned_not_recorded_before: 'Provisionné mais non enregistré :',
                provisioned_not_recorded_after: '— rien n\'est capturé ; les achats pour ces terrains expireront et seront remboursés.',
                self_reported: 'Déclaré par le boîtier',
                not_reported: 'non déclaré',
                hint_only: 'INDICATIF',
                admin_provisioned: 'Provisionné par l\'admin (appliqué)',
                all_courts: 'tous les terrains (aucune restriction)',
                // Contrôle des terrains provisionnés
                provisioned_courts: 'Terrains provisionnés',
                all_courts_placeholder: 'Tous les terrains de l\'organisation',
                provisioned_helper: 'Périmètre d\'accès défini par l\'admin. L\'agent ne peut récupérer et téléverser des enregistrements que pour ces terrains — la liste déclarée par le boîtier lui-même ne peut pas l\'élargir. C\'est aussi visible côté joueurs : les feature flags de l\'organisation exposent l\'union des terrains provisionnés de ses agents non révoqués, et l\'application mobile n\'affiche l\'option d\'enregistrement par partie que sur les terrains de cet ensemble.',
                clear_warning_title: 'Aucun terrain sélectionné signifie un accès à toute l\'organisation, pas « désactivé ».',
                clear_warning_body_before: 'Enregistrer une sélection vide efface entièrement le périmètre admin : cet agent sera autorisé sur',
                clear_warning_body_strong: 'tous les terrains de l\'organisation',
                clear_warning_body_after: ', et il cesse de contribuer à l\'ensemble des terrains qui conditionne l\'option d\'enregistrement mobile. Pour limiter un boîtier à un seul terrain, sélectionnez ce terrain. Pour mettre un agent hors service, révoquez sa clé.',
                scope_cleared_toast: 'Périmètre terrain effacé — l\'agent a désormais accès à toute l\'organisation',
                scope_updated: 'Périmètre terrain mis à jour',
                scope_update_failed: 'Échec de la mise à jour du périmètre terrain',
                clear_scope_button: 'Effacer le périmètre — accès à toute l\'organisation',
                save_scope: 'Enregistrer le périmètre terrain',
                reset: 'Réinitialiser',
                // Affectation caméra → terrain
                camera_to_court: 'Caméra → terrain',
                no_cameras: 'Le boîtier n\'a encore signalé aucune caméra.',
                camera: 'Caméra',
                mac_unknown: 'MAC inconnue',
                connected: 'connectée',
                disconnected: 'déconnectée',
                recording_now: 'Enregistre actuellement',
                assign_to: 'Affecter à',
                court_for_camera: 'Terrain pour la caméra {camera}',
                badge_applied: 'APPLIQUÉ',
                badge_pending: 'EN ATTENTE',
                badge_box_config: 'CONFIG BOÎTIER',
                badge_no_mac: 'MAC INCONNUE',
                badge_not_reporting: 'NON DÉTECTÉE',
                state_applied: 'Appliqué — le boîtier enregistre cette caméra sur le terrain affecté.',
                state_pending: 'En attente — enregistré ; le boîtier réécrit sa configuration et redémarre à son prochain heartbeat (environ une minute).',
                state_unassigned: 'Issu de la configuration du boîtier — aucune affectation admin pour l\'instant.',
                state_no_mac: 'MAC pas encore résolue — le boîtier la signale une fois la caméra connectée. Impossible de l\'affecter avant.',
                state_not_reporting: 'Affectée, mais le boîtier ne signale aucune caméra avec cette MAC.',
                camera_helper: 'Quelle caméra physique enregistre quel terrain. Enregistrer envoie la correspondance au boîtier, qui réécrit sa propre configuration et redémarre dans le heartbeat suivant (quelques secondes d\'images perdues) — n\'enregistrez pas pendant un match en cours. L\'ajout ou le retrait de caméras et leurs identifiants se font toujours sur le boîtier.',
                duplicate_court: '{court} est sélectionné pour deux caméras. Chaque terrain ne peut avoir qu\'une seule caméra.',
                save_assignments: 'Enregistrer les affectations caméra',
                assignments_saved: 'Affectations caméra enregistrées',
                assignments_saved_desc: 'Le boîtier les applique à son prochain heartbeat (environ une minute) et redémarre.',
                assignments_save_failed: 'Échec de l\'enregistrement des affectations caméra',
                no_snapshot_yet: 'Pas encore de photo',
                snapshot_unavailable: 'Photo indisponible',
                snapshot_alt: 'Dernière image de la caméra {camera}',
            },
            camera_setup: {
                box_online: 'Boîtier en ligne',
                box_offline: 'Boîtier hors ligne',
                box_never_seen: 'Boîtier pas encore connecté',
                box_online_hint: 'Dernier contact avec le boîtier {ago}.',
                box_offline_hint: 'Dernier contact {ago}. Vérifiez le câble d\'alimentation et le câble INTERNET, puis patientez deux minutes.',
                box_never_seen_hint: 'Branchez l\'alimentation et le câble INTERNET, puis patientez deux minutes. Si rien ne change, appelez le support.',
                take_photos: 'Prendre de nouvelles photos',
                taking_photos: 'Photos demandées — environ une minute…',
                photos_requested_toast: 'Nouvelles photos demandées',
                photos_requested_toast_desc: 'Le boîtier les prend dans la minute. Cette page se met à jour toute seule.',
                photos_request_failed: 'Impossible de demander des photos',
                picture_none: 'Pas encore de photo',
                picture_waiting: 'Nouvelle photo en cours…',
                picture_taken: 'Photo prise {ago}',
                picture_failed: 'Photo indisponible — prenez de nouvelles photos',
                confirm_label: 'Oui, c\'est bien {court}',
                confirm_blocked_hint: 'Il faut une photo et une caméra connectée avant de confirmer.',
                confirm_save_first: 'Enregistrez d\'abord les affectations ci-dessous, puis confirmez avec le nouveau nom.',
                activation_override_hint: 'Le bouton « Activer » de la ligne du boîtier reste disponible à un opérateur qui veut passer outre.',
                state_connected: 'Caméra connectée.',
                state_disconnected: 'Caméra sans réponse — vérifiez son câble sur le switch CAMÉRAS.',
                state_no_mac: 'Caméra en cours de démarrage — patientez une minute.',
                state_pending: 'Enregistré — le boîtier applique le changement (environ une minute).',
                state_not_reporting: 'Le boîtier ne voit plus cette caméra. Vérifiez son câble.',
                activation_title: 'Activer l\'enregistrement',
                activation_intro: 'Les joueurs pourront enregistrer leurs matchs dès que tout ci-dessous est au vert.',
                blocker_box_offline: 'Le boîtier est hors ligne.',
                blocker_no_cameras: 'Aucune caméra détectée.',
                blocker_camera_disconnected: 'Une caméra ne répond pas.',
                blocker_camera_not_ready: 'Une caméra démarre encore.',
                blocker_duplicate_court: 'Deux caméras pointent vers le même terrain.',
                blocker_pending_apply: 'Le boîtier applique encore un changement.',
                blocker_unconfirmed: 'Confirmez le terrain de chaque caméra.',
                all_good: 'Tout est prêt.',
                activate: 'Activer l\'enregistrement',
                activate_confirm: 'Activer l\'enregistrement ? Les joueurs pourront enregistrer sur ces terrains immédiatement.',
                activated_toast: 'L\'enregistrement est activé',
                activate_failed: 'Impossible d\'activer l\'enregistrement',
                recording_active: 'L\'enregistrement est actif depuis le {date}.',
                recording_active_hint: 'Vous pouvez toujours corriger une caméra ci-dessous. Le boîtier applique le changement dans la minute.',
                ago_seconds: 'il y a {count} s',
                ago_minutes: 'il y a {count} min',
                ago_hours: 'il y a {count} h',
                ago_days: 'il y a {count} j',
            },
            camera_aim: {
                title: 'Viser une caméra',
                back: 'Agents de site',
                aim_live: 'Viser en direct',
                blocker_box_offline: 'Boîtier hors ligne',
                blocker_no_mac: 'Caméra en cours de démarrage',
                blocker_camera_disconnected: 'Caméra non connectée',
                blocker_revoked: 'Boîtier révoqué',
                camera_tail: 'Caméra …{tail}',
                no_court: 'Caméra sans terrain',
                picture_alt: 'Image en direct de la caméra {camera}',
                opening: 'Connexion au boîtier…',
                starting: 'La caméra démarre… (jusqu\'à 1 min)',
                starting_hint: 'Gardez cette page ouverte : l\'image arrive toute seule.',
                box_late: 'Le boîtier ne répond pas à la visée — il doit peut-être être mis à jour.',
                ended_title: 'Session terminée',
                ended_capped: 'Une visée dure 15 minutes au plus.',
                ended_hint: 'La visée s\'est arrêtée.',
                continue: 'Continuer',
                replaced_title: 'Un autre administrateur vise une autre caméra',
                replaced_hint: 'Un boîtier ne montre qu\'une caméra à la fois.',
                take_over: 'Reprendre la main',
                error_invalid: 'Cette caméra n\'a pas une adresse MAC valide.',
                error_forbidden: 'Vous n\'avez pas accès à ce boîtier.',
                error_not_found: 'Ce boîtier ne signale pas cette caméra en ce moment.',
                error_revoked: 'Ce boîtier a été révoqué : la visée est impossible.',
                error_unavailable: 'Impossible de joindre le serveur pour la visée.',
                retry: 'Réessayer',
                list_error: 'Impossible de charger les boîtiers.',
                agent_not_found: 'Ce boîtier est introuvable dans cette organisation.',
                camera_invalid: 'Ce lien ne désigne pas une caméra. Choisissez-en une :',
                age_frozen: 'Image figée · {ago}',
                stop: 'Terminer',
                cameras_label: 'Caméras du boîtier',
                tips_title: 'Conseils de pose',
                tip_position: 'Derrière la vitre du fond, à environ 2 m du sol.',
                tip_centred: 'Centrée sur la largeur du terrain.',
                tip_players: 'Les deux joueurs bien visibles, au filet comme au fond.',
                tip_court: 'Tout le terrain dans l\'image, les deux lignes de fond comprises.',
            },
        },
        whatsapp_conversations: {
            title: 'Conversations WhatsApp',
            phone: 'Téléphone',
            user: 'Utilisateur',
            last_activity: 'Dernière activité',
            created_at: 'Créé le',
            actions: 'Actions',
            unknown_user: 'Inconnu',
            no_conversations: 'Aucune conversation',
            delete_conversation: 'Supprimer la conversation',
            delete_confirm: 'Cela supprimera définitivement la conversation et tous ses messages. Cette action est irréversible.',
            deleted_successfully: 'Conversation supprimée',
            delete_error: 'Erreur lors de la suppression',
            conversation_details: 'Détails de la conversation',
            messages: 'Messages',
            no_messages: 'Aucun message dans cette conversation',
            clear_messages: 'Effacer les messages',
            clear_confirm: "Cela supprimera tous les messages de cette conversation, réinitialisant l'historique du chat. La conversation sera conservée.",
            messages_cleared: 'Messages effacés',
            clear_error: "Erreur lors de l'effacement des messages",
            load_error: 'Erreur lors du chargement de la conversation',
        },
        weather: {
            feels_like: 'ressenti',
            wind: 'Vent',
            humidity: 'Humidité',
            rain: 'Pluie',
        },
        loading: 'Chargement...',
        achievement: {
            achievements: 'Réalisations',
            create_achievement: 'Créer une réalisation',
            edit_achievement: 'Modifier la réalisation',
            delete_achievement: 'Supprimer la réalisation',
            achievement_details: 'Détails de la réalisation',
            name: 'Nom',
            name_placeholder: 'ex. Première Victoire',
            name_required: 'Le nom est requis',
            description: 'Description',
            description_placeholder: 'Décrivez ce que le joueur doit accomplir',
            category: 'Catégorie',
            tier: 'Niveau',
            no_tier: 'Pas de niveau',
            criteria: 'Critères',
            criteria_type: 'Type de déclencheur',
            threshold: 'Seuil',
            threshold_min: 'Le seuil doit être au moins 1',
            active: 'Actif',
            inactive: 'Inactif',
            sort_order: 'Ordre de tri',
            sport_filter: 'Filtre par sport',
            sport_filter_placeholder: 'Laisser vide pour tous les sports',
            sport_type: 'Type de sport',
            icon_url: 'URL de l\'icône',
            actions: 'Actions',
            no_achievements: 'Aucune réalisation définie',
            not_found: 'Réalisation introuvable',
            created_successfully: 'Réalisation créée',
            updated_successfully: 'Réalisation mise à jour',
            deleted_successfully: 'Réalisation supprimée',
            create_error: 'Échec de la création',
            update_error: 'Échec de la mise à jour',
            delete_error: 'Échec de la suppression',
            toggle_error: 'Échec du changement de statut',
            load_error: 'Échec du chargement des succès',
            period_type_required: 'Le type de période est requis pour les critères de série',
            delete_confirm: 'Êtes-vous sûr de vouloir supprimer "{name}" ? Cette action est irréversible.',
            create: 'Créer',
            reward_type: 'Type de récompense',
            reward_none: 'Aucune',
            reward_wallet_credits: 'Crédits portefeuille',
            reward_coupon: 'Coupon',
            reward_credit_amount: 'Montant des crédits',
            reward_coupon_select: 'Sélectionner un coupon',
            reward_coupon_placeholder: 'Choisir un coupon...',
            type_achievement_reward: 'Récompense de réalisation',
            reward_value_required: 'Le montant des crédits doit être supérieur à 0',
            reward_coupon_required: 'Veuillez sélectionner un coupon',
            category_gameplay: 'Jeu',
            category_social: 'Social',
            category_progression: 'Progression',
            category_community: 'Communauté',
            category_custom: 'Personnalisé',
            tier_bronze: 'Bronze',
            tier_silver: 'Argent',
            tier_gold: 'Or',
            tier_platinum: 'Platine',
            criteria_games_played: 'Parties jouées',
            criteria_courts_booked: 'Terrains réservés',
            criteria_events_joined: 'Événements rejoints',
            criteria_coaching_sessions: 'Séances de coaching',
            criteria_matches_won: 'Matchs gagnés',
            criteria_streak: 'Série',
            criteria_unique_opponents: 'Adversaires uniques',
            criteria_level_reached: 'Niveau atteint',
            streak_activity_type: "Type d'activité",
            streak_period_type: 'Type de période',
            activity_game: 'Match',
            activity_court_booking: 'Réservation de terrain',
            activity_event: 'Événement',
            activity_coaching: 'Coaching',
            activity_any: 'Toute activité',
            period_daily: 'Quotidien',
            period_weekly: 'Hebdomadaire',
            period_monthly: 'Mensuel',
        },
        walkthrough: {
            home: 'Accueil',
            welcome: 'Bon retour',
            quick_actions: 'Actions rapides',
            checklist_title: 'Préparez votre établissement',
            complete: 'terminé',
            done: 'Fait',
            go: 'Aller',
            dismiss: 'Masquer',
            show_setup_guide: 'Afficher le guide de configuration',
            all_complete_title: 'Tout est prêt !',
            all_complete_description: 'Votre établissement est prêt à recevoir des réservations.',
            create_organization: 'Créer votre organisation',
            add_location: 'Ajouter un club',
            setup_courts: 'Configurer vos terrains',
            configure_pricing: 'Configurer les tarifs',
            connect_stripe: 'Connecter Stripe',
            add_coaches: 'Ajouter vos coachs',
            create_event: 'Créer un événement',
            create_membership: 'Créer un type d\'abonnement',
            create_product: 'Créer un produit',
            create_coupons: 'Créer des coupons',
            empty_courts_title: 'Aucun terrain',
            empty_courts_description: 'Les terrains sont les espaces de réservation pour vos joueurs. Ajoutez votre premier terrain pour commencer.',
            empty_courts_action: 'Ajouter un terrain',
            empty_games_title: 'Aucun match programmé',
            empty_games_description: 'Les matchs permettent aux joueurs de se retrouver. Créez votre premier match pour remplir vos terrains.',
            empty_events_title: 'Aucun événement créé',
            empty_events_description: 'Les événements rassemblent votre communauté. Créez un tournoi, un stage ou un social pour commencer.',
            empty_users_title: 'Aucun joueur',
            empty_users_description: 'Les joueurs apparaîtront ici quand ils s\'inscriront et réserveront via votre établissement.',
            tour_back: 'Retour',
            tour_close: 'Fermer',
            tour_last: 'Compris',
            tour_next: 'Suivant',
            tour_next_with_progress: 'Suivant ({step}/{steps})',
            tour_skip: 'Passer',
            replay_tour: 'Relancer le guide',
            replay_coach_tour: 'Revoir le didacticiel',
            coach_tour_planning_title: 'Votre planning',
            coach_tour_planning_content: 'Ce calendrier affiche toutes les réservations sur les terrains — y compris vos cours. Cliquez sur un cours pour voir son détail : l\'élève, le terrain et les options d\'annulation.',
            coach_tour_coachs_link_title: 'L\'onglet Coachs',
            coach_tour_coachs_link_content: 'C\'est ici que se trouve votre fiche coach. Ouvrez-la pour gérer vos informations et vos disponibilités.',
            coach_tour_profile_title: 'Votre fiche coach',
            coach_tour_profile_content: 'Basculez entre vos informations (nom, photo, sports, tarifs des cours) et votre calendrier de disponibilités avec ce sélecteur.',
            coach_tour_availabilities_title: 'Vos disponibilités',
            coach_tour_availabilities_content: 'Ce sont les créneaux que les joueurs peuvent réserver avec vous. Cliquez sur un créneau libre pour ajouter une disponibilité, ou sur un créneau existant pour le retirer.',
            coach_tour_replay_title: 'C\'est terminé !',
            coach_tour_replay_content: 'Vous pouvez revoir ce didacticiel à tout moment depuis ce menu. Bonne saison !',
            court_config_details_title: 'Détails du terrain',
            court_config_details_content: 'Consultez et modifiez le nom du terrain, le type de sport et les paramètres de base. C\'est ici que vous gérez chaque terrain individuellement.',
            court_config_calendar_title: 'Calendrier du terrain',
            court_config_calendar_content: 'Visualisez toutes les réservations, blocages et disponibilités d\'un coup d\'œil. Cliquez sur un créneau pour créer un blocage ou gérer la disponibilité.',
            court_config_heatmap_title: 'Carte tarifaire',
            court_config_heatmap_content: 'Vue d\'ensemble des tarifs de ce terrain sur la semaine. Les couleurs foncées indiquent des prix plus élevés — utile pour repérer les créneaux à ajuster.',
            pricing_court_title: 'Tarification des terrains',
            pricing_court_content: 'Définissez les tarifs horaires pour chaque terrain. Sélectionnez un terrain pour voir sa carte tarifaire — les couleurs indiquent les niveaux de prix sur la semaine.',
            pricing_coach_title: 'Tarification des coachs',
            pricing_coach_content: 'Configurez les tarifs de séance pour chaque coach. Les coachs peuvent aussi avoir des tarifs heures pleines/creuses.',
            pricing_duration_title: 'Durées de match',
            pricing_duration_content: 'Définissez la durée des matchs. Différents sports et types de terrain peuvent avoir des durées différentes.',
            pricing_refund_title: 'Politique de remboursement',
            pricing_refund_content: 'Définissez le délai d\'annulation. Les joueurs peuvent être remboursés intégralement s\'ils annulent avant ce délai.',
            pricing_discount_title: 'Réductions de dernière minute',
            pricing_discount_content: 'Réduisez automatiquement le prix des terrains qui risquent de rester vides. Définissez le pourcentage et le délai avant le début du créneau.',
            time_windows_groups_title: 'Groupes de créneaux horaires',
            time_windows_groups_content: 'Les groupes organisent vos créneaux par usage — ex. « Heures pleines », « Heures creuses », « Week-ends ». Créez d\'abord un groupe, puis ajoutez-y des créneaux.',
            time_windows_slots_title: 'Créneaux horaires',
            time_windows_slots_content: 'Chaque créneau définit un jour de la semaine + une plage horaire. Les terrains et les règles tarifaires utilisent ces groupes pour appliquer différents tarifs selon les horaires.',
        },
        appearance: {
            style: 'Style',
            aesthetic_classic: 'Classique',
            aesthetic_classic_desc: 'Gris froids, lignes épurées',
            aesthetic_clubhouse: 'Clubhouse',
            aesthetic_clubhouse_desc: 'Tons chauds, aspect premium',
            theme: 'Couleur',
            animations: 'Animations',
            preset_default: 'Par défaut',
            preset_default_desc: 'Bleu classique',
            preset_midnight: 'Nuit',
            preset_midnight_desc: 'Indigo profond',
            preset_ember: 'Braise',
            preset_ember_desc: 'Tons chauds terreux',
            preset_forest: 'Forêt',
            preset_forest_desc: 'Verts naturels',
            preset_clay: 'Argile',
            preset_clay_desc: 'Terracotta méditerranéen',
            animation_full: 'Complet',
            animation_full_desc: 'Toutes les transitions et effets',
            animation_reduced: 'Réduit',
            animation_reduced_desc: 'Fondus subtils uniquement',
            animation_none: 'Aucune',
            animation_none_desc: 'Instantané, sans mouvement',
        },
        command_palette: {
            search_placeholder: 'Rechercher des pages, actions, utilisateurs...',
            search_users_placeholder: 'Rechercher des utilisateurs par nom ou email...',
            no_results_title: "Aucun résultat pour '{{query}}'",
            no_results_hint: 'Essayez une autre recherche ou parcourez les pages dans la barre latérale',
            recent: 'Récents',
            actions: 'Actions',
            search: 'Recherche',
            pages: 'Pages',
            toggle_dark_mode: 'Activer le mode sombre',
            toggle_light_mode: 'Activer le mode clair',
            create_court: 'Créer un terrain',
            create_event: 'Créer un événement',
            search_users: 'Rechercher des utilisateurs...',
            select_org_first: "Sélectionnez d'abord une organisation",
            users_pill: 'Utilisateurs',
            min_chars_hint: 'Tapez au moins 2 caractères pour rechercher',
            searching: 'Recherche en cours...',
            search_failed: 'La recherche a échoué — réessayez',
            no_users_found: "Aucun utilisateur trouvé pour '{{query}}'",
            keyboard_hint: '↑↓ Naviguer  ⏎ Sélectionner  esc Fermer',
            keyboard_hint_sub: '↑↓ Naviguer  ⏎ Sélectionner  ⌫ Retour  esc Fermer',
            aria_label: 'Palette de commandes',
        },
        admin_notifications: {
            title: 'Notifications Admin',
            mark_all_read: 'Tout marquer comme lu',
            view_all: 'Voir toutes les notifications',
            empty: 'Aucune notification pour le moment',
            just_now: "À l'instant",
            unread: 'non lues',
            read: 'Lu',
            type_courtBookingCreated: 'Réservation créée',
            type_courtBookingCanceled: 'Réservation annulée',
            type_paymentFailed: 'Paiement échoué',
            filter_all_types: 'Tous les types',
            filter_all_status: 'Tous les statuts',
            filter_unread: 'Non lues',
            filter_read: 'Lues',
            col_type: 'Type',
            col_title: 'Titre',
            col_message: 'Message',
            col_date: 'Date',
            col_status: 'Statut',
            prev: 'Précédent',
            next: 'Suivant',
        },
        marketing: {
            sign_in: 'Connexion',
            start_free_trial: 'Essai gratuit',
            whatsapp_cta: 'Discuter sur WhatsApp',
            footer_tagline: 'La plateforme tout-en-un pour les clubs de sport. Réservations, paiements et gestion des joueurs — automatisés.',
            footer_contact: 'Contact',
            footer_product: 'Produit',
            footer_rights: 'Tous droits réservés.',
            nav_roi_calculator: 'Calculateur ROI',
            nav_pricing: 'Tarifs',
            calc_hero_title: 'Quel est l\'impact réel de la digitalisation sur votre club ?',
            calc_hero_subtitle: 'Renseignez votre club et découvrez combien de revenus vous pourriez récupérer grâce à l\'automatisation, la réduction des no-shows et la fidélisation des membres.',
            calc_courts: 'Nombre de terrains',
            calc_rate: 'Tarif horaire moyen (€)',
            calc_hours: 'Heures d\'ouverture par jour',
            calc_noshow: 'Taux de no-show estimé',
            calc_industry_avg: 'Moyenne du secteur : 15%',
            calc_booking_method: 'Méthode de réservation actuelle',
            calc_method_phone: 'Appels téléphoniques',
            calc_method_email: 'Email',
            calc_method_whatsapp: 'Messages WhatsApp',
            calc_method_other_platform: 'Autre plateforme',
            calc_method_paper: 'Papier / sur place',
            calc_cta: 'Calculer mes économies',
            calc_result_noshow: 'Récupérés des no-shows',
            calc_result_time: 'Temps admin économisé par semaine',
            calc_result_waitlist: 'Revenus supplémentaires via liste d\'attente',
            calc_result_total: 'Impact mensuel total sur votre club',
            calc_social_proof_title: 'Utilisé par des clubs en France et en Afrique du Nord',
            calc_social_proof_body: 'Les clubs utilisant MySportSet constatent jusqu\'à 85% de no-shows en moins grâce au prépaiement obligatoire et aux rappels automatiques.',
            calc_bottom_cta: 'Des questions ? Discutons.',
            calc_section_members: 'Vos membres',
            calc_active_members: 'Membres actifs',
            calc_monthly_revenue: 'Revenu moyen / membre / mois (€)',
            calc_section_bookings: 'Réservations',
            calc_phone_bookings: 'Réservations par téléphone / jour',
            calc_phone_bookings_help: 'Appels, SMS, WhatsApp manuels',
            calc_advanced: 'Options avancées',
            calc_churn_rate: 'Taux de désabonnement mensuel',
            calc_churn_rate_help: 'Moyenne secteur : 3-7%',
            calc_coaches: 'Nombre de coachs',
            calc_coaching_sessions: 'Sessions coaching / semaine',
            calc_result_retention: 'Fidélisation des membres',
            calc_result_automation: 'Économies d\'automatisation',
            source_noshow: 'Taux no-show : 10-30% moy. secteur (SFM Journal, 2023)',
            source_time: 'Basé sur des enquêtes opérateurs (N=120)',
            source_waitlist: 'Taux remplissage liste d\'attente : 5% des créneaux vides',
            source_retention: '5% rétention = 25-95% profit (Bain / Harvard)',
            source_automation: 'Économies admin proportionnelles à la taille du club',
            method_toggle: 'Comment nous avons calculé',
            method_noshow_title: 'Récupération des no-shows (45%)',
            method_noshow_body: 'Les clubs sportifs subissent 10 à 30% de no-shows (Sports Facility Management, 2023). Le prépaiement seul réduit les no-shows de 40 à 50% (Mindbody, foreUP sur 10M+ réservations). Nous utilisons 45% — la fourchette basse du prépaiement seul, sans empiler d\'effets supplémentaires non vérifiés. Appliqué aux créneaux réservés uniquement (taux d\'occupation moyen de 60%).',
            method_recovery_title: 'Temps administratif économisé',
            method_recovery_body: 'Le temps par réservation téléphonique est d\'environ 5 min (décrocher, vérifier le planning, confirmer le créneau). Le calcul ne compte que les réservations téléphoniques que vous déclarez, pas l\'ensemble des réservations. La réservation en libre-service réduit ce temps à zéro.',
            method_time_title: 'Utilisation via liste d\'attente (+5%)',
            method_time_body: 'Le taux d\'occupation moyen des terrains est d\'environ 60%. Les listes d\'attente intelligentes remplissent automatiquement les annulations et créneaux vides. Nous estimons que 5% des créneaux vides sont récupérés — un taux prudent, les annonces de l\'industrie citant 10-20% mais rarement vérifiées indépendamment.',
            method_waitlist_title: 'Validation terrain : Fréjus',
            method_waitlist_body: 'Notre déploiement au Fréjus Padel Club a validé ces projections : les no-shows ont chuté de 85% après l\'introduction du prépaiement, et le taux d\'occupation moyen est passé de 58% à 73% dans les 3 mois suivant la mise en service.',
            method_retention_title: 'Fidélisation des membres (10% de churn en moins)',
            method_retention_body: 'Les recherches de Bain & Company / Harvard montrent qu\'une amélioration de 5% de la rétention génère 25 à 95% de profit supplémentaire. Les membres pratiquant en groupe sont 56% moins susceptibles d\'annuler (ClassPass 2025). Nous appliquons 10% de réduction du churn global — bien en dessous du 56% car tous les membres ne passent pas au jeu en groupe.',
            method_automation_title: 'Automatisation des réservations',
            method_automation_body: 'Chaque réservation téléphonique prend ~5 min de temps personnel. La réservation en ligne automatise 60% de ces appels (certains joueurs préfèreront toujours téléphoner). L\'automatisation des tâches admin (rappels, facturation, planification) économise ~1,5h par terrain par semaine à 12€/h. Pour les clubs avec coachs, la réservation en ligne remplit 10% de créneaux coaching en plus.',
            calc_scenario: 'Scénario de projection',
            calc_scenario_help: 'Prudent réduit les estimations de 30%, Optimiste les augmente de 30%',
            calc_scenario_label: 'Scénario :',
            scenario_conservative: 'Prudent (0.7x)',
            scenario_moderate: 'Modéré (1.0x)',
            scenario_optimistic: 'Optimiste (1.3x)',
            sources_title: 'Sources et références',
            sources_tier1: 'Sources françaises',
            sources_tier2: 'Citations sectorielles',
            sources_tier3: 'Rapports approfondis',
            email_capture_title: 'Recevez votre rapport personnalisé',
            email_capture_subtitle: 'Nous vous enverrons un PDF détaillé avec vos résultats et recommandations.',
            email_capture_placeholder: 'votre@email.com',
            email_capture_club_placeholder: 'Nom de votre club',
            email_capture_submit: 'Recevoir mon rapport',
            email_capture_success: 'Merci ! Vérifiez votre boîte mail.',
            email_capture_error: 'Une erreur est survenue. Réessayez.',
            pdf_export: 'Télécharger le rapport PDF',
            method_disclaimer: 'Toutes les projections sont des estimations basées sur des recherches sectorielles et des déploiements réels de MySportSet. Les résultats réels varient selon la taille du club, la localisation, le sport et la démographie des joueurs.',
            // Formula tooltips
            formula_your_input: 'Votre saisie',
            formula_noshow_loss_tip: '{bookedRev}€ de revenu réservé × {noShow}% taux de no-show',
            formula_noshow_recovery_tip: 'Prépaiement seul — Mindbody, foreUP (10M+ réservations). On n\'empile pas les effets de rappel.',
            formula_phone_count_tip: 'Votre saisie : appels de réservation par jour',
            formula_phone_duration_tip: 'Durée moyenne d\'un appel : décrocher, vérifier le planning, confirmer, noter',
            formula_days_week_tip: '7 jours d\'exploitation par semaine',
            formula_empty_slots_tip: '{courts} terrains × {hours}h/j × {days}j/an × {empty}% inoccupés',
            formula_waitlist_tip: 'Prudent — le secteur annonce 10-20% mais rarement vérifié indépendamment',
            formula_your_rate_tip: 'Votre saisie : tarif horaire',
            formula_churn_loss_tip: '{members} membres × {revenue}€/mois × {churn}% churn × 12 mois',
            formula_churn_rate_tip: 'Membres en groupe 56% moins susceptibles d\'annuler (ClassPass 2025). Moyenne pondérée sur tous les membres : 10%',
            formula_phone_auto_tip: '{hours}h/an au téléphone × {rate}% automatisés × {cost}€/h',
            formula_admin_auto_tip: '{courts} terrains × {hpw}h/terrain/sem × {cost}€/h × {weeks} sem',
            formula_coaching_tip: '{coaches} coachs × {sessions} séances/sem × {uplift}% × {rate}€ × {weeks} sem',
            formula_sum_tip: 'Somme de toutes les catégories avant ajustement du scénario',
            formula_scenario_tip: 'Multiplicateur du scénario {scenario}',
            formula_monthly_tip: 'Divisé par 12 pour afficher l\'impact mensuel',
            copy_link: 'Copier le lien',
            link_copied: 'Lien copié !',
            trust_roi_label: 'Retour sur investissement',
            trust_monthly_gain: 'gain mensuel',
            trust_subscription: '/mois d\'abonnement',
            trust_even_half: 'Même à la moitié de ces estimations, c\'est rentable',
            trust_proof_label: 'Résultats vérifiés',
            trust_prepayment: 'prépaiement',
            trust_slots: 'utilisation créneaux',
            trust_courts: 'terrains',
            case_study_title: 'Fréjus Padel Club',
            case_study_location: 'Fréjus, France — 6 terrains',
            case_study_body: 'Avant MySportSet, Fréjus gérait ses réservations par téléphone et WhatsApp. Les no-shows atteignaient 20%, et le staff passait plus de 3 heures par jour sur la planification. Après le passage à MySportSet, le prépaiement a éliminé quasi tous les no-shows, et la liste d\'attente automatique a rempli 22% des créneaux précédemment vides dès le premier trimestre.',
            case_study_stat1_value: '-85%',
            case_study_stat1_label: 'Réduction des no-shows',
            case_study_stat2_value: '450+',
            case_study_stat2_label: 'Joueurs actifs',
            case_study_stat3_value: '92%',
            case_study_stat3_label: 'Taux de prépaiement',
            case_study_stat4_value: '+22%',
            case_study_stat4_label: 'Utilisation créneaux',
            case_study_see_methodology: 'Voir la méthodologie ci-dessus',
            // Migration timeline
            migration_timeline_title: 'Votre migration en 3 jours',
            migration_day1: 'Jour 1',
            migration_day2: 'Jour 2',
            migration_day3: 'Jour 3',
            migration_step1_title: 'Import des terrains',
            migration_step1_desc: 'Nous configurons vos terrains, horaires et tarifs dans MySportSet.',
            migration_step2_title: 'Import des joueurs',
            migration_step2_desc: 'Vos joueurs reçoivent une invitation et créent leur profil en 2 minutes.',
            migration_step3_title: 'Première réservation',
            migration_step3_desc: 'Votre club est en ligne. Les joueurs réservent et paient en autonomie.',
            // Migration kit
            migration_kit_title: 'Amenez vos joueurs',
            migration_kit_subtitle: 'Changer de logiciel ne signifie pas perdre vos joueurs. Notre processus de migration est conçu pour une transition sans friction.',
            migration_kit_section1_title: 'Zéro perte de données',
            migration_kit_section1_body: 'Nous importons vos terrains, tarifs, créneaux et membres existants. Rien n\'est perdu dans la transition.',
            migration_kit_section2_title: 'Vos joueurs sont accompagnés',
            migration_kit_section2_body: 'Chaque joueur reçoit une invitation personnalisée avec un lien direct pour créer son profil. Pas de friction, pas de confusion.',
            migration_kit_section3_title: 'Assistance dédiée',
            migration_kit_section3_body: 'Un référent MySportSet vous accompagne pendant toute la migration et les 30 premiers jours d\'utilisation.',
            migration_kit_cta: 'Démarrer ma migration',
            // Referral program
            referral_title: 'Parrainez un club, gagnez ensemble',
            referral_subtitle: 'Vous connaissez un club qui mérite mieux que les réservations par téléphone ? Recommandez MySportSet et profitez d\'avantages exclusifs.',
            referral_step1_title: 'Recommandez',
            referral_step1_desc: 'Parlez de MySportSet à un club de sport dans votre réseau.',
            referral_step2_title: 'Le club s\'inscrit',
            referral_step2_desc: 'Le club mentionné essaie MySportSet et active son compte.',
            referral_step3_title: 'Vous êtes récompensé',
            referral_step3_desc: 'Recevez un mois gratuit pour chaque club parrainé qui reste actif.',
            referral_how_title: 'Comment ça marche',
            referral_benefit1: '1 mois gratuit par parrainage réussi',
            referral_benefit2: 'Le club parrainé reçoit aussi 1 mois offert',
            referral_benefit3: 'Pas de limite au nombre de parrainages',
            referral_cta: 'Contactez-nous pour parrainer',
            // Navigation
            nav_migration_kit: 'Migration',
            nav_referral: 'Parrainage',
            nav_switch: 'Changer',
            // Switch from Doinsport page
            switch_badge: 'Vous utilisez Doinsport ?',
            switch_hero_title: 'Votre club mérite mieux que des tarifs opaques et des fonctionnalités verrouillées',
            switch_hero_subtitle: 'Comparez MySportSet point par point — tarifs transparents, réservation WhatsApp par IA, et un essai gratuit à démarrer aujourd\'hui.',
            switch_cta_calculator: 'Calculer mon ROI',
            switch_cta_signup: 'Essai gratuit',
            // Pain points
            switch_pain_title: 'Pourquoi les clubs changent',
            switch_pain_subtitle: 'Les mêmes frustrations reviennent chez les clubs qui quittent Doinsport.',
            switch_pain_opaque_title: 'Tarifs opaques',
            switch_pain_opaque_body: 'Les fonctionnalités avancées sont "sur devis" — vous ne connaissez le coût réel qu\'en appel commercial. Nous publions nos prix.',
            switch_pain_locked_title: 'Fonctionnalités payantes',
            switch_pain_locked_body: 'Le contrôle d\'accès aux terrains, l\'éclairage automatisé et les intégrations comptables coûtent en supplément. Vous le découvrez après vous être engagé.',
            switch_pain_demo_title: 'Produit verrouillé par la vente',
            switch_pain_demo_body: 'Pas d\'essai gratuit, pas de visite du produit, aucun moyen d\'évaluer le logiciel avant de s\'engager. Nous vous laissons tout essayer d\'abord.',
            switch_pain_no_data_title: 'Aucune preuve que ça marche',
            switch_pain_no_data_body: 'Des affirmations de "+25% de nouveaux membres" sans méthodologie, sans études de cas, sans chiffres vérifiables. Nous montrons nos calculs.',
            // Comparison table
            switch_compare_title: 'Comparaison fonctionnalité par fonctionnalité',
            switch_compare_subtitle: 'Une comparaison honnête basée sur les informations publiquement disponibles. Mis à jour mars 2026.',
            switch_table_feature: 'Fonctionnalité',
            switch_feat_transparent_pricing: 'Tarifs transparents',
            switch_feat_transparent_pricing_ds_note: 'Sur devis',
            switch_feat_free_trial: 'Essai gratuit',
            switch_feat_whatsapp_ai: 'Assistant WhatsApp IA',
            switch_feat_whatsapp_ai_mss_note: 'Propulsé par IA',
            switch_feat_white_label_app: 'Application mobile en marque blanche',
            switch_feat_online_booking: 'Réservation et planning en ligne',
            switch_feat_prepayment: 'Prépaiement obligatoire',
            switch_feat_multi_location: 'Support multi-sites',
            switch_feat_roi_calculator: 'Calculateur ROI',
            switch_feat_wallet_credits: 'Portefeuille / crédits',
            switch_feat_wallet_credits_ds_note: 'Limité',
            switch_feat_court_access: 'Contrôle d\'accès / éclairage auto',
            switch_feat_court_access_mss_note: 'Bientôt disponible',
            switch_feat_coach_module: 'Module coach / académie',
            switch_feat_events_tournaments: 'Événements & tournois',
            switch_feat_membership_mgmt: 'Gestion des adhésions',
            switch_feat_africa_support: 'Afrique & marchés émergents',
            switch_feat_africa_support_mss_note: 'FR + AR + paiements locaux',
            switch_compare_disclaimer: 'Comparaison basée sur les informations publiquement disponibles sur doinsport.com en mars 2026. Si quelque chose est inexact, prévenez-nous et nous le mettrons à jour.',
            // Differentiators
            switch_diff_title: 'Ce que MySportSet offre et que Doinsport n\'a pas',
            switch_diff_ai_title: 'Assistant WhatsApp IA',
            switch_diff_ai_body: 'Vos joueurs réservent, vérifient les disponibilités et gèrent leurs réservations via WhatsApp — propulsé par l\'IA. Aucune autre plateforme de réservation n\'a cette fonctionnalité.',
            switch_diff_pricing_title: 'Tarifs publiés et transparents',
            switch_diff_pricing_body: 'Pas de "contactez-nous pour un devis." Vous voyez exactement ce que vous payez, ce qui est inclus, et ce qui ne l\'est pas. Pas de surprises après l\'intégration.',
            switch_diff_trial_title: 'Essayez avant d\'acheter',
            switch_diff_trial_body: 'Inscrivez-vous, configurez vos terrains et testez chaque fonctionnalité avec de vrais joueurs. Pas de mur de démo, pas d\'appel commercial requis.',
            switch_diff_whatsapp_title: 'WhatsApp comme canal de vente',
            switch_diff_whatsapp_body: 'Parlez à un humain, pas à un chatbot. Notre équipe est disponible sur WhatsApp pour vos questions, l\'intégration et le support.',
            // Testimonial
            switch_testimonial_quote: 'On utilisait une autre plateforme avant. La migration a pris 2 jours, et nos joueurs n\'ont même pas remarqué le changement — sauf que tout fonctionne mieux maintenant.',
            switch_testimonial_name: 'Gérant de club',
            switch_testimonial_role: 'Client MySportSet',
            // Migration
            switch_migration_title: 'Changer est sans douleur',
            switch_migration_subtitle: 'Nous gérons l\'import de vos données, les invitations joueurs, et vous accompagnons les 30 premiers jours. Vos joueurs ne verront aucune interruption.',
            // Risk reversal
            switch_risk_title: 'Pas d\'engagement. Pas de verrouillage.',
            switch_risk_body: 'Commencez par un essai gratuit. Annulez à tout moment. Nous vous aiderons même à exporter vos données si vous décidez de partir. Voilà notre niveau de confiance.',
            // Final CTA
            switch_final_cta: 'Prêt à changer ?',
            switch_final_cta_sub: 'Rejoignez les clubs en France et en Afrique du Nord qui ont choisi MySportSet et n\'ont jamais regretté.',
        },
        help_center: {
            title: 'Centre d\'aide',
            new_article: 'Nouvel article',
            new_category: 'Nouvelle catégorie',
            manage_categories: 'Gérer les catégories',
            back_to_articles: 'Retour aux articles',
            article_title: 'Titre',
            article_slug: 'Slug',
            article_content_key: 'Clé de contenu',
            article_excerpt: 'Extrait',
            article_category: 'Catégorie',
            article_language: 'Langue',
            article_status: 'Statut',
            article_cover: 'Image de couverture',
            save_draft: 'Enregistrer le brouillon',
            publish: 'Publier',
            save: 'Enregistrer',
            published: 'Publié',
            draft: 'Brouillon',
            delete_confirm: 'Supprimer cet article ?',
            category_name_en: 'Nom (Anglais)',
            category_name_fr: 'Nom (Français)',
            category_slug: 'Slug',
            category_delete_blocked: 'Impossible de supprimer une catégorie avec des articles',
            article_created: 'Article créé',
            article_updated: 'Article mis à jour',
            article_deleted: 'Article supprimé',
            category_created: 'Catégorie créée',
            category_updated: 'Catégorie mise à jour',
            category_deleted: 'Catégorie supprimée',
        },
        court_pulse: {
            venue_pulse: 'Pouls du club',
            occupied: 'occupé',
            today: "Aujourd'hui",
            compact_view: 'Vue compacte',
            comfortable_view: 'Vue confortable',
            show_chart: 'Afficher le graphique',
            view_as_table: 'Voir en tableau',
            chart_data_table: 'Données du graphique',
        },
        venue_display: {
            showcase: {
                title: 'Affichage Club — exploration de design',
                intro: "Concept d'un affichage projecteur plein écran à l'entrée du club. Accueille les joueurs à leur arrivée avec le planning des terrains, les matchs en cours et ce qui démarre ensuite.",
                intro_warning: "Toutes les variantes sont des maquettes HTML statiques — elles lisent des données simulées et ne sont pas encore connectées à l'API.",
                how_to_use_title: 'Comment utiliser',
                how_to_use_p1: "Cliquez sur Lancer plein écran sur n'importe quelle variante pour l'ouvrir dans un nouvel onglet en 1920×1080. Depuis le plein écran, la pastille flottante Thème (en bas à droite) permet de basculer entre les 7 thèmes MySportSet (Classic, Prism, Night Court, Terra, Clubhouse, Volt, Ocean) et un sélecteur d'accent personnalisé. La direction actuelle est l'itération 3.",
                how_to_use_rotation: "Moteur de rotation : la variante Calme simule un club de 12 terrains paginé 6+6 toutes les 8 secondes, avec le terrain 3 épinglé car il démarre dans moins de 15 min. Spec complète dans docs/designs/venue-display-rotation.md.",
                date_count_one: '{date} · {count} variante',
                date_count_other: '{date} · {count} variantes',
                rotation_demo_label: 'Démo rotation',
                launch_live: 'Lancer avec données réelles',
                launch_fullscreen: 'Lancer plein écran',
                launch_mock: 'Maquette plein écran',
                tag_resolution: '1920×1080',
                tag_rotation: '↻ moteur de rotation',
                tag_live: '⚡ données réelles',
            },
            status: {
                current: 'Direction actuelle',
                superseded: 'Remplacé',
                rejected: 'Rejeté',
            },
            iteration: {
                v1_label: 'Itération 1 — premier essai',
                v1_note: "Quatre déclinaisons de tableau de bord sombre avec différentes typos. Trop convergent, remplacé.",
                v2_label: 'Itération 2 — différents paris produit',
                v2_note: "Chaque variante optimisée pour un usage différent de l'écran. Diversité structurelle, pas seulement stylistique.",
                v3_label: 'Itération 3 — verre calme (direction actuelle)',
                v3_note: "Flou d'arrière-plan marqué, généreux espace blanc, corps de texte ≥ 28pt, infos par carte réduites à 3-4 éléments. Thèmes par tenant via le panneau flottant dans chaque variante.",
            },
            variant: {
                v3_calm: {
                    name: 'Calme',
                    pitch: 'Pile verticale en verre',
                    optimizes_for: "Lisibilité à distance dans le hall. Six lignes en verre pleine largeur, un match par ligne. Trois éléments par ligne, pas de quatrième.",
                    rotation_note: "12 terrains, paginés 6+6 avec fondu enchaîné toutes les 8s (cadence démo). Terrain 3 épinglé car il démarre dans moins de 15 min — voir l'étiquette « Démarre bientôt ».",
                },
                v3_breathing: {
                    name: 'Respirante',
                    pitch: 'Grille en verre généreuse',
                    optimizes_for: "Grille 2×3, chaque carte 2× plus grande avec 3× plus d'espace blanc. Numéro de terrain en ancre à 184pt.",
                },
                v3_constellation: {
                    name: 'Constellation',
                    pitch: 'Hero + satellites · cinématique',
                    optimizes_for: "Spectateurs. Le match phare occupe la scène en 1340×720 avec un nom de joueur en 76pt ; cinq satellites en orbite. Le terrain en vedette tourne toutes les 30s.",
                },
                v2_poster: {
                    name: 'Affiche',
                    pitch: "L'atmosphère d'abord",
                    optimizes_for: "Visiteurs à l'arrivée. Hero d'entrée de cinéma, infos compressées dans un bandeau en bas.",
                },
                v2_floorplan: {
                    name: 'Plan du club',
                    pitch: "Orientation d'abord",
                    optimizes_for: "« Je joue sur le 3, où est le 3 ? » — plan vu du dessus avec les terrains dans leurs positions réelles.",
                },
                v2_arrival: {
                    name: "Tableau d'arrivée",
                    pitch: "Anticipation d'abord",
                    optimizes_for: "Joueurs à l'arrivée. Style tableau d'aéroport : compte à rebours en hero, planning chronologique en dessous.",
                },
                v2_spotlight: {
                    name: 'Projecteur',
                    pitch: "Diffusion d'abord",
                    optimizes_for: "Spectateurs. Un match en vedette occupe 70% de l'écran ; les autres en bande de tuiles fine. Rotation toutes les 15s.",
                },
                v1_atrium: {
                    name: 'Atrium',
                    pitch: 'Grille en verre sur photographie',
                    optimizes_for: "Image de marque clubs premium. Peu d'infos, arrière-plan atmosphérique, grille glassmorphique 2×3.",
                },
                v1_scoreboard: {
                    name: 'Tableau de scores',
                    pitch: 'Grille dense sur fond charbon',
                    optimizes_for: "Sites de tournois. Grille serrée de tuiles denses, badges de niveau, barres de progression.",
                },
                v1_horizon: {
                    name: 'Horizon',
                    pitch: 'Surface unique panoramique',
                    optimizes_for: "Minimal cinématique. Cinq lignes horizontales, dégradé doré, chiffres en 138pt.",
                },
                v1_kinetic: {
                    name: 'Stade Cinétique',
                    pitch: 'Grille cinétique athlétique',
                    optimizes_for: "Clubs jeunes et compétitifs. Chiffres Barlow Condensed, accents vert électrique, découpes angulaires. Rupture d'archétype performance.",
                },
            },
            live: {
                back: '← Retour au tableau de bord',
                loading: 'Chargement du planning…',
                no_location: 'Aucun emplacement sélectionné',
                error_title: 'Impossible de charger les terrains',
                error_sub: 'Reconnexion…',
                no_courts_title: 'Aucun terrain à cet emplacement',
                no_courts_sub: "Ajoutez des terrains depuis le tableau de bord pour voir l'état en direct",
                welcome_one: 'En direct · 1 terrain · bienvenue au club',
                welcome_other: 'En direct · {count} terrains · bienvenue au club',
                last_sync: 'Dernière synchro il y a {seconds}s',
                page_rotation: 'Rotation · {count} pages',
                single_page: 'Page unique',
                check_in: "Enregistrez-vous à l'accueil · bonne partie",
                starting_soon: 'Démarre bientôt',
                until: "jusqu'à {time}",
                starts_at: 'débute à {time}',
                back_at: 'retour à {time}',
                available: 'disponible',
                no_bookings: 'Pas encore de réservation',
                no_sessions: "Aucune session aujourd'hui",
                min_left: '{count} min restantes',
                in_min: 'Dans {count} min',
                sport_doubles: 'Doubles',
                sport_singles: 'Simples',
                sport_open: 'Libre',
                kind_class: 'Cours',
                kind_event: 'Événement',
                open_booking: 'Réservation libre',
                class_with_coach: 'Cours avec Coach {name}',
                idle: 'Inactif',
                blockade_maintenance: 'Entretien',
                blockade_reserved: 'Réservé',
                blockade_hold: 'En attente',
                blockade_other: 'Bloqué',
                reopens_at: 'rouvre à {time}',
                court_label: 'Terrain',
                unknown_player: 'Joueur',
            },
        },
    },
};
